<template>
	<div class="height-100dvh">
		<NcdTopContainer id="hideinlaptop" />
		<div
			class="mobiletabsdash-main-container"
			@click="mobCreateNewProfile = false"
		>
			<div
				class="mobcand-profiledashboard-maincontainer cand-profiledashboard-maincontainer d-flex flex-column tabsdash-with-sidebar"
				:class="{
					'card-blur':
						(mobCreateNewProfile ||
							showCreateNewMProfileModal ||
							showAllProfileModal) &&
						!isLaptop,
				}"
				style="gap: 10px"
			>
				<main
					class="max-1825 h-100 d-flex app-bottom-padding"
					:class="highlightSection && !okayToParse ? 'apply-blur' : ''"
				>
					<div
						class="candash-left-container pr-0"
						ref="mobscrollContainer"
						@scroll="mobilehandleScroll"
					>
						<div
							id="hideinlaptop"
							class="d-flex align-items-center justify-content-around mb-3 mt-1 alw-bluring"
						>
							<div
								class="sel-tabstxt mob d-flex align-items-center"
								:class="
									progress.createNewProfile ||
									(progress.profileCount > 1 &&
										localCandidateInfo.resume_clinic_analysis)
										? ''
										: 'opac-5'
								"
								@click="
									progress.createNewProfile ||
									(progress.profileCount > 1 &&
										localCandidateInfo.resume_clinic_analysis)
										? showModal()
										: (featureNotAvailable = 'Switch')
								"
							>
								<img
									src="../../../assets/newbuilder/blueSwitch.svg"
									class="mr-2"
									alt=""
								/>Switch Profile
							</div>
							<div class="candash-line mx-3"></div>
							<div
								class="sel-tabstxt mob d-flex align-items-center"
								@click="videoSnap(true)"
							>
								<img
									src="../../../assets/newbuilder/mob-video.svg"
									class="mr-2"
									alt=""
								/>Video Snapshot
							</div>
						</div>
						<div
							v-if="
								($route.query.uuid ||
								$route.query.fromWebsite ||
								$route.query.type == 'resumeClinic') && candidateInfo?.resume_clinic_analysis != null
							"
							id="hideinlaptop"
							class="mobresume-card mb-2 w-100 d-flex justify-content-between align-items-center"
						>
							<div class="position-relative">
								<img
									src="../../../assets/newdesign/resumeclinic/mob4meter.svg"
									alt=""
								/>
								<img
									src="../../../assets//newdesign/resumeclinic/mobcursor.svg"
									alt=""
									:class="getMeterClass"
									class="position-absolute"
								/>
							</div>
							<div class="w-50 text-center">
								<h6 class="fw-M fs-13 fam-lato text-white">
									Your Resume Score:
								</h6>
								<h5
									class="fs-16 fam-mont fw-B"
									:class="{
										'color-2AA869': overAllRating == 'Amazing',
										'color-F9C82B': overAllRating == 'Good',
										'color-e99e32': overAllRating == 'Okay',
										'color-d7342c': overAllRating == 'Fair',
									}"
								>
									{{ overAllRating }}
								</h5>
							</div>
							<div
								class="mobreviewbtn text-blue fs-13 fw-M fam-lato"
								@click="showresumeclinic = true"
							>
								Review
							</div>
						</div>
						<div v-if="showloader">
							<div class="candash-top-header position-relative">
								<div class="candash-profile-pic avatar-class">
									<b-skeleton type="avatar"></b-skeleton>
								</div>
								<div>
									<div>
										<b-skeleton class="ml-3 mt-2 w-25 h-10"></b-skeleton>
									</div>
									<div>
										<b-skeleton class="ml-3 mt-2 w-50 h-10"></b-skeleton>
									</div>
								</div>
							</div>
							<div class="candash-below-header-2">
								<div class="p175 ml-4">
									<b-skeleton class="mt-2 w-75 h-10"></b-skeleton>
								</div>

								<div>
									<b-skeleton class="ml-2 mt-4 w-15 h-10"></b-skeleton>
								</div>
								<div>
									<b-skeleton-img
										no-aspect
										height="60px "
										width="90%"
										class="ml-2 mt-2"
										style="bottom: 3px; border-radius: 5px"
									></b-skeleton-img>
								</div>
							</div>
						</div>
						<div
							v-if="!showloader && showDashboard"
							id="maindash"
							ref="maindash"
							class="mob-z-ind alw-bluring"
						>
							<div
								style="height: auto"
								class="candash-top-header position-relative d-flex align-items-start justify-content-between"
							>
								<div class="candash-profile-pic">
									<img
										class="candash-uploaded"
										:src="localCandidateInfo.image"
										alt=""
									/>
								</div>
								<div class="donut-progress">
									<DonutProgress
										:totalProgress="100"
										:progressCount="progress.progress"
									/>
									<div v-if="localCandidateInfo.primary" class="profile-star">
										<img src="../../../assets/img/homepage/profile-star.svg" />
									</div>
									<div class="prog-badge">{{ progress.progress }}%</div>
								</div>

								<div
									class="word-break"
									:class="isLaptop ? 'w-75' : 'w-65'"
									id="topmobileheader"
								>
									<div class="candash-boldWhite" id="cand-name">
										{{ localCandidateInfo.firstName }}

										{{ localCandidateInfo.lastName }}
									</div>
									<div
										v-if="
											localCandidateInfo.experienceLevel == 'fresher' ||
											localCandidateInfo.experienceLevel == 'student' ||
											localCandidateInfo.experienceLevel == 'intermediate' ||
											localCandidateInfo.experienceLevel == 'senior'
										"
										class="candash-normaltxt"
									>
										<span
											v-if="
												localCandidateInfo.designation != null &&
												localCandidateInfo.designation != '' &&
												localCandidateInfo.totalYearsOfExp
											"
										>
											{{ localCandidateInfo.designation }} |
											{{ localCandidateInfo.totalYearsOfExp }}
											{{
												localCandidateInfo.totalYearsOfExp > 1
													? "Years"
													: "Year"
											}}
										</span>
										<span
											v-else-if="
												localCandidateInfo.designation != null &&
												localCandidateInfo.designation != '' &&
												!localCandidateInfo.totalYearsOfExp
											"
										>
											{{ localCandidateInfo.designation }} |
											{{
												capitalizeFirstLetter(
													localCandidateInfo.experienceLevelFormatted
												)
											}}</span
										>
										<span v-else-if="localCandidateInfo.totalYearsOfExp">
											{{
												capitalizeFirstLetter(
													localCandidateInfo.experienceLevelFormatted
												)
											}}
											| {{ localCandidateInfo.totalYearsOfExp }}
											{{
												localCandidateInfo.totalYearsOfExp > 1
													? "Years"
													: "Year"
											}}</span
										>
										<span v-else>
											{{
												capitalizeFirstLetter(
													localCandidateInfo.experienceLevelFormatted
												)
											}}</span
										>
									</div>

									<!-- <div
										v-else-if="
											localCandidateInfo.experienceLevel == 'intermediate' ||
											localCandidateInfo.experienceLevel == 'senior'
										"
										class="candash-normaltxt"
									>
										<span
											v-if="
												localCandidateInfo.designation != null &&
												localCandidateInfo.designation != '' &&
												localCandidateInfo.totalYearsOfExp
											"
										>
											{{ localCandidateInfo.designation }} |
											{{ localCandidateInfo.totalYearsOfExp }}
											{{
												localCandidateInfo.totalYearsOfExp > 1
													? "Years"
													: "Year"
											}}
										</span>
										
										<span
											v-else-if="localCandidateInfo.totalYearsOfExp"
										>
											{{
												capitalizeFirstLetter(
													localCandidateInfo.experienceLevelFormatted
												)
											}}
											| {{ localCandidateInfo.totalYearsOfExp }}
											{{
												localCandidateInfo.totalYearsOfExp > 1
													? "Years"
													: "Year"
											}}</span
										>
										<span v-else>
											{{
												capitalizeFirstLetter(
													localCandidateInfo.experienceLevelFormatted
												)
											}}</span
										>
									</div> -->
								</div>
								<!-- {{ !isNotProfileFilled}} -->
								<div class="d-flex builder-mobile-icons gap-2">
									<article
										@click="videoSnap()"
										class="dash-buttons"
										:class="
											localCandidateInfo.videoResume
												? 'video-snap-1'
												: 'video-snap-2'
										"
									>
										<span>
											{{
												localCandidateInfo.videoResume
													? "View video snapshot"
													: "Create video snapshot"
											}}</span
										>
										<img
											src="../../../assets/newdesign/dashboard/new-videosnap.svg"
											alt=""
										/>
									</article>
									<article
										v-if="
											progress.createNewProfile ||
											(progress.profileCount > 1 &&
												localCandidateInfo.resume_clinic_analysis)
										"
										@click="openProfileModal()"
										class="dash-buttons switch-profile"
									>
										<span>Switch profiles</span>
										<div class="position-relative">
											<div
												v-if="toggleNotification"
												style="right: 3px; top: 3px"
												class="laptop-filter-dot"
											></div>
											<img
												src="../../../assets/newdesign/dashboard/Profiles.svg"
												alt=""
											/>
										</div>
									</article>

									<div
										v-if="localCandidateInfo.link != null"
										class="position-relative"
									>
										<article class="dash-buttons share-profile" ref="qrbutton">
											<span
												@click="
													!isProgressSufficient ||
													!localCandidateInfo.profileName ||
													!progress.createNewProfile ||
													!localCandidateInfo.database_demographics
														? (featureNotAvailable = 'Share')
														: openShare()
												"
												>Share profile</span
											>
											<img
												v-if="
													localCandidateInfo.link != null &&
													(showtstdiv || shareClick)
												"
												@click="closeShare()"
												src="../../../assets/newdesign/dashboard/shareLinkBlue.svg"
												alt=""
											/>
											<img
												v-if="
													localCandidateInfo.link != null &&
													!showtstdiv &&
													!shareClick
												"
												@click="
													!isProgressSufficient ||
													!localCandidateInfo.profileName ||
													!progress.createNewProfile ||
													!localCandidateInfo.database_demographics
														? (featureNotAvailable = 'Share')
														: openShare()
												"
												src="../../../assets/newdesign/dashboard/shareLinkWhite.svg"
												alt=""
											/>
										</article>
										<div
											v-if="shareClick && isLaptop"
											ref="expdropdown"
											v-closable="{
												exclude: [
													'expdropdown',
													'qrbutton',
													'mobButton',
													'myexpdropdown',
												],
												handler: 'closeShare',
											}"
										>
											<ShareProfile
												v-if="shareClick && isLaptop"
												:showtstdiv="showtstdiv"
												:shareClick="shareClick"
												:isPrimary="isPrimary"
												:candidateInfo="localCandidateInfo"
												@close="shareClick = true"
											/>
										</div>
									</div>
									<article
										class="dash-buttons edit-profile"
										v-show="!isNotProfileFilled || $route.params.uuid !== null"
										@click="openPersonalDetailsModal('edit')"
									>
										<span>Edit profile</span>
										<img
											src="../../../assets/newdesign/dashboard/editProfile.svg"
											alt=""
										/>
									</article>
								</div>
							</div>
							<!-- :class="
							showAboutMe ||
							(localCandidateInfo.designation !== null &&
								localCandidateInfo.designation !== '')
								? 'candash-padding-11'
								: 'candash-padding-12'
						" -->
							<div class="candash-below-header-2 candash-padding-11">
								<div class="p175 p-none mob-position-realtive">
									<div class="d-flex builder-mob-basicdetails mb-2 mobmb-0">
										<div
											class="candash-blackTxt"
											v-if="displayDateOfBirth(localCandidateInfo.dateOfBirth)"
										>
											<img
												class="mob-m0"
												style="margin-top: -7px"
												src="@/assets/newdesign/dashboard/dateOfBirth.svg"
												alt="dob"
											/>
											{{ displayDateOfBirth(localCandidateInfo.dateOfBirth) }}
										</div>
										<div
											v-if="localCandidateInfo.displayEmail"
											class="candash-blackTxt mobml-0 word-break"
										>
											<img
												class="mob-m0"
												style="margin-right: 4px; margin-top: -2px"
												src="../../../assets/newdesign/dashboard/blueMail.svg"
												alt=""
											/>{{ localCandidateInfo.displayEmail.toLowerCase() }}
										</div>
										<div
											class="candash-blackTxt mobml-0"
											v-if="
												localCandidateInfo.phoneNumber !== '' ||
												localCandidateInfo.phoneNumber !== null
											"
										>
											<img
												class="mob-m0"
												style="margin-top: -2px"
												src="../../../assets/newdesign/dashboard/blueCall.svg"
												alt=""
											/>
											<span class="mob-phone-no">
												{{ localCandidateInfo.phoneNumber }}
											</span>
											<span v-if="localCandidateInfo.altPhoneNumber">
												, {{ localCandidateInfo.altPhoneNumber }}
											</span>
										</div>
										<div
											class="candash-blackTxt mobml-0"
											v-if="
												localCandidateInfo.city !== '' &&
												localCandidateInfo.city !== null
											"
										>
											<img
												class="mob-m0"
												style="margin-top: -5px"
												src="../../../assets/newdesign/dashboard/blueLocation.svg"
												alt=""
											/>
											{{ localCandidateInfo.city }}
										</div>
									</div>
									<!-- images are there in newbuilder folder under assets -->
									<div
										class="d-flex align-items-center flex-wrap gap-2"
										v-if="
											this.localCandidateInfo.portfolio &&
											this.localCandidateInfo.portfolio.length > 0
										"
									>
										<div class="d-flex align-items-center flex-wrap gap-2">
											<div
												class="portfolio-mob-box mt-2 pointer"
												v-for="(portfolio, index) in displayPortfolio"
												:key="index + 'portf'"
												@click="redirectToTheLink(portfolio.portfolioLink)"
											>
												<img
													:src="bindPortfolioSrc(portfolio)"
													class="mr-2"
													alt=""
												/>
												{{ formatPortfolioLink(portfolio.portfolioLink) }}
											</div>

											<span
												v-if="hasMorePortfolio && !showAllPortfolios"
												@click="togglePortfolioView"
												class="pointer showmre-lesstxt text-dec-under mt-11px"
											>
												+{{ remainingPortfolioCount }} more
											</span>

											<span
												v-if="showAllPortfolios"
												@click="togglePortfolioView"
												class="pointer showmre-lesstxt mt-11px"
											>
												Show less
											</span>
										</div>
									</div>
								</div>

								<b-collapse
									:class="
										localCandidateInfo.designation != null ||
										localCandidateInfo.designation != ''
											? 'mt-14 '
											: 'mt-5'
									"
									v-model="showAboutMe"
									id="showAboutMe"
								>
									<div
										class="candash-bold-black-txt-2"
										v-if="localCandidateInfo.profileSummary"
									>
										About Me
									</div>
									<div
										class="candash-descrpth text-break"
										v-if="localCandidateInfo.profileSummary"
									>
										<div class="builder-lapshowmore">
											{{ truncatedProfileSummary }}
											<span
												v-if="
													localCandidateInfo.profileSummary &&
													localCandidateInfo.profileSummary.length > 256 &&
													!showFullContentCand
												"
												class="pro-theme font-w-600 pointer builder-lapshowmore"
												@click="ProfileAboutToggle()"
											>
												<span class="candash-descrpth">...</span>
												<span>show more</span>
											</span>
											<span
												class="pro-theme font-w-600 pointer"
												v-if="showFullContentCand"
												@click="ProfileAboutToggle()"
												>show less</span
											>
										</div>
										<div class="builder-mobshowmore">
											{{ truncatedMobProfileSummary }}
											<span
												v-if="
													localCandidateInfo.profileSummary &&
													localCandidateInfo.profileSummary.length > 100 &&
													!showFullContentCand
												"
												class="pro-theme font-w-600 pointer builder-mobshowmore"
												@click="ProfileAboutToggle()"
											>
												<span class="candash-descrpth">...</span>
												<span>show more</span>
											</span>
											<span
												class="pro-theme font-w-600 pointer"
												v-if="showFullContentCand"
												@click="ProfileAboutToggle()"
												>show less</span
											>
										</div>
									</div>
								</b-collapse>
								<div id="hideinlaptop" class="d-flex gap-3 mt-3">
									<div class="mob-addBtn position-relative w-50">
										<b-button class="w-100" @click="goToPersonalDetails()"
											><img
												src="@/assets/newbuilder/ddedit-1.svg"
												class="mr-1"
												alt=""
											/>Edit</b-button
										>
									</div>
									<div class="position-relative w-50" ref="mobButton">
										<div class="mob-cancelBtn w-100">
											<b-button
												class="w-100"
												:class="
													!isProgressSufficient ||
													!localCandidateInfo.profileName ||
													!progress.createNewProfile ||
													!localCandidateInfo.database_demographics
														? 'opac-5'
														: ''
												"
												@click="
													!isProgressSufficient ||
													!localCandidateInfo.profileName ||
													!progress.createNewProfile ||
													!localCandidateInfo.database_demographics
														? loadingData
															? ''
															: (featureNotAvailable = 'Share')
														: openShare()
												"
												><img
													src="@/assets/newbuilder/share.svg"
													class="mr-2"
													alt=""
												/>Share</b-button
											>
										</div>
										<div
											v-if="shareClick"
											ref="expdropdown"
											v-closable="{
												exclude: [
													'expdropdown',
													'qrbutton',
													'mobButton',
													'myexpdropdown',
												],
												handler: 'closeShare',
											}"
										>
											<ShareProfile
												v-if="shareClick && !isLaptop"
												:showtstdiv="showtstdiv"
												:shareClick="shareClick"
												:isPrimary="isPrimary"
												:candidateInfo="localCandidateInfo"
												@close="shareClick = true"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							id="resume-graph"
							:class="isLaptop ? 'candash-tabs-container' : ''"
						>
							<div
								v-if="showTaskBarShimmer && isLaptop"
								class="d-flex align-items-start justify-content-center position-relative z-ind-1 mt-1 p-left-20 h-60"
							>
								<div
									class="d-flex align-items-center position-relative"
									:style="index <= 6 ? 'width:12.5%' : ''"
									v-for="(i, index) in loopvar"
									:key="index + 'shimmer'"
								>
									<div class="">
										<b-skeleton type="avatar"></b-skeleton>
									</div>
									<div
										v-if="index != loopvar - 1"
										class="shimmer-candash-tabs-line"
									></div>
								</div>
							</div>
							<!-- Checking for the dynamic Data -->

							<div
								v-else-if="showTaskBar && !showTaskBarShimmer"
								class="d-flex align-items-start justify-content-center position-relative z-ind-1 w-100 mt-1 p-left-20 h-60 hidetabs-mob alw-bluring"
							>
								<div
									class="d-flex align-items-center position-relative"
									:class="index < passDynamicScale.length - 1 ? 'width-35' : ''"
									v-for="(headVal, index) in passDynamicScale"
									:key="'dynamic' + index"
								>
									<div class="position-relative">
										<div
											@click="setTab(headVal.formID, index)"
											class="d-flex align-items-center justify-content-center pointer position-relative z-ind-2"
											:class="
												selectedTab == headVal.formID
													? 'candash-enableTab'
													: 'candash-disTab'
											"
										>
											<img
												v-if="
													isTabEmpty(headVal.formID) &&
													selectedTab != headVal.formID
												"
												src="../../../assets/newdesign/dashboard/completedTab.svg"
												alt=""
											/>

											<div
												v-else
												:class="{
													enableDot: selectedTab === headVal.formID,
													disDot: selectedTab !== headVal.formID,
												}"
											></div>
										</div>
										<div
											class="position-absolute mt-1"
											:class="[
												selectedTab == headVal.formID
													? 'sel-tabstxt'
													: 'tabstxt',
												{
													'left-14': headVal.formName === 'Experience',
												},
												{
													'left-8': headVal.formName === 'Portfolio Links',
												},
												{
													'left-23': headVal.formName === 'Demographics',
												},
												{
													'left-2': headVal.formName === 'Skills',
												},
												{
													'left-7': headVal.formName === 'Projects',
												},
												{
													'left-20': headVal.formName === 'Achievement',
												},
												{
													'left-12': headVal.formName === 'Education',
												},
												{
													'left-6': headVal.formName === 'Resume',
												},
												{
													'left-14 text-nowrap':
														headVal.formName === 'Personal Details',
												},
											]"
										>
											{{
												headVal.formID == "portfolio"
													? "Portfolio"
													: headVal.formID == "project"
													? "Project"
													: headVal.formName
											}}
										</div>
									</div>
									<div
										v-if="index < passDynamicScale.length - 1"
										:class="
											isTabEmpty(passDynamicScale[index + 1].formID)
												? 'candash-tabs-Blueline'
												: 'candash-tabs-line'
										"
									></div>
								</div>
							</div>

							<div
								:class="isLaptop ? 'candash-tabs-overflow' : ''"
								id="belowdash"
								ref="belowdash"
								:style="{ height: belowDashHeight }"
								@scroll="handleScroll"
							>
								<template v-if="showTaskBarShimmer">
									<div class="candash-tabs-newcard mt-2">
										<div>
											<div>
												<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
											</div>
											<div class="demograpgic-data"></div>
											<div
												class="candash-blue-details-box mt-2 p-2"
												v-for="(j, index) in demographicsLoop"
												:key="index + 'exp-shim'"
											>
												<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
												<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>

												<b-skeleton class="mt-2 w-75 h-15"></b-skeleton>
											</div>
										</div>
									</div>
									<div class="candash-tabs-newcard mt-2">
										<div>
											<div>
												<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
											</div>
											<div class="demograpgic-data"></div>
											<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>

											<div
												class="candash-blue-details-box mt-2 p-2"
												v-for="(j, index) in demographicsLoop"
												:key="index + 'skill-shim'"
											>
												<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
												<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
											</div>
											<div class="demograpgic-data"></div>
											<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>

											<div
												class="candash-blue-details-box mt-2 p-2"
												v-for="(j, index) in demographicsLoop"
												:key="index + 'int-shim'"
											>
												<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
												<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
											</div>
										</div>
									</div>

									<div class="candash-tabs-newcard mt-2">
										<div>
											<div>
												<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
											</div>
											<div class="demograpgic-data"></div>
											<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>

											<div
												class="candash-blue-details-box mt-2 p-2"
												v-for="(j, index) in demographicsLoop"
												:key="index + 'skill-shim'"
											>
												<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
												<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
											</div>
											<div class="demograpgic-data"></div>
											<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>

											<div
												class="candash-blue-details-box mt-2 p-2"
												v-for="(j, index) in demographicsLoop"
												:key="index + 'int-shim'"
											>
												<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
												<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
											</div>
										</div>
									</div>
									<div class="candash-tabs-newcard mt-2">
										<div>
											<div>
												<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
											</div>
											<div class="demograpgic-data"></div>
											<div class="candash-blue-details-box mt-2 p-2">
												<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
												<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
											</div>
										</div>
									</div>
									<div class="candash-tabs-newcard mt-2">
										<div>
											<div>
												<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
											</div>
											<div class="demograpgic-data"></div>
											<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>

											<div class="candash-blue-details-box mt-2 p-2">
												<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
												<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
											</div>
											<div class="demograpgic-data"></div>
											<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>

											<div class="candash-blue-details-box mt-2 p-2">
												<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
												<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
											</div>
										</div>
									</div>
								</template>
								<template v-else>
									<div
										v-for="form in passDynamicScale"
										:key="form.formID"
										:id="form.formID"
									>
										<div
											v-if="
												false && !showTaskBarShimmer && !showShimmerBasicModal
											"
											class="candash-tabs-newcard mt-2"
											ref="demographicSection"
										>
											<div
												class="d-flex align-items-center justify-content-between alw-bluring"
											>
												<div>
													<div class="candash-bold-black-txt-2 d-flex">
														Personal Details
													</div>
													<div v-if="!opendemographic" class="asp-subtxt mt-1">
														Add your personal details
													</div>
												</div>
												<div>
													<img
														@click="openPersonalDetailsModal('edit')"
														class="pointer blueShadow"
														src="../../../assets/newdesign/dashboard/editProfile.svg"
														alt=""
													/>
												</div>
											</div>

											<b-collapse v-model="opendemographic">
												<div
													class="demograpgic-data alw-bluring"
													:class="isLaptop ? 'mb-4 ' : 'mb-2'"
												></div>
												<div class="d-flex flex-wrap gap-4">
													<div class="candash-blue-details-box p-3 w-100">
														<div
															class="d-flex flex-wrap"
															style="gap: 20px 40px"
														>
															<div v-if="localCandidateInfo.designation">
																<div class="asp-subtxt mb-1">Designation</div>
																<div class="candash-blackTxt-2">
																	{{ localCandidateInfo.designation }}
																</div>
															</div>
															<div v-if="localCandidateInfo.dateOfBirth">
																<div class="asp-subtxt mb-1">Date of Birth</div>
																<div class="candash-blackTxt-2">
																	{{
																		displayDateOfBirth(
																			localCandidateInfo.dateOfBirth
																		)
																	}}
																</div>
															</div>
															<div v-if="localCandidateInfo.gender">
																<div class="asp-subtxt mb-1">Gender</div>
																<div class="candash-blackTxt-2 text-capitalize">
																	{{ localCandidateInfo.gender }}
																</div>
															</div>
															<div v-if="localCandidateInfo.email">
																<div class="asp-subtxt mb-1">Email</div>
																<div class="candash-blackTxt-2">
																	{{ localCandidateInfo.email }}
																</div>
															</div>
															<div v-if="localCandidateInfo.phoneNumber">
																<div class="asp-subtxt mb-1">Phone Number</div>
																<div class="candash-blackTxt-2">
																	{{ localCandidateInfo.phoneNumber }}
																</div>
															</div>
															<div v-if="localCandidateInfo.city">
																<div class="asp-subtxt mb-1">Location</div>
																<div class="candash-blackTxt-2">
																	{{ localCandidateInfo.city }}
																</div>
															</div>
															<div v-if="localCandidateInfo.maritalStatus">
																<div class="asp-subtxt mb-1">
																	Marital Status
																</div>
																<div class="candash-blackTxt-2 text-capitalize">
																	{{ localCandidateInfo.maritalStatus }}
																</div>
															</div>
															<div v-if="localCandidateInfo.nationality">
																<div class="asp-subtxt mb-1">Nationality</div>
																<div class="candash-blackTxt-2 text-capitalize">
																	{{ localCandidateInfo.nationality }}
																</div>
															</div>
														</div>
													</div>
												</div>
											</b-collapse>
										</div>
										<div
											v-if="
												form.formID == 'education' &&
												!showTaskBarShimmer &&
												!showShimmerEduModal
											"
											class="candash-tabs-newcard mt-2"
											ref="educationSection"
										>
											<div
												class="d-flex align-items-center justify-content-between alw-bluring"
											>
												<div>
													<div class="candash-bold-black-txt-2 d-flex">
														Education
													</div>
													<div v-if="!openeducation" class="asp-subtxt mt-1">
														Add your education details
													</div>
												</div>
												<div>
													<img
														@click="openFormModal(form)"
														class="pointer blueShadow"
														src="../../../assets/newdesign/dashboard/roundPlus.svg"
														alt=""
														@click.stop
													/>
												</div>
											</div>

											<b-collapse v-model="openeducation">
												<div
													class="demograpgic-data alw-bluring"
													:class="isLaptop ? 'mb-4 ' : 'mb-2'"
												></div>
												<div
													v-for="(education, index) in nonParserEducations"
													:key="index + 'edu'"
													class="mt-2 alw-bluring"
												>
													<EducationCard
														:isLaptop="isLaptop"
														:education="education"
														:formConfiguration="checkDynamicField"
														:form="form"
														:selectedCard="selectedCard"
														@select-card="(e) => (selectedCard = e)"
														@edit-form="openEditForm"
														@delete-data="assignDeleteData"
													/>
												</div>
												<!-- Imported From Resume -->
												<div
													v-if="
														ifParserDataPresent(
															localCandidateInfo.educationalInfo
														)
													"
													ref="education"
												>
													<div
														class="rec-title-2 alw-bluring"
														:class="isLaptop ? ' mt-4' : ''"
													>
														Review Data (Imported from your resume)
													</div>
													<div class="mob-parsetxt greytxt mt-1 alw-bluring">
														The data needs to be verified and added or missing
														data needs to be added
													</div>
													<div
														v-for="(education, index) in parserEducations"
														:key="index + 'eduParser'"
														class="position-relative"
														:class="
															highlightSection != 'education' ||
															(!okayToParse && index != 0)
																? 'alw-bluring'
																: ''
														"
													>
														<EducationCard
															:isLaptop="isLaptop"
															:education="education"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@edit-form="openEditForm"
															@select-card="(e) => (selectedCard = e)"
															@delete-data="assignDeleteData"
														/>
														<ParserCheckModal
															v-if="
																highlightSection === 'education' &&
																index === 0 &&
																!okayToParse
															"
															@submit="submitResumeVerification"
														/>
													</div>
												</div>
												<div
													v-if="localCandidateInfo.educationalInfo.length > 2"
													class="text-center mob-viewall mb-blue-txt-2 mt-3 mb-1 alw-bluring"
													@click="openFormModal(form, true)"
												>
													View All
												</div>
											</b-collapse>
										</div>

										<div
											v-if="
												form.formID == 'experience' &&
												!showTaskBarShimmer &&
												!showShimmerExpModal
											"
											class="candash-tabs-newcard mt-2"
											ref="experinceSection"
										>
											<div
												class="d-flex align-items-center justify-content-between alw-bluring"
											>
												<div>
													<div class="candash-bold-black-txt-2 d-flex">
														Experience
													</div>
													<div v-if="!openexperience" class="asp-subtxt mt-1">
														Add your experience details
													</div>
												</div>
												<div>
													<img
														@click="openFormModal(form)"
														src="../../../assets/newdesign/dashboard/roundPlus.svg"
														alt=""
														class="pointer blueShadow"
														@click.stop
													/>
												</div>
											</div>

											<b-collapse v-model="openexperience">
												<div
													class="demograpgic-data alw-bluring"
													:class="isLaptop ? 'mb-4 ' : 'mb-2'"
												></div>

												<div
													v-for="(experience, index) in nonParserExperiences"
													:key="index + 'exp'"
													class="mt-2 alw-bluring"
													v-show="!experience.parser"
												>
													<ExperienceCard
														:form="form"
														:isLaptop="isLaptop"
														:experience="experience"
														:selectedCard="selectedCard"
														:formConfiguration="checkDynamicField"
														:localCandidateInfo="localCandidateInfo"
														@edit-form="openEditForm"
														@select-card="(e) => (selectedCard = e)"
														@delete-data="assignDeleteData"
													/>
												</div>
												<!-- For the parser Data -->
												<div
													v-if="
														ifParserDataPresent(localCandidateInfo.experience)
													"
													ref="experience"
												>
													<div
														class="rec-title-2 alw-bluring"
														:class="isLaptop ? ' mt-4' : ''"
													>
														Review Data (Imported from your resume)
													</div>
													<div class="mob-parsetxt greytxt mt-1 alw-bluring">
														The data needs to be verified and added or missing
														data needs to be added
													</div>

													<div
														v-for="(experience, index) in parserExperiences"
														:key="index + 'expParser'"
														class="position-relative"
														v-show="experience.parser"
														:class="
															highlightSection != 'experience' ||
															(!okayToParse && index != 0)
																? 'alw-bluring'
																: ''
														"
													>
														<ExperienceCard
															:form="form"
															:isLaptop="isLaptop"
															:experience="experience"
															:selectedCard="selectedCard"
															:formConfiguration="checkDynamicField"
															:localCandidateInfo="localCandidateInfo"
															@edit-form="openEditForm"
															@select-card="(e) => (selectedCard = e)"
															@delete-data="assignDeleteData"
														/>

														<ParserCheckModal
															v-if="
																highlightSection === 'experience' &&
																index === 0 &&
																!okayToParse
															"
															@submit="submitResumeVerification"
														/>
													</div>
												</div>
												<div
													v-if="localCandidateInfo.experience.length > 2"
													class="text-center alw-bluring mob-viewall mb-blue-txt-2 mt-3 mb-1"
													@click="openFormModal(form, true)"
												>
													View All
												</div>
											</b-collapse>
										</div>

										<div
											v-if="
												form.formID == 'skills' &&
												!showTaskBarShimmer &&
												!showShimmerSkillModal
											"
											class="candash-tabs-newcard mt-2"
											ref="skillSection"
										>
											<div
												class="d-flex align-items-center justify-content-between alw-bluring"
											>
												<div>
													<div class="candash-bold-black-txt-2 d-flex">
														Skills
														<!-- <span
													class="mobile-forms-required-box hideinlaptop ml-1"
												>
													<span class="text-darkgrey">Required</span>
													<span class="text-lightgrey"> (Min. 1)</span>
												</span> -->
													</div>
													<div v-if="!openskill" class="asp-subtxt mt-1">
														Add your skills details
													</div>
												</div>
												<div>
													<img
														@click="openSkillModal(form)"
														src="../../../assets/newdesign/dashboard/roundPlus.svg"
														alt=""
														class="blueShadow pointer"
														@click.stop
													/>
												</div>
											</div>

											<b-collapse v-model="openskill">
												<div
													v-if="
														isArrayNotEmpty(localCandidateInfo.skills) ||
														isArrayNotEmpty(
															localCandidateInfo.interpersonalSkills
														)
													"
													class="demograpgic-data alw-bluring"
													:class="isLaptop ? 'mb-4' : 'mb-2'"
												></div>
												<div
													v-if="
														ifOriginalDataPresent(localCandidateInfo.skills)
													"
													class="candash-blktxt-bold alw-bluring"
												>
													Technical Skills
												</div>

												<draggable
													tag="div"
													group="mySkillData"
													:list="localCandidateInfo.skills"
													class="pointer alw-bluring"
													@end="onDragEndSkill"
													handle=".drag-handle"
												>
													<div
														v-for="(techSkill, ind) in nonParserTechSkills"
														:key="ind + 'techSkill'"
													>
														<SkillCard
															:isLaptop="isLaptop"
															:skill="techSkill"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@open-form="openForm"
															@select-card="(e) => (selectedCard = e)"
															@edit-form="openEditForm"
															@delete-data="assignDeleteData"
														/>
													</div>
												</draggable>
												<div
													v-if="ifParserDataPresent(localCandidateInfo.skills)"
													ref="techskill"
												>
													<div
														class="rec-title-2 alw-bluring"
														:class="isLaptop ? ' mt-4' : ''"
													>
														Review Data (Imported from your resume)
													</div>
													<div class="mob-parsetxt greytxt mt-1 alw-bluring">
														The data needs to be verified and added or missing
														data needs to be added
													</div>
													<div
														class="position-relative"
														v-for="(techSkillParser, ind) in parserTechSkills"
														:key="ind + 'techSkillParser'"
														:class="
															highlightSection != 'techskill' ||
															(!okayToParse && ind != 0)
																? 'alw-bluring'
																: ''
														"
													>
														<SkillCard
															:isLaptop="isLaptop"
															:skill="techSkillParser"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@open-form="openForm"
															@select-card="(e) => (selectedCard = e)"
															@edit-form="openEditForm"
															@delete-data="assignDeleteData"
														/>

														<ParserCheckModal
															v-if="
																highlightSection === 'techskill' &&
																ind === 0 &&
																!okayToParse
															"
															@submit="submitResumeVerification"
														/>
													</div>
												</div>
												<div
													v-if="
														localCandidateInfo.interpersonalSkills &&
														localCandidateInfo.interpersonalSkills.length > 0
													"
													class="candash-blktxt-bold alw-bluring"
													:class="
														!isArrayNotEmpty(localCandidateInfo.skills)
															? 'mt-3'
															: 'mt-4'
													"
													ref="interskill"
												>
													Interpersonal Skills
												</div>

												<draggable
													tag="div"
													group="myInterskillData"
													:list="localCandidateInfo.interpersonalSkills"
													class="pointer alw-bluring"
													@end="onDragEndInterSkill"
													handle=".drag-handle"
												>
													<div
														v-for="(skill, index) in nonParserInterSkills"
														:key="index + 'skill'"
													>
														<SkillCard
															:isLaptop="isLaptop"
															:skill="skill"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@open-form="openForm"
															@select-card="(e) => (selectedCard = e)"
															@edit-form="openEditForm"
															@delete-data="assignDeleteData"
														/>
													</div>
												</draggable>

												<div
													v-if="
														ifParserDataPresent(
															localCandidateInfo.interpersonalSkills
														)
													"
												>
													<div
														class="position-relative"
														v-for="(interSkillParser, ind) in parserInterSkills"
														:key="ind + 'interSkillParser'"
														:class="
															highlightSection != 'interskill' ||
															(!okayToParse && ind != 0)
																? 'alw-bluring'
																: ''
														"
													>
														<SkillCard
															:isLaptop="isLaptop"
															:skill="interSkillParser"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@open-form="openForm"
															@select-card="(e) => (selectedCard = e)"
															@edit-form="openEditForm"
															@delete-data="assignDeleteData"
														/>

														<ParserCheckModal
															v-if="
																highlightSection === 'interskill' &&
																ind === 0 &&
																!okayToParse
															"
															@submit="submitResumeVerification"
														/>
													</div>
												</div>
												<div
													v-if="
														(localCandidateInfo.hobbies &&
															localCandidateInfo.hobbies.length > 0) ||
														(localCandidateInfo.parserHobbies &&
															localCandidateInfo.parserHobbies.length > 0)
													"
													class="candash-blktxt-bold alw-bluring"
													:class="
														localCandidateInfo.portfolio.length < 1
															? 'mt-3 mb-1'
															: 'mt-4'
													"
													ref="hobby"
												>
													Interests / Hobbies
												</div>
												<div
													v-if="
														localCandidateInfo.hobbies &&
														localCandidateInfo.hobbies.length > 0
													"
													class="w-100"
												>
													<draggable
														tag="div"
														group="myHobyData"
														:list="localCandidateInfo.hobbies"
														class="pointer alw-bluring"
														@end="onDragEndHoby"
														handle=".drag-handleHobby"
													>
														<div
															class="mt-2 text-capitalize"
															v-for="(
																hobby, index
															) in localCandidateInfo.hobbies"
															:key="index + 'hobbies'"
															v-show="
																index <
																(!isLaptop
																	? 2
																	: localCandidateInfo.hobbies.length)
															"
															:class="
																index <
																(!isLaptop
																	? 2
																	: localCandidateInfo.hobbies.length)
																	? 'd-flex align-items-start'
																	: 'd-none'
															"
														>
															<HobbyCard
																:isLaptop="isLaptop"
																:hobby="hobby"
																:formConfiguration="checkDynamicField"
																:form="form"
																:selectedCard="selectedCard"
																@open-form="openForm"
																@select-card="(e) => (selectedCard = e)"
																@edit-form="openEditForm"
																@delete-data="assignDeleteData"
															/>
														</div>
													</draggable>
												</div>

												<div
													v-if="
														localCandidateInfo.parserHobbies &&
														localCandidateInfo.parserHobbies.length > 0
													"
												>
													<div
														class="position-relative"
														v-for="(hobby, ind) in parserHobbies"
														:key="ind + 'hobbyparse'"
														:show="
															ind <
															(!isLaptop
																? 2
																: localCandidateInfo.parserHobbies.length)
														"
														:class="
															highlightSection != 'hobby' ||
															(!okayToParse && ind != 0)
																? 'alw-bluring'
																: ''
														"
													>
														<HobbyCard
															:isLaptop="isLaptop"
															:hobby="hobby"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															:isParser="true"
															@open-form="openForm"
															@select-card="(e) => (selectedCard = e)"
															@edit-form="openEditForm"
															@delete-data="assignDeleteData"
														/>
														<ParserCheckModal
															v-if="
																highlightSection === 'hobby' &&
																ind === 0 &&
																!okayToParse
															"
															@submit="submitResumeVerification"
														/>
													</div>
												</div>
												<div
													v-if="
														localCandidateInfo.skills.length > 2 ||
														localCandidateInfo.interpersonalSkills.length > 2 ||
														localCandidateInfo.hobbies.length > 2
													"
													class="text-center alw-bluring mob-viewall mb-blue-txt-2 mt-3 mb-1"
													@click="openSkillModal(form)"
												>
													View All
												</div>
											</b-collapse>
										</div>
										<div
											v-if="
												form.formID == 'project' &&
												!showTaskBarShimmer &&
												!showShimmerProjectModal
											"
											class="candash-tabs-newcard mt-2"
											ref="projectSection"
										>
											<div
												class="d-flex align-items-center justify-content-between alw-bluring"
											>
												<div>
													<div class="candash-bold-black-txt-2 d-flex">
														Project
													</div>
													<div v-if="!openproject" class="asp-subtxt mt-1">
														Add your project details
													</div>
												</div>
												<div>
													<img
														@click="openFormModal(form)"
														src="../../../assets/newdesign/dashboard/roundPlus.svg"
														alt=""
														class="pointer blueShadow"
														@click.stop
													/>
												</div>
											</div>

											<b-collapse v-model="openproject">
												<div
													class="demograpgic-data alw-bluring"
													:class="isLaptop ? 'mb-4' : 'mb-2'"
												></div>

												<draggable
													tag="div"
													group="myProjectData"
													:list="localCandidateInfo.projects"
													class="pointer alw-bluring"
													@end="onDragEndProj"
													handle=".drag-handleProj"
												>
													<div
														v-for="(project, index) in nonParserProjects"
														:key="index + 'project'"
														v-show="!project.parser"
													>
														<ProjectCard
															:isLaptop="isLaptop"
															:project="project"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@edit-form="openEditForm"
															@select-card="(e) => (selectedCard = e)"
															@delete-data="assignDeleteData"
														/>
													</div>
												</draggable>
												<div
													v-if="showTaskBarShimmer"
													class="candash-tabs-newcard mt-2"
												>
													<div>
														<div>
															<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
														</div>
														<div class="demograpgic-data"></div>
														<div class="candash-blue-details-box mt-2 p-2">
															<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
															<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
														</div>
													</div>
												</div>

												<!-- From parser Data  -->
												<div
													v-else-if="
														ifParserDataPresent(localCandidateInfo.projects) &&
														!showTaskBarShimmer
													"
													ref="project"
												>
													<div
														class="rec-title-2 alw-bluring"
														:class="isLaptop ? ' mt-4' : ''"
													>
														Review Data (Imported from your resume)
													</div>
													<div class="greytxt mt-1 alw-bluring">
														The data needs to be verified and added or missing
														data needs to be added
													</div>
													<div
														v-for="(project, index) in parserProjects"
														:key="index + 'projectParser'"
														v-show="project.parser"
														class="position-relative"
														:class="
															highlightSection != 'project' ||
															(!okayToParse && index != 0)
																? 'alw-bluring'
																: ''
														"
													>
														<ProjectCard
															:isLaptop="isLaptop"
															:project="project"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@edit-form="openEditForm"
															@select-card="(e) => (selectedCard = e)"
															@delete-data="assignDeleteData"
														/>
														<ParserCheckModal
															v-if="
																highlightSection === 'project' &&
																index === 0 &&
																!okayToParse
															"
															@submit="submitResumeVerification"
														/>
													</div>
												</div>
												<div
													v-if="
														localCandidateInfo.projects &&
														localCandidateInfo.projects.length > 2
													"
													class="text-center alw-bluring mob-viewall mb-blue-txt-2 mt-3 mb-1 alw-bluring"
													@click="openFormModal(form, true)"
												>
													View All
												</div>
											</b-collapse>
										</div>

										<div
											v-if="
												form.formID == 'achievement' &&
												!showTaskBarShimmer &&
												!showShimmerAchieveModal
											"
											class="candash-tabs-newcard mt-2"
											ref="achievementSection"
										>
											<div
												class="d-flex align-items-center justify-content-between alw-bluring"
											>
												<div>
													<div class="candash-bold-black-txt-2 d-flex">
														Achievement
													</div>
													<div v-if="!openachiev" class="asp-subtxt mt-1">
														Add your achievement details
													</div>
												</div>
												<div class="pointer">
													<img
														@click="openFormModal(form)"
														src="../../../assets/newdesign/dashboard/roundPlus.svg"
														alt=""
														class="pointer blueShadow"
														@click.stop
													/>
												</div>
											</div>

											<b-collapse v-model="openachiev">
												<div
													v-if="
														isArrayNotEmpty(localCandidateInfo.awards) ||
														isArrayNotEmpty(localCandidateInfo.achievement) ||
														isArrayNotEmpty(localCandidateInfo.events)
													"
													class="demograpgic-data alw-bluring"
													:class="isLaptop ? 'mb-4 ' : 'mb-2'"
												></div>
												<!-- For Awards -->
												<div
													v-if="isArrayNotEmpty(localCandidateInfo.awards)"
													class="candash-blktxt-bold alw-bluring"
												>
													Awards
												</div>

												<draggable
													tag="div"
													group="myAwardData"
													:list="localCandidateInfo.awards"
													class="pointer alw-bluring"
													@end="onDragEndAchieveAward"
													handle=".drag-handleAch"
												>
													<div
														v-for="(achievement, id) in nonParserAwards"
														:key="id + 'award'"
													>
														<AchievementCard
															:isLaptop="isLaptop"
															:achievement="achievement"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@edit-form="openEditForm"
															@select-card="(e) => (selectedCard = e)"
															@delete-data="assignDeleteData"
														/>
													</div>
												</draggable>

												<!-- For certificates -->
												<div
													v-if="
														ifOriginalDataPresent(
															localCandidateInfo.achievement
														) ||
														(ifParserDataPresent(
															localCandidateInfo.achievement
														) &&
															ifParserCertiPresent(
																localCandidateInfo.achievement
															))
													"
													class="candash-blktxt-bold alw-bluring"
													:class="
														localCandidateInfo.achievement.length > 0
															? 'mt-4'
															: 'mt-3'
													"
												>
													Certificates
												</div>

												<draggable
													tag="div"
													group="myAchievementData"
													:list="localCandidateInfo.achievement"
													class="pointer alw-bluring"
													@end="onDragEndAchieveCerti"
													handle=".drag-handleAch"
												>
													<div
														v-for="(achievement, id) in nonParserCertificates"
														:key="id + 'certi'"
													>
														<AchievementCard
															:isLaptop="isLaptop"
															:achievement="achievement"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@edit-form="openEditForm"
															@select-card="(e) => (selectedCard = e)"
															@delete-data="assignDeleteData"
														/>
													</div>
												</draggable>

												<!-- For Events -->
												<div
													v-if="isArrayNotEmpty(localCandidateInfo.events)"
													class="candash-blktxt-bold alw-bluring"
													:class="
														localCandidateInfo.awards.length > 0 ||
														localCandidateInfo.achievement.length > 0
															? 'mt-4'
															: 'mt-3'
													"
												>
													Events
												</div>

												<draggable
													tag="div"
													group="myEventData"
													:list="localCandidateInfo.events"
													class="pointer alw-bluring"
													@end="onDragEndAchieveEvent"
													handle=".drag-handleAch"
												>
													<div
														v-for="(achievement, id) in nonParserEvents"
														:key="id + 'achiev'"
													>
														<AchievementCard
															:isLaptop="isLaptop"
															:achievement="achievement"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@edit-form="openEditForm"
															@select-card="(e) => (selectedCard = e)"
															@delete-data="assignDeleteData"
														/>
													</div>
												</draggable>

												<!-- Coming From parser Data -->
												<div
													v-if="
														ifParserDataPresent(localCandidateInfo.achievement)
													"
													ref="achievement"
												>
													<div
														class="rec-title-2 alw-bluring"
														:class="isLaptop ? ' mt-4' : ''"
													>
														Review Data (Imported from your resume)
													</div>
													<div class="greytxt mt-1 alw-bluring">
														The data needs to be verified and added or missing
														data needs to be added
													</div>
													<div
														class="position-relative"
														v-for="(achievement, id) in parserAchievement"
														:key="id + 'award'"
														:class="
															highlightSection != 'achievement' ||
															(!okayToParse && id != 0)
																? 'alw-bluring'
																: ''
														"
													>
														<AchievementCard
															:isLaptop="isLaptop"
															:achievement="achievement"
															:formConfiguration="checkDynamicField"
															:form="form"
															:selectedCard="selectedCard"
															@edit-form="openEditForm"
															@select-card="(e) => (selectedCard = e)"
															@delete-data="assignDeleteData"
														/>

														<ParserCheckModal
															v-if="
																highlightSection === 'achievement' &&
																id === 0 &&
																!okayToParse
															"
															@submit="submitResumeVerification"
														/>
													</div>
												</div>
												<div
													v-if="
														localCandidateInfo.achievement.length > 2 ||
														localCandidateInfo.events.length > 2 ||
														localCandidateInfo.awards.length > 2
													"
													class="text-center alw-bluring mob-viewall mb-blue-txt-2 mt-3 mb-1"
													@click="openFormModal(form, true)"
												>
													View All
												</div>
											</b-collapse>
										</div>
									</div>
								</template>

								<div
									v-if="candidateInfo._id !== null"
									@mouseenter="showptag = true"
									@mouseleave="showptag = false"
									@click="goToPreviewResume()"
									:class="
										showptag ? 'extracv-width view-cv-icon' : 'view-cv-icon'
									"
									class="target hideinlaptop d-flex align-items-center justify-content-center px-1"
								>
									<img src="@/assets/newbuilder/cv.svg" alt="" />
									<p
										class="mb-0 ml-1"
										v-if="Object.keys(getcandidateInfo).length > 0 && showptag"
									>
										{{
											Object.keys(getcandidateInfo.atsResume).length == 0
												? "Create Resume"
												: "Preview Resume"
										}}
									</p>
								</div>
								<div
									v-if="candidateInfo._id !== null"
									id="resumeDiv"
									ref="resumeDiv"
									class="candash-tabs-newcard mt-2 pt-1 alw-bluring"
									:class="{
										'resume-view':
											isOnResumeDiv &&
											!previewVideo &&
											(previewAts || previewGraphical),
										'mb-27': isOnResumeDiv && previewVideo,
										'pl-0 pr-0':
											totalReferalCount < 5 &&
											previewVideo &&
											localCandidateInfo.videoResume == null,
									}"
								>
									<!-- <div style="background-color: red" @click="openGraphBuy = true">
              buy premium
            </div> -->
									<!-- first part of resume -->
									<div
										v-if="
											!previewAts &&
											!previewGraphical &&
											!previewVideo &&
											!createVideo
										"
										class="mb-2"
									>
										<div class="candash-bold-black-txt-2">Resume</div>
										<div class="candash-blueBox flex-wrap w-100 mt-1">
											<div class="bluebox-1 w-100">
												<div
													class="d-flex align-items-start justify-content-between w-100"
												>
													<div class="w-75">
														<div class="candash-bold-black-txt">
															Create your resume
														</div>
														<div class="candash-bold-black-txt-4 mt-2">
															Enhance your professional profile by incorporating
															our comprehensive resume and engaging video
															snapshot.
														</div>
													</div>
													<div class="bluebox-2">
														<img
															src="../../../assets/newdesign/dashboard/ResumeGood.svg"
															alt=""
														/>
													</div>
												</div>

												<div
													class="d-flex align-items-center justify-content-between mt-4-query new-vr-back p-2 mb-2"
												>
													<!-- <b-button
														@click="getScrollResume()"
														class="new-vr-btn"
													>
														<img
															class="mr-1"
															src="../../../assets/newdesign/dashboard/atsResume.svg"
															alt=""
														/>

														Create Graphical Resume
													</b-button> -->
													<b-button @click="openATS" class="new-vr-btn">
														<img
															class="mr-1"
															src="../../../assets/newdesign/dashboard/atsResume.svg"
															alt=""
														/>
														<span
															v-if="
																Object.keys(getcandidateInfo).length > 0 &&
																Object.keys(getcandidateInfo.atsResume)
																	.length !== 0
															"
															>Preview &nbsp;</span
														>
														<span v-else> Create&nbsp; </span>
														ATS Resume</b-button
													>
													<div class="candash-line"></div>
													<b-button
														@click="checkVideoCreateCondition()"
														class="new-vr-btn ucdSelDocFile position-relative"
													>
														<img
															class="mr-1"
															src="../../../assets/newdesign/dashboard/roundVideoBtn.svg"
															alt=""
														/>
														{{
															localCandidateInfo.videoResume
																? "View video snapshot"
																: "Create video snapshot"
														}}
													</b-button>
												</div>
											</div>
										</div>
										<hr />
										<dashboadrdfooter />
									</div>
									<template
										v-if="previewAts || previewGraphical || previewVideo"
									>
										<div
											class="candash-reume-header d-flex align-items-center justify-content-between w-100"
										>
											<div class="d-flex">
												<!-- <div
													class="candash-resume-tabs-pos-1"
													@click="handleClick"
													:class="
														previewGraphical
															? 'candash-resume-sel'
															: 'candash-resume-unsel'
													"
												>
													Graphical Resume
													<div
														v-if="previewGraphical"
														class="graph-sel-tab"
													></div>
													<div v-else class="graph-unsel-tab"></div>
												</div> -->
												<div
													class="candash-resume-tabs-pos-2"
													@click="selectAtsTab()"
													:class="
														previewAts
															? 'candash-resume-sel'
															: 'candash-resume-unsel'
													"
												>
													ATS Resume
													<!-- IF ATS IS SELECTED -->
													<div v-if="previewAts" class="ats-sel-tab"></div>
													<div v-else class="ats-unsel-tab"></div>
												</div>
												<div
													class="candash-resume-tabs-pos-2"
													@click="videoSnapOnClick()"
													:class="
														previewVideo
															? 'candash-resume-sel'
															: 'candash-resume-unsel'
													"
												>
													Video Snapshot
													<!-- IF ATS IS SELECTED -->
													<div v-if="previewVideo" class="ats-sel-tab"></div>
													<div v-else class="ats-unsel-tab"></div>
												</div>
											</div>
											<div
												class="d-flex align-items-center"
												v-if="previewGraphical || previewAts"
											>
												<div
													class="d-flex align-items-center down-left"
													v-if="userInfo.PAYMENT_REQUIRED"
												>
													<img
														class="mr-1"
														src="../../../assets/newdesign/dashboard/downloadsLeft.svg"
														alt=""
													/>{{
														parseInt(
															creditData.credits / creditData.templateCost
														)
													}}
													{{
														creditData.type == "free"
															? "daily free"
															: creditData.type
													}}
													downloads left
												</div>
												<div
													class="candash-line ml-3 mr-3"
													v-if="userInfo.PAYMENT_REQUIRED"
												></div>
												<div
													class="sel-tabstxt d-flex align-items-center pointer"
													@click="
														localCandidateInfo.profileName &&
															((resumeNameNew = localCandidateInfo.profileName),
															(renameProfile = true))
													"
													:class="{
														'disabled-download':
															!localCandidateInfo.profileName,
													}"
												>
													<img
														class="mr-1"
														src="../../../assets/newdesign/dashboard/rename.svg"
														alt=""
													/>Rename
												</div>
												<div class="candash-line ml-3 mr-3"></div>
												<div class="position-relative">
													<div
														@click="
															localCandidateInfo.primary
																? allProfiles.length > 1
																	? (deleteProfile = true)
																	: null
																: (deleteProfile = true)
														"
														class="sel-tabstxt d-flex align-items-center pointer"
														:class="{
															'disabled-download': allProfiles.length <= 1,
														}"
														@mouseenter="
															allProfiles.length <= 1 &&
																(showDeleteTooltip = true)
														"
														@mouseleave="showDeleteTooltip = false"
													>
														<img
															class="mr-1"
															src="../../../assets/newdesign/dashboard/delete-h.svg"
															alt=""
														/>Delete
													</div>
													<div class="delete-tooltip" v-if="showDeleteTooltip">
														<div
															class="d-flex align-items-center asp-small-txt text-center"
														>
															Primary profile cannot be<br />
															deleted
														</div>
													</div>
												</div>

												<div class="candash-line ml-2 mr-3"></div>
												<div
													class="candash-displaytxt-grey-3 candash-set-primary"
													@click="
														localCandidateInfo.primary
															? null
															: checkMandatoryFields(true)
													"
												>
													<b-form-radio
														size="sm"
														:class="
															localCandidateInfo.primary
																? 'pad-radio2'
																: 'pad-radio'
														"
														>Set as Primary</b-form-radio
													>
												</div>
											</div>
										</div>

										<template v-if="previewAts">
											<div class="d-flex mt-2">
												<div class="w70">
													<div
														v-if="localCandidateInfo.profileName"
														class="ml-2 mb-1 rrec-title-2 d-flex align-items-center"
													>
														<img
															v-if="localCandidateInfo.primary"
															src="../../../assets/newdesign/dashboard/svg-resume.svg"
															alt=""
														/>
														{{ localCandidateInfo.profileName }}
													</div>
												</div>
												<div
													class="width-30 d-flex justify-content-center candash-blktxt-bold"
												>
													Select Template
												</div>
											</div>
											<div
												oncontextmenu="return false;"
												class="d-flex pl-3 pr-3 mt-2"
												style="height: calc(100vh - 212px)"
											>
												<div class="ats2-right h-100">
													<div
														class="d-flex align-items-center justify-content-between pl-4 pr-4 w-100 h-90"
													>
														<div>
															<div v-if="!(currentFullPdfUrls.length <= 2)">
																<img
																	style="cursor: pointer"
																	v-if="
																		currentFullPdfUrls.length > 1 &&
																		selectedindexResume !== 0
																	"
																	@click="selectPreviousPage()"
																	src="../../../assets/newdesign/dashboard/paginationleft.svg"
																	alt=""
																/>
																<img
																	style="cursor: not-allowed"
																	v-else-if="
																		currentFullPdfUrls.length > 1 &&
																		selectedindexResume === 0
																	"
																	src="../../../assets/newdesign/dashboard/paginationleft-disabled.svg"
																	alt=""
																/>
															</div>
														</div>
														<b-overlay
															:show="!currentFullPdfUrls[currentPageAts]"
															rounded="sm"
															class="d-flex justify-content-center h-100"
															:class="{
																'w-50': currentFullPdfUrls.length === 1,
															}"
														>
															<div
																@mouseenter="resumeexpand = true"
																@mouseleave="resumeexpand = false"
																class="d-flex justify-content-center position-relative h95 w-90"
																:class="{
																	'haze-hover':
																		resumeexpand && !atsPreviewViewUpdate,
																	'haze-update':
																		atsPreviewViewUpdate &&
																		currentFullPdfUrls[currentPageAts],
																}"
															>
																<img
																	v-if="
																		!checkAtsLength &&
																		currentFullPdfUrls[currentPageAts]
																	"
																	class="ats2-whiteBorder-big br-5px"
																	style="height: 100%; width: 100%"
																	:src="currentFullPdfUrls[currentPageAts]"
																	alt=""
																/>
																<div
																	v-else-if="currentFullPdfUrls[currentPageAts]"
																	class="d-flex justify-content-between"
																>
																	<img
																		:src="currentFullPdfUrls[currentPageAts]"
																		alt=""
																		class="ats2-whiteBorder-big br-5px"
																		style="height: 100%; width: 48%"
																	/>
																	<img
																		:src="
																			currentFullPdfUrls[currentPageAts + 1]
																		"
																		alt=""
																		class="ats2-whiteBorder-big br-5px"
																		style="height: 100%; width: 48%"
																	/>
																</div>
																<div
																	v-if="resumeexpand && !atsPreviewViewUpdate"
																	class="position-absolute expand-pos text-center w-100"
																>
																	<img
																		class="pointer"
																		@click="
																			$bvModal.show('expandAtsResume'),
																				(currentPageAtsModal = 1),
																				(currentFullPdfUrlModal =
																					currentFullPdfUrlsModal[
																						currentPageAtsModal - 1
																					])
																		"
																		src="../../../assets/newdesign/dashboard/resumeExpand.svg"
																		alt=""
																	/>
																</div>
															</div>
															<div
																v-if="
																	atsPreviewViewUpdate &&
																	currentFullPdfUrls[currentPageAts]
																"
																class="candash-hazy-preview text-center w-100"
															>
																<b-button
																	v-b-modal.updateresumeAtsPreview
																	class="candash-addBtn-ats position-relative"
																>
																	<img
																		class="mr-2"
																		src="../../../assets/newdesign/dashboard/whiterefresh.svg"
																		alt=""
																	/>

																	{{
																		(
																			localCandidateInfo.atsResume.templateID
																				? localCandidateInfo.atsResume
																						.templateID ===
																				  "template" + (selectedindex + 1)
																				: true
																		)
																			? "Update"
																			: "Update and Save"
																	}}

																	<div
																		:class="
																			localCandidateInfo.atsResume
																				.templateID ===
																			'template' + (selectedindex + 1)
																				? 'update-tooltip'
																				: 'update-save-tooltip'
																		"
																	>
																		<div
																			class="d-flex align-items-center asp-small-txt text-center"
																		>
																			Click Update to reflect changes <br />
																			on the resume
																		</div>
																	</div>
																</b-button>
															</div>
														</b-overlay>
														<div>
															<div v-if="!(currentFullPdfUrls.length <= 2)">
																<img
																	style="cursor: pointer"
																	v-if="
																		checkAtsLength
																			? currentFullPdfUrls.length > 1 &&
																			  selectedindexResume !==
																					currentFullPdfUrls.length - 2
																			: currentFullPdfUrls.length > 1 &&
																			  selectedindexResume !==
																					currentFullPdfUrls.length - 1
																	"
																	@click="selectNextPage()"
																	src="../../../assets/newdesign/dashboard/paginationright.svg"
																	alt=""
																/>
																<img
																	style="cursor: not-allowed"
																	v-else
																	src="../../../assets/newdesign/dashboard/paginationright-disabled.svg"
																	alt=""
																/>
															</div>
														</div>
													</div>
													<div v-if="!atsPreviewViewUpdate">
														<div
															v-if="
																Object.keys(getcandidateInfo.atsResume)
																	.length === 0
															"
															class="d-flex justify-content-center"
														>
															<div class="position-relative">
																<b-button
																	:class="
																		saveAtsResumeLoading
																			? 'loader-class defaultCursor '
																			: 'pointer'
																	"
																	:disabled="
																		!currentFullPdfUrls[currentPageAts]
																	"
																	@click="
																		saveAtsResumeLoading
																			? null
																			: ((saveAtsResumeLoading = true),
																			  downloadAtsPreview(),
																			  setCandidateProgress())
																	"
																	class="candash-addBtn"
																>
																	{{
																		saveAtsResumeLoading
																			? ""
																			: creditData.type == "free" &&
																			  creditData.credits <
																					creditData.templateCost &&
																			  userInfo.PAYMENT_REQUIRED
																			? "Pay & Download"
																			: "Download"
																	}}
																</b-button>
																<div
																	v-if="saveAtsResumeLoading"
																	class="loader-pos-new"
																>
																	<Loader />
																</div>
															</div>
														</div>
														<div v-else class="button-and-image-container mt-2">
															<!-- <b-button
                          class="candash-cancelBtn mr-4 pointer"
                          @click="saveasanewresumne()"
                          :disabled="
                            selectedAtsResumeOnClick === selectedAtsResume ||
                            saveAtsResumeLoading
                          "
                          >Save As New</b-button
                        > -->
															<div class="position-relative mr-3">
																<b-button
																	class="candash-addBtn"
																	:class="
																		saveAtsResumeLoading
																			? 'loader-class defaultCursor '
																			: 'pointer'
																	"
																	:disabled="
																		selectedAtsResumeOnClick ===
																			selectedAtsResume ||
																		!currentFullPdfUrls[currentPageAts]
																	"
																	@click="saveResumeAtsPreviewfunc(false)"
																>
																	{{
																		saveAtsResumeLoading ? "" : "Save"
																	}}</b-button
																>
																<div
																	v-if="saveAtsResumeLoading"
																	class="loader-pos-new"
																>
																	<Loader />
																</div>
															</div>
															<div class="position-relative">
																<b-button
																	class="candash-customBtn"
																	:class="
																		isDownloading
																			? '  loader-class-pay-download defaultCursor '
																			: ' pointer'
																	"
																	:disabled="
																		!currentFullPdfUrls[currentPageAts]
																	"
																	@click="checkForAtsCredit(false)"
																>
																	<!-- !isDownloading &&
                                ((isDownloading = true), checkAndDownloadAts()) -->
																	{{
																		isDownloading
																			? ""
																			: creditData.type == "free" &&
																			  creditData.credits <
																					creditData.templateCost &&
																			  userInfo.PAYMENT_REQUIRED
																			? "Pay & Download"
																			: "Download"
																	}}</b-button
																>
																<div
																	v-if="isDownloading && !openGraphBuy"
																	class="loader-pos-new"
																>
																	<Loader />
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="ats2-left">
													<div
														v-for="(template, index) in templateResume"
														:key="index"
													>
														<div
															class="d-flex flex-column align-items-center"
															:class="index == 0 ? 'mt-1' : 'mt-4'"
														>
															<b-overlay
																:show="
																	template.resumeDataUrls &&
																	template.resumeDataUrls.length <= 0
																"
																rounded="sm"
															>
																<div
																	@click="selectResumeprev(template, index)"
																	@mouseenter="
																		(showAtsResume = true),
																			(showAtsResumeIndex = index)
																	"
																	@mouseleave="
																		(showAtsResume = false),
																			(showAtsResumeIndex = null)
																	"
																	:class="
																		selectedindex == index
																			? 'ats-black-haze-2'
																			: showAtsResumeIndex == index &&
																			  showAtsResume
																			? 'ats-blueBorder pointer'
																			: 'ats-whiteBorder-pdf'
																	"
																>
																	<!-- <img
                              v-if="
                                selectedindex == index &&
                                template.resumeDataUrls.length > 0
                              "
                              class="candash-bluecheck pointer"
                              src="../../../assets/newdesign/dashboard/bluecheck.svg"
                              alt=""
                            /> -->
																	<div
																		v-if="
																			selectedindex == index &&
																			template.resumeDataUrls.length > 0
																		"
																		class="candash-hazy-preview text-center w-100"
																	>
																		<img
																			src="../../../assets/newdesign/dashboard/whiteTick-2.svg"
																			alt=""
																		/>
																		Selected
																	</div>
																	<canvas
																		style="
																			width: 100%;
																			height: 100%;
																			border-radius: 4px;
																		"
																		:id="index + 'pdfCanvas'"
																	></canvas>
																</div>
															</b-overlay>
															<div>
																<span class="candash-desc">Template</span
																>&nbsp;&nbsp;&nbsp;<span
																	class="candash-bold-grey"
																	>{{
																		(index < 9 ? "0" : "") + (index + 1)
																	}}</span
																>
															</div>
														</div>
													</div>
												</div>
											</div>
										</template>
										<div
											v-if="previewGraphical"
											class="mt-2 d-flex"
											style="height: calc(100vh - 170px)"
										>
											<div class="w-50 h91">
												<div
													v-if="localCandidateInfo.profileName"
													class="ml-2 mb-2 rrec-title-2 d-flex align-items-center"
												>
													<img
														v-if="localCandidateInfo.primary"
														src="../../../assets/newdesign/dashboard/svg-resume.svg"
														alt=""
													/>
													{{ localCandidateInfo.profileName }}
												</div>
												<div
													class="pl-5 height-resume w70 overflow-y-auto"
													id="graph-template"
													@mouseenter="resumeexpandGraph = true"
													@mouseleave="resumeexpandGraph = false"
												>
													<b-overlay
														:show="Object.keys(selectedTemplate).length === 0"
														rounded="sm"
														class="w-100"
														:class="{
															'haze-hover':
																resumeexpandGraph &&
																!(
																	(!checkIfGraphicalResumeExist &&
																		!upToDateLocal) ||
																	!localCandidateInfo.upToDate
																) &&
																isTemplateLoaded,
															'haze-update':
																((!checkIfGraphicalResumeExist &&
																	!upToDateLocal) ||
																	!localCandidateInfo.upToDate) &&
																isTemplateLoaded,
															'cd-custom-height':
																selectedTemplate?.rows?.length < 4 &&
																(selectedTemplate.template_id ==
																	'graph_template_2' ||
																	selectedTemplate.template_id ==
																		'graph_template_1'),
															'cd-overlay-height': !isTemplateLoaded,
														}"
													>
														<template v-if="selectedTemplate.isColumned">
															<!-- style="height: 500px; width: 350px" -->
															<!-- style="position: relative" -->
															<div id="graph-resume" class="a4 template-div">
																<!-- <img style="position:absolute;right: 0px;bottom: 0px;" src="../../../assets/poweredBy.svg" alt=""> -->
																<div class="h-100 w-100 d-flex">
																	<div style="height: 100%; width: 33.3%">
																		<div
																			v-html="
																				selectedTemplate.columnData[0].data
																			"
																			style="width: 100%; height: 75%"
																		></div>
																		<div
																			v-html="
																				selectedTemplate.columnData[1].data
																			"
																			style="width: 100%; height: 25%"
																		></div>
																	</div>

																	<div style="width: 66.6%" class="h-100">
																		<div
																			class="d-flex w-100"
																			v-for="(
																				row, index
																			) in selectedTemplate.rows"
																			:key="index"
																			:style="applyMargin(index)"
																		>
																			<div
																				style="margin-left: 3px"
																				:style="
																					index1 > 0
																						? `width: ${svgData.width}%;`
																						: `width: ${svgData.width}%;`
																				"
																				v-for="(
																					svgData, index1
																				) in selectedTemplate.rowData[row]"
																				:key="index1"
																				v-html="svgData.data"
																			></div>
																			<template
																				v-if="
																					selectedTemplate.sharedRow &&
																					row === 'row_1'
																				"
																			>
																				<div style="width: 50%">
																					<div
																						v-for="(
																							svgData, index2
																						) in selectedTemplate.sharedRowData"
																						:key="index2"
																						v-html="svgData.data"
																						style="
																							height: 50%;
																							width: 100%;
																							margin-left: 2px;
																						"
																						:style="
																							index2 > 0
																								? 'margin-top: 1px;'
																								: 'margin-top: 0px;'
																						"
																					></div>
																				</div>
																			</template>
																		</div>
																	</div>
																</div>
																<div
																	id="update-btn"
																	class="candash-hazy-preview text-center w-100"
																	v-if="
																		((!checkIfGraphicalResumeExist &&
																			!upToDateLocal) ||
																			!localCandidateInfo.upToDate) &&
																		isTemplateLoaded
																	"
																>
																	<b-button
																		v-b-modal.updateresume
																		class="candash-addBtn-ats position-relative"
																	>
																		<img
																			class="mr-2"
																			src="../../../assets/newdesign/dashboard/whiterefresh.svg"
																			alt=""
																		/>
																		{{
																			(
																				localCandidateInfo.graphicalResume
																					.templateID
																					? localCandidateInfo.graphicalResume
																							.templateID ===
																					  selectedTemplate.template_id
																					: true
																			)
																				? "Update"
																				: "Update and Save"
																		}}
																		<div
																			class="update-tooltip"
																			:class="{
																				'update-save-tooltip':
																					localCandidateInfo.graphicalResume
																						.templateID &&
																					localCandidateInfo.graphicalResume
																						.templateID !==
																						selectedTemplate.template_id,
																			}"
																		>
																			<div
																				class="d-flex align-items-center asp-small-txt text-center"
																			>
																				Click Update to reflect changes <br />
																				on the resume
																			</div>
																		</div>
																	</b-button>
																</div>
																<div
																	v-if="
																		resumeexpandGraph &&
																		!(
																			(!checkIfGraphicalResumeExist &&
																				!upToDateLocal) ||
																			!localCandidateInfo.upToDate
																		) &&
																		isTemplateLoaded
																	"
																	class="position-absolute expand-pos text-center w-100"
																>
																	<img
																		id="expand-resume"
																		class="pointer"
																		@click="
																			$bvModal.show('expandGraphResume'),
																				(showResumePreview = true)
																		"
																		src="../../../assets/newdesign/dashboard/resumeExpand.svg"
																		alt=""
																	/>
																</div>
																<!-- <div
                          style="height: 25%; margin-top: 1px"
                          class="d-flex"
                        >
                          <div
                            v-for="(col, index) in selectedTemplate.sharedRow"
                            :key="index + 'shared'"
                            v-html="col.data"
                            :style="`width : ${col.width}%;`"
                          ></div>
                        </div> -->
															</div>
														</template>

														<template v-else>
															<!-- use this class when update button comes 'haze-update' -->
															<!-- style="position: relative;" -->
															<div id="graph-resume" class="a4 template-div">
																<!-- <img style="position:absolute;right: 0px;bottom: 0px;" src="../../../assets/resumeLogo.svg" alt="">
                        <img style="position:absolute;right: 0px;bottom: 0px;" src="../../../assets/poweredBy.svg" alt=""> -->
																<div class="w-100 h-100">
																	<div
																		class="d-flex w-100"
																		v-for="(
																			row, index
																		) in selectedTemplate.rows"
																		:key="index"
																		:style="applyStyle(index)"
																	>
																		<!-- :style="index === 0 ? 'height: 24.5%; margin-top:0px;' : 'height: 25%; margin-top:4px;'" -->
																		<div
																			:style="
																				index1 > 0
																					? `margin-left:6px;width: ${svgData.width}%;`
																					: `margin-left:0px;width: ${svgData.width}%;`
																			"
																			v-for="(
																				svgData, index1
																			) in selectedTemplate.rowData[row]"
																			:key="index1"
																			v-html="svgData.data"
																		></div>
																	</div>
																</div>
																<!-- code for update btn on resume -->
																<div
																	id="update-btn"
																	class="candash-hazy-preview text-center w-100"
																	v-if="
																		((!checkIfGraphicalResumeExist &&
																			!upToDateLocal) ||
																			!localCandidateInfo.upToDate) &&
																		isTemplateLoaded
																	"
																>
																	<b-button
																		v-b-modal.updateresume
																		class="candash-addBtn-ats position-relative"
																	>
																		<img
																			class="mr-2"
																			src="../../../assets/newdesign/dashboard/whiterefresh.svg"
																			alt=""
																		/>
																		{{
																			(
																				localCandidateInfo.graphicalResume
																					.templateID
																					? localCandidateInfo.graphicalResume
																							.templateID ===
																					  selectedTemplate.template_id
																					: true
																			)
																				? "Update"
																				: "Update and Save"
																		}}
																		<div
																			class="update-tooltip"
																			:class="{
																				'update-save-tooltip':
																					localCandidateInfo.graphicalResume
																						.templateID &&
																					localCandidateInfo.graphicalResume
																						.templateID !==
																						selectedTemplate.template_id,
																			}"
																		>
																			<div
																				class="d-flex align-items-center asp-small-txt text-center"
																			>
																				Click Update to reflect changes <br />
																				on the resume
																			</div>
																		</div>
																	</b-button>
																</div>
																<div
																	v-if="
																		resumeexpandGraph &&
																		!(
																			(!checkIfGraphicalResumeExist &&
																				!upToDateLocal) ||
																			!localCandidateInfo.upToDate
																		) &&
																		isTemplateLoaded
																	"
																	class="position-absolute expand-pos text-center w-100"
																>
																	<img
																		id="expand-resume-column"
																		class="pointer"
																		@click="
																			$bvModal.show('expandGraphResume'),
																				(showResumePreview = true)
																		"
																		src="../../../assets/newdesign/dashboard/resumeExpand.svg"
																		alt=""
																	/>
																</div>
															</div>
														</template>
													</b-overlay>

													<!-- <img
                      src="../../../assets/newdesign/dashboard/selTempResume.svg"
                      alt=""
                    /> -->
												</div>
												<div class="d-flex flex-column">
													<template
														v-if="!checkIfGraphicalResumeExist && upToDateLocal"
													>
														<div
															class="button-and-image-container mt-2 ml-5 w60"
														>
															<div class="position-relative">
																<b-button
																	class="candash-customBtn"
																	:class="
																		isDownloading
																			? ' loader-class-download defaultCursor '
																			: ' pointer'
																	"
																	@click="
																		isDownloading
																			? null
																			: localCandidateInfo.profileName
																			? (checkAndDownload(true),
																			  (isDownloading = true),
																			  (firstDownload = true),
																			  setCandidateProgress())
																			: ($bvModal.show('saveresume1'),
																			  (firstDownload = true))
																	"
																	:disabled="
																		!isTemplateLoaded ||
																		(!checkIfGraphicalResumeExist &&
																			!upToDateLocal)
																	"
																	>{{
																		isDownloading
																			? ""
																			: creditData.type == "free" &&
																			  creditData.credits <
																					creditData.templateCost &&
																			  userInfo.PAYMENT_REQUIRED
																			? "Pay & Download"
																			: "Download"
																	}}</b-button
																>
																<div
																	v-if="isDownloading"
																	class="loader-pos-new"
																>
																	<Loader />
																</div>
															</div>
														</div>
													</template>
													<div
														v-else-if="
															localCandidateInfo.upToDate &&
															checkIfGraphicalResumeExist
														"
														class="button-and-image-container mt-2 ml-5 w60"
													>
														<!-- <b-button
                        class="candash-cancelBtn mr-4 pointer"
                        :disabled="
                          (localCandidateInfo.upToDate &&
                            localCandidateInfo.graphicalResume.templateID ===
                              selectedTemplate['template_id']) ||
                          !isTemplateLoaded
                        "
                        @click="$bvModal.show('saveresume'), (saveAs = true)"
                        >Save As New</b-button
                      > -->
														<div class="position-relative mr-3">
															<b-button
																class="candash-addBtn"
																:class="
																	saveResumeLoading
																		? 'loader-class defaultCursor '
																		: ' pointer'
																"
																@click="saveResume(), (saveAs = false)"
																:disabled="
																	(localCandidateInfo.upToDate &&
																		localCandidateInfo.graphicalResume
																			.templateID ===
																			selectedTemplate['template_id']) ||
																	!isTemplateLoaded
																"
																>{{ saveResumeLoading ? "" : "Save" }}</b-button
															>
															<div
																v-if="saveResumeLoading"
																class="loader-pos-new"
															>
																<Loader />
															</div>
														</div>

														<div class="position-relative">
															<div class="position-relative">
																<b-button
																	class="candash-customBtn"
																	:class="
																		isDownloading &&
																		creditData.credits < creditData.templateCost
																			? 'loader-class-pay-download defaultCursor'
																			: isDownloading
																			? 'loader-class-download defaultCursor'
																			: 'pointer'
																	"
																	@click="
																		isDownloading
																			? null
																			: true
																			? ((isDownloading = true),
																			  checkAndDownload())
																			: ''
																	"
																	:disabled="
																		!localCandidateInfo.upToDate ||
																		!isTemplateLoaded
																	"
																	>{{
																		isDownloading && !openGraphBuy
																			? ""
																			: creditData.type == "free" &&
																			  creditData.credits <
																					creditData.templateCost &&
																			  userInfo.PAYMENT_REQUIRED
																			? "Pay & Download"
																			: "Download"
																	}}</b-button
																>
																<!-- // : creditData.credits < creditData.templateCost
                          // ? "Pay & Download" -->
																<div
																	v-if="isDownloading && !openGraphBuy"
																	class="loader-pos-new"
																>
																	<Loader />
																</div>
															</div>
															<div
																v-if="
																	showDownloadTooltip &&
																	isTemplateLoaded &&
																	!localCandidateInfo.upToDate
																"
																class="download-tooltip"
															>
																<div
																	class="d-flex align-items-center asp-small-txt text-center"
																>
																	To download your resume,<br />
																	click on Update
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div class="w-50 pl-4 pr-4 h-100">
												<div class="rrec-title-2 mb-2 ml-4">
													Select Template
												</div>
												<div class="d-flex justify-content-end h44 w-100">
													<div
														class="d-flex flex-column align-items-center w-50 mr-5 height-90"
													>
														<b-overlay
															v-if="
																template1Loading ||
																selectedTemplate['template_id'] ===
																	template1['template_id']
															"
															class="candash-blueBorder-2"
															:class="{
																'candash-black-haze-2':
																	selectedTemplate['template_id'] &&
																	selectedTemplate['template_id'] ===
																		template1['template_id'],
															}"
															:show="template1Loading"
															rounded="sm"
														>
															<template>
																<div>
																	<img
																		v-if="template1Loading"
																		class="h-100 w-100 br-5px"
																		src="../../../assets/newdesign/dashboard/selTempResSmall.png"
																		alt=""
																	/>
																	<img
																		v-else
																		class="h-100 w-100 br-5px card-blur"
																		src="../../../assets/newdesign/dashboard/template1.svg"
																		alt=""
																	/>
																	<div
																		v-if="
																			selectedTemplate['template_id'] &&
																			selectedTemplate['template_id'] ===
																				template1['template_id']
																		"
																		class="candash-hazy-preview text-center w-100"
																	>
																		<img
																			src="../../../assets/newdesign/dashboard/whiteTick-2.svg"
																			alt=""
																		/>
																		Selected
																	</div>
																</div>
															</template>
														</b-overlay>
														<!-- eslint-disable -->
														<Template
															v-else
															@select-template="selectTemplate"
															:templateData="template1"
															:templateID="selectedTemplate['template_id']"
														/>
														<!-- eslint-enable -->
														<div>
															<span class="candash-desc">Template</span
															>&nbsp;&nbsp;&nbsp;<span class="candash-bold-grey"
																>01</span
															>
														</div>
													</div>
													<div
														class="ml-3 d-flex flex-column align-items-center w-50 height-90"
													>
														<!-- <div class="candash-black-haze-2">
                        <img
                          class="h-100 w-100 z-ind-1 br-5px"
                          src="../../../assets/newdesign/dashboard/selTempResSmall.png"
                          alt=""
                        />
                        <div class="candash-hazy-preview text-center w-100">
                          <img
                            class="mr-2"
                            src="../../../assets/newdesign/dashboard/whitePreview.svg"
                            alt=""
                          />
                          Preview
                        </div>
                      </div> -->
														<b-overlay
															v-if="
																template2Loading ||
																selectedTemplate['template_id'] ===
																	template2['template_id']
															"
															class="candash-blueBorder-2"
															:class="{
																'candash-black-haze-2':
																	selectedTemplate['template_id'] &&
																	selectedTemplate['template_id'] ===
																		template2['template_id'],
															}"
															:show="template2Loading"
															rounded="sm"
														>
															<template>
																<div>
																	<img
																		v-if="template2Loading"
																		class="h-100 w-100 br-5px"
																		src="../../../assets/newdesign/dashboard/selTempResSmall.png"
																		alt=""
																	/>
																	<img
																		v-else
																		class="h-100 w-100 br-5px card-blur"
																		src="../../../assets/newdesign/dashboard/template2.svg"
																		alt=""
																	/>
																	<div
																		v-if="
																			selectedTemplate['template_id'] &&
																			selectedTemplate['template_id'] ===
																				template2['template_id']
																		"
																		class="candash-hazy-preview text-center w-100"
																	>
																		<img
																			src="../../../assets/newdesign/dashboard/whiteTick-2.svg"
																			alt=""
																		/>
																		Selected
																	</div>
																</div>
															</template>
														</b-overlay>
														<!-- eslint-disable -->
														<Template
															v-else
															@select-template="selectTemplate"
															:templateData="template2"
															:templateID="selectedTemplate['template_id']"
														/>
														<!-- eslint-enable -->
														<div>
															<span class="candash-desc">Template</span
															>&nbsp;&nbsp;&nbsp;<span class="candash-bold-grey"
																>02</span
															>
														</div>
													</div>
												</div>
												<div class="d-flex justify-content-end h44 w-100">
													<div
														class="d-flex flex-column align-items-center mr-5 w-50 height-90"
													>
														<b-overlay
															v-if="
																template3Loading ||
																selectedTemplate['template_id'] ===
																	template3['template_id']
															"
															class="candash-blueBorder-2"
															:class="{
																'candash-black-haze-2':
																	selectedTemplate['template_id'] &&
																	selectedTemplate['template_id'] ===
																		template3['template_id'],
															}"
															:show="template3Loading"
															rounded="sm"
														>
															<template>
																<div>
																	<!-- <div class="candash-whiteBorder-2"> -->
																	<img
																		v-if="template3Loading"
																		class="h-100 w-100 br-5px"
																		src="../../../assets/newdesign/dashboard/selTempResSmall.png"
																		alt=""
																	/>
																	<img
																		v-else
																		class="h-100 w-100 br-5px card-blur"
																		src="../../../assets/newdesign/dashboard/template3.svg"
																		alt=""
																	/>
																	<div
																		v-if="
																			selectedTemplate['template_id'] &&
																			selectedTemplate['template_id'] ===
																				template3['template_id']
																		"
																		class="candash-hazy-preview text-center w-100"
																	>
																		<img
																			src="../../../assets/newdesign/dashboard/whiteTick-2.svg"
																			alt=""
																		/>
																		Selected
																	</div>
																</div>
															</template>
														</b-overlay>
														<!-- eslint-disable -->
														<Template
															v-else
															@select-template="selectTemplate"
															:templateData="template3"
															:templateID="selectedTemplate['template_id']"
														/>
														<!-- eslint-enable -->
														<div>
															<span class="candash-desc">Template</span
															>&nbsp;&nbsp;&nbsp;<span class="candash-bold-grey"
																>03</span
															>
														</div>
													</div>
													<div
														class="ml-3 d-flex flex-column align-items-center w-50 height-90"
													>
														<b-overlay
															v-if="
																template4Loading ||
																selectedTemplate['template_id'] ===
																	template4['template_id']
															"
															class="candash-blueBorder-2"
															:class="{
																'candash-black-haze-2':
																	selectedTemplate['template_id'] &&
																	selectedTemplate['template_id'] ===
																		template4['template_id'],
															}"
															:show="template4Loading"
															rounded="sm"
														>
															<template>
																<div>
																	<!-- <div class="candash-whiteBorder-2"> -->
																	<img
																		v-if="template4Loading"
																		class="h-100 w-100 br-5px"
																		src="../../../assets/newdesign/dashboard/selTempResSmall.png"
																		alt=""
																	/>
																	<img
																		v-else
																		class="h-100 w-100 br-5px card-blur"
																		src="../../../assets/newdesign/dashboard/template4.svg"
																		alt=""
																	/>
																	<div
																		v-if="
																			selectedTemplate['template_id'] &&
																			selectedTemplate['template_id'] ===
																				template4['template_id']
																		"
																		class="candash-hazy-preview text-center w-100"
																	>
																		<img
																			src="../../../assets/newdesign/dashboard/whiteTick-2.svg"
																			alt=""
																		/>
																		Selected
																	</div>
																</div>
															</template>
														</b-overlay>
														<!-- eslint-disable -->
														<Template
															v-else
															@select-template="selectTemplate"
															:templateData="template4"
															:templateID="selectedTemplate['template_id']"
														/>
														<!-- eslint-enable -->
														<div>
															<span class="candash-desc">Template</span
															>&nbsp;&nbsp;&nbsp;<span class="candash-bold-grey"
																>04</span
															>
														</div>
													</div>
												</div>
											</div>
										</div>
										<template v-if="previewVideo">
											<div class="d-flex w-100">
												<div v-if="previewVideo" class="w-100">
													<div
														v-if="!localCandidateInfo.videoResume"
														class="d-flex align-items-center justify-content-between position-relative"
														:class="
															!creditData.firstPurchaseDone && 'height-265px'
														"
													>
														<!-- <div
															class="candash-vdsnpshot-container position-absolute d-flex justify-content-center align-items-center flex-column mt-1"
															v-if="!creditData.firstPurchaseDone"
														>
															<div
																class="d-flex align-items-center candashvector-size"
															>
																<img
																	src="../../../assets/img/candashvector.svg"
																	alt=""
																/>
															</div>
															<span class="candash-text mt-3">
																"Unlock Exclusive Video Snapshots with a simple
																click"
															</span>
															<div
																@click="
																	payementClicked ? '' : showPaymentModal()
																"
																class="bpr-add-2 bpr-add mt-4 pointer"
															>
																<img
																	class="mr-2"
																	src="../../../assets/img/unlock.svg"
																	alt=""
																/>Unlock Now
															</div>
														</div> -->

														<div
															:class="totalReferalCount < 5 ? 'pl-5' : 'pl-2'"
														>
															<div class="candash-bold-black-txt-8">
																Create your Video Snapshot
															</div>
															<div class="js-description-font pr-5 mt-3">
																Effortlessly showcase your skills and
																personality through dynamic self-presentations,
																leaving a lasting impression on potential
																employers
															</div>
															<div class="mt-4 pointer">
																<b-button
																	@click="goSystemCheck"
																	class="candash-addBtn-ats"
																	>Create New<img
																		src="../../../assets/newdesign/videoresume/newWhiteCam.svg"
																		alt=""
																/></b-button>
															</div>
														</div>
														<div
															:class="totalReferalCount < 5 ? 'pr-5' : 'pr-2'"
														>
															<img
																src="../../../assets/newdesign/videoresume/startVR.svg"
																alt=""
															/>
														</div>
													</div>
													<div v-else-if="localCandidateInfo.videoResume">
														<previewResume />
													</div>
												</div>
												<!-- <div v-else-if="createVideo" class="w-100">
                    <div v-if="sysCheck">
                      <systemCheck
                        @sysCheck="sysCheck = false"
                        @bcktoPreview="
                          (previewVideo = true),
                            (createVideo = false),
                            (sysCheck = true)
                        "
                      />
                    </div>
                    <div v-else>
                      <videoResume
                        @bcktosyscheck="sysCheck = true"
                        @gotoPreviewResume="
                          (previewVideo = true),
                            (createVideo = false),
                            (sysCheck = true)
                        "
                      />
                    </div>
                  </div> -->
											</div>
										</template>
										<div class="demograpgic-data mt-2"></div>
										<dashboadrdfooter />
									</template>
								</div>
							</div>
						</div>
					</div>

					<HelpSection
						:referalCode="referalCode"
						:isLoading="showTaskBarShimmer"
						class="alw-bluring"
					/>
				</main>
			</div>
			<div
				id="hideinlaptop"
				v-if="showNotSavedProfile"
				class="candash-saved-cont"
			>
				<div
					class="mob-back-header d-flex align-items-center justify-content-between"
				>
					<div class="fw-LM fam-lato fs-18 text-black">
						<img
							src="../../../assets/img/header/bckarw.svg"
							class="mr-2"
							alt=""
							@click="showNotSavedProfile = false"
						/>
						Preview Resume
					</div>
				</div>
				<div class="candash-blueBox flex-wrap w-100 mt-1">
					<div class="bluebox-1 w-100">
						<div class="d-flex align-items-start justify-content-between w-100">
							<div class="w-75">
								<div class="candash-bold-black-txt">Create your resume</div>
								<div class="candash-bold-black-txt-4 mt-2">
									Enhance your professional profile by incorporating our
									comprehensive resume and engaging video snapshot.
								</div>
							</div>
						</div>
						<div class="bluebox-2">
							<img
								src="../../../assets/newdesign/dashboard/ResumeGood.svg"
								alt=""
							/>
						</div>
						<div
							class="d-flex align-items-center justify-content-between mt-4-query new-vr-back p-2 mb-2"
						>
							<!-- <b-button
								@click="routeToMobileResume('graphical')"
								class="new-vr-btn"
							>
								<img
									class="mr-1"
									src="../../../assets/newdesign/dashboard/atsResume.svg"
									alt=""
								/>

								Create Graphical Resume
							</b-button> -->
							<b-button @click="routeToMobileResume('ats')" class="new-vr-btn">
								<img
									class="mr-1"
									src="../../../assets/newdesign/dashboard/atsResume.svg"
									alt=""
								/>
								<span
									v-if="
										Object.keys(getcandidateInfo).length > 0 &&
										Object.keys(getcandidateInfo.atsResume).length !== 0
									"
									>Preview &nbsp;</span
								>
								<span v-else> Create&nbsp; </span>
								ATS Resume</b-button
							>
							<div class="candash-line"></div>
							<b-button
								@click="routeToMobileResume('video')"
								class="new-vr-btn ucdSelDocFile position-relative"
							>
								<img
									class="mr-1"
									src="../../../assets/newdesign/dashboard/roundVideoBtn.svg"
									alt=""
								/>
								{{
									localCandidateInfo.videoResume
										? "View video snapshot"
										: "Create video snapshot"
								}}
							</b-button>
						</div>
					</div>
				</div>
			</div>
			<div v-if="showMobVideoScreen" class="create-video-cont">
				<div style="height: 92%">
					<div class="d-flex justify-content-end">
						<img
							class="m-3"
							@click="showMobVideoScreen = false"
							src="@/assets/newbuilder/grey-cross.svg"
						/>
					</div>
					<div class="body">
						<div class="fam-mont fw-M fs-20 text-blue px-3">
							Create your Video Snapshot
						</div>
						<div class="fam-mont fw-R fs-14 text-black px-3 mt-4">
							Effortlessly showcase your skills and personality through dynamic
							self-presentations, leaving a lasting impression on potential
							employers
						</div>
						<div class="mt-5">
							<img
								class="w-100"
								src="@/assets/newbuilder/create-video.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<div class="mobjd-applied-footer px-4">
					<div class="mob-addBtn w-100">
						<b-button @click="goSystemCheck()" class="w-100"
							><img
								class="mr-2"
								src="@/assets/newbuilder/create-video-btn.svg"
							/>
							Create New</b-button
						>
					</div>
				</div>
			</div>
			<div
				class="create-profile-box alw-bluring"
				v-if="mobCreateNewProfile"
				style="height: auto"
			>
				<section>
					<div
						v-if="localCandidateInfo.primary == false"
						class="cpb-txt pt-2 d-flex align-items-center justify-content-between"
					>
						<div
							class="d-flex align-items-center"
							@click="
								localCandidateInfo.primary ? null : checkMandatoryFields(true)
							"
						>
							<b-form-radio
								:class="localCandidateInfo.primary ? 'pad-radio2' : 'pad-radio'"
							></b-form-radio>
							Set as primary profile
						</div>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/rightarrow.svg"
								alt=""
							/>
						</div>
					</div>
					<hr class="my-2 hr-back" v-if="localCandidateInfo.primary == false" />
					<div
						class="cpb-txt pt-2 d-flex align-items-center justify-content-between"
						@click="
							localCandidateInfo.profileName &&
								((resumeNameNew = localCandidateInfo.profileName),
								(renameProfile = true))
						"
						:class="{
							'disabled-download': !localCandidateInfo.profileName,
						}"
					>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/shutter-rename.svg"
								alt=""
							/>
							Rename
						</div>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/rightarrow.svg"
								alt=""
							/>
						</div>
					</div>
					<hr class="my-2 hr-back" v-if="allProfiles.length > 1" />
					<div
						v-if="allProfiles.length > 1"
						@click="deleteProfile = true"
						class="cpb-txt pt-2 d-flex align-items-center justify-content-between"
					>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/shutter-delete.svg"
								alt=""
							/>
							Delete
						</div>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/rightarrow.svg"
								alt=""
							/>
						</div>
					</div>
					<hr class="my-2 hr-back" />
					<div
						class="cpb-txt pt-2 d-flex align-items-center justify-content-between"
						@click="handleCreateNewProfile()"
					>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/create-prof.svg"
								alt=""
							/>
							Create New Profile
						</div>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/rightarrow.svg"
								alt=""
							/>
						</div>
					</div>
					<hr class="my-2 hr-back" v-if="localCandidateInfo.primary == false" />
					<div
						v-if="localCandidateInfo.primary == false"
						class="cpb-txt pt-2 d-flex align-items-center justify-content-between"
						@click="
							(mobCreateNewProfile = false),
								setProfileId(candidateInfo.primaryProfile.id)
						"
					>
						<div ref="profileDiv-tabs">
							<img
								class="mr-1"
								src="@/assets/newbuilder/switcprimary.svg"
								alt=""
							/>
							Switch to Primary Profile
						</div>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/rightarrow.svg"
								alt=""
							/>
						</div>
					</div>

					<hr v-if="allProfiles.length > 1" class="my-2 hr-back" />
					<div
						v-if="allProfiles.length > 1"
						class="cpb-txt pt-2 d-flex align-items-center justify-content-between"
						@click="(mobCreateNewProfile = false), (showAllProfileModal = true)"
					>
						<div>
							<img
								class="mr-1"
								src="@/assets/newbuilder/view-profs.svg"
								alt=""
							/>
							View all Profiles
						</div>
						<div
							@click="
								(mobCreateNewProfile = false), (showAllProfileModal = true)
							"
						>
							<img
								class="mr-1"
								src="@/assets/newbuilder/rightarrow.svg"
								alt=""
							/>
						</div>
					</div>
				</section>
				<!-- the below section create-profile-box height is 350px view all profs -->

				<!-- create profs the create-profile-box height is 500px -->
			</div>
			<Profiles
				v-if="showAllProfileModal"
				:showModal="showAllProfileModal"
				:isLaptop="isLaptop"
				@close-modal="showAllProfileModal = false"
				@open-mob-create="mobileCreateNewProfile"
				@show-create-new-profile="handleCreateNewProfile()"
				@change-profile="changeProfiles"
				@downloadGraphicalResume="downloadGraphicalResume"
				@checkDownloadForm="checkDownloadForm"
			/>
		</div>

		<!-- </div> -->
		<b-modal
			id="buypremiumodal"
			v-model="openGraphBuy"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			@hidden="openGraphBuy = false"
		>
			<div class="d-flex w-100">
				<div class="w-50">
					<div
						class="h-86px bpr-header d-flex align-items-center justify-content-center"
					>
						Free
					</div>
					<div class="d-flex flex-column align-items-center pt-2">
						<div class="bpr-resume-div">
							<div
								class="h-100 w-100 position-relative d-flex align-items-center justify-content-center"
								v-if="openGraphBuy"
								v-html="getHTMLFile(true, 1)"
							></div>
						</div>
						<div class="d-flex justify-content-between mt-4">
							<div class="down-left">
								{{ parseInt(creditData.credits / creditData.templateCost) }}
								downloads left
							</div>
						</div>
						<div
							class="bpr-cancel my-4 pointer position-relative"
							@click="downloadFree"
						>
							{{ isDownloading ? "" : "Free - Download" }}
							<div v-if="isDownloading" class="loader-pos-new">
								<BlueLoader />
							</div>
						</div>
					</div>
				</div>
				<div class="w-50">
					<div class="position-relative">
						<img
							class=""
							src="../../../assets/newdesign/dashboard/buyPremium.svg"
							alt=""
						/>
						<img
							@click="openGraphBuy = false"
							class="buy-prem-pos rotate-on-hover pointer"
							src="../../../assets/newdesign/dashboard/x-close.svg"
							alt=""
						/>
					</div>
					<div
						class="d-flex flex-column align-items-center pt-2"
						style="background-color: #eef3f7; border-bottom-right-radius: 9px"
					>
						<div class="bpr-resume-div">
							<div
								class="h-100 w-100 position-relative"
								v-if="openGraphBuy"
								v-html="getHTMLFile(true)"
							></div>
						</div>
						<div
							class="d-flex align-items-center justify-content-center mt-4 mb-resume-name-2"
						>
							<img
								class="mr-2"
								src="../../../assets/newdesign/dashboard/svgCheck.svg"
								alt=""
							/>Download more resumes without watermark
						</div>
						<div
							@click="payementClicked ? '' : showPaymentModal()"
							class="bpr-add my-4 pointer"
						>
							Buy Now
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="buypremiumodal"
			v-model="openAtsBuy"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			@hidden="openAtsBuy = false"
		>
			<div class="d-flex w-100">
				<div class="w-50">
					<div
						class="h-86px bpr-header d-flex align-items-center justify-content-center"
					>
						Free
					</div>
					<div class="d-flex flex-column align-items-center pt-2">
						<b-overlay
							:show="showAtsBuy"
							rounded="sm"
							class="d-flex justify-content-center h-100"
						>
							<div class="bpr-resume-div position-relative">
								<canvas
									style="width: 100%; height: 100%; border-radius: 4px"
									id="free-pdfCanvas"
								></canvas>
							</div>
						</b-overlay>
						<div class="d-flex justify-content-between mt-4">
							<div class="down-left">
								{{ parseInt(creditData.credits / creditData.templateCost) }}
								downloads left
							</div>
						</div>
						<div
							class="bpr-cancel my-4 pointer position-relative"
							@click="handleClickAts"
							:class="{
								'disabled-download': downloadFreeAtsLoader || showAtsBuy,
							}"
						>
							{{ downloadFreeAtsLoader || showAtsBuy ? "" : "Free - Download" }}
							<div
								v-if="downloadFreeAtsLoader || showAtsBuy"
								class="loader-pos-new"
							>
								<BlueLoader />
							</div>
						</div>
					</div>
				</div>
				<div class="w-50">
					<div class="position-relative">
						<img
							class=""
							src="../../../assets/newdesign/dashboard/buyPremium.svg"
							alt=""
						/>
						<img
							@click="openAtsBuy = false"
							class="buy-prem-pos rotate-on-hover pointer"
							src="../../../assets/newdesign/dashboard/x-close.svg"
							alt=""
						/>
					</div>
					<div
						class="d-flex flex-column align-items-center pt-2"
						style="background-color: #eef3f7; border-bottom-right-radius: 9px"
					>
						<div class="bpr-resume-div position-relative">
							<div
								v-if="(showAtsBuy || loadAtsNor) && !previewAts"
								class="loader-pos-new"
							>
								<b-overlay
									:show="showAtsBuy || loadAtsNor"
									rounded="sm"
									class="d-flex justify-content-center h-100"
								>
								</b-overlay>
							</div>
							<img
								v-else
								class="h-100 w-100"
								:src="currentFullPdfUrlModal"
								alt=""
							/>
						</div>
						<div
							class="d-flex align-items-center justify-content-center mt-4 mb-resume-name-2"
						>
							<img
								class="mr-2"
								src="../../../assets/newdesign/dashboard/svgCheck.svg"
								alt=""
							/>Download more resumes without watermark
						</div>
						<div
							@click="payementClicked ? '' : showPaymentModal()"
							class="bpr-add my-4 pointer"
						>
							Buy Now
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="fillmandatory" size="md" centered hide-footer hide-header>
			<div class="d-flex flex-column align-items-center p-2">
				<div>
					<img src="../../../assets/New Profile/warning-icon.svg" alt="" />
				</div>
				<div class="mb-header-txt text-center mt-2">
					Please fill the mandatory forms<br />
					before setting this profile as primary.
				</div>
				<div class="mt-4">
					<b-button
						class="candash-addBtn"
						@click="checkOverallMandetoryTabsFilledAts(true)"
						>Okay</b-button
					>
				</div>
			</div>
		</b-modal>

		<b-modal id="expandGraphResume" centered hide-footer hide-header size="lg">
			<div class="d-flex">
				<div class="candash-modal-left width-7"></div>
				<div class="width-93">
					<div class="candash-modal-top p-3">
						<div class="width-97">
							<div class="mb-header-txt">Preview Graphical Resume</div>
						</div>
						<div class="d-flex justify-content-end pointer">
							<img
								class="rotate-on-hover"
								src="../../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
								@click="
									$bvModal.hide('expandGraphResume'),
										(showResumePreview = false),
										(resumeexpandGraph = false)
								"
							/>
						</div>
					</div>
					<div class="d-flex flex-column align-items-center pt-2 pl-4 pr-4">
						<div class="graph-overflow p-2">
							<div
								class="Graph-modal-resume"
								v-if="showResumePreview"
								v-html="getHTMLFile(true)"
							></div>
						</div>
						<div class="h-50px"></div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="expandAtsResume" centered hide-footer hide-header size="lg">
			<div class="d-flex">
				<div class="candash-modal-left width-7"></div>
				<div class="width-93">
					<div class="candash-modal-top p-3">
						<div class="width-97">
							<div class="mb-header-txt">Preview ATS Resume</div>
						</div>
						<div class="d-flex justify-content-end pointer">
							<img
								class="rotate-on-hover"
								src="../../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
								@click="$bvModal.hide('expandAtsResume')"
							/>
						</div>
					</div>
					<div class="d-flex flex-column align-items-center pt-2 pl-4 pr-4">
						<div class="graph-overflow p-2" id="ATSPreview">
							<div class="Graph-modal-resume" oncontextmenu="return false;">
								<img
									:src="currentFullPdfUrlModal"
									alt=""
									style="height: 100%; width: 100%"
								/>
							</div>
						</div>
						<div class="asp-pagination align-items-center d-flex h-50px">
							<b-pagination
								v-model="currentPageAtsModal"
								:total-rows="currentFullPdfUrlsModal.length"
								:per-page="1"
								align="center"
								first-number
								last-number
								@change="handlePageChange"
							>
							</b-pagination>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="updateresume" size="md" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-top no-border-bottom p-3">
						<div class="width-10">
							<img
								class="mr-3"
								src="../../../assets/videoresume/captureerror.svg"
								alt=""
							/>
						</div>
						<div class="pl-3 w87">
							<div class="d-flex justify-content-between">
								<div class="candash-modal-head">Update</div>
								<div
									class="d-flex justify-content-end pointer cross-icon-pos"
									@click="$bvModal.hide('updateresume')"
								>
									<img
										class="rotate-on-hover"
										src="../../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-2 pr-3">
								Would you like to update the changes?
							</div>
						</div>
					</div>

					<div
						class="p-3 no-border-top d-flex align-items-center justify-content-end"
					>
						<b-button
							class="candash-cancelBtn mr-4"
							@click="$bvModal.hide('updateresume')"
							>Cancel</b-button
						>
						<div class="position-relative">
							<b-button
								class="candash-addBtn"
								@click="
									updateResumeLoading
										? null
										: ((selectedResumeToDownload = null),
										  !checkIfGraphicalResumeExist
												? updateBeforeDownload()
												: saveResume(false, true))
								"
								:class="
									updateResumeLoading
										? 'loader-class-update defaultCursor'
										: 'pointer'
								"
								>{{ updateResumeLoading ? "" : "Update" }}
							</b-button>
							<div v-if="updateResumeLoading" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="createATS" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="w-100">
					<div
						class="candash-modal-top no-border-bottom align-items-start mt-2"
					>
						<div class="width-10">
							<img
								class="mr-3"
								src="../../../assets/newdesign/dashboard/blueModalPic.svg"
								alt=""
							/>
						</div>
						<div class="w87">
							<div class="d-flex justify-content-between align-items-start">
								<div class="mb-header-txt">
									Would you like to generate an ATS Resume without filling in
									all the sections?
								</div>

								<div
									class="d-flex justify-content-end pointer"
									@click="$bvModal.hide('createATS')"
								>
									<img
										src="../../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>

					<div
						class="no-border-top d-flex align-items-center justify-content-end mt-4 mb-2"
					>
						<b-button
							@click="$bvModal.hide('createATS')"
							class="candash-cancelBtn mr-3 pointer"
							>Cancel</b-button
						>
						<b-button
							class="candash-addBtn pointer"
							@click="
								(previewAts = true),
									setInitialAtsLocalCandidateInfo(),
									(previewGraphical = false),
									getAllProfiles();
								$bvModal.hide('createATS');
							"
							>Create Anyway</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal id="saveresume1" size="md" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-body-3 p-3">
						<div class="d-flex align-items-start">
							<div>
								<img
									src="../../../assets/newdesign/dashboard/creaNewPro.svg"
									alt=""
								/>
							</div>
							<div class="w95 pl-3">
								<div class="d-flex align-items-center justify-content-between">
									<div class="candash-modal-head">
										{{ saveAs ? "Save As" : "Save Resume" }}
									</div>
									<div
										class="pointer"
										@click="
											$bvModal.hide('saveresume1'),
												$v.resumeName.$reset(),
												(resumeErrorMessage = ''),
												(resumeName = '')
										"
									>
										<img
											class="rotate-on-hover"
											src="../../../assets/newdesign/dashboard/blueCross.svg"
											alt=""
										/>
									</div>
								</div>
								<div class="candash-blackTxt mt-2">Profile Name</div>
								<div class="w95 mt-2">
									<b-form-input
										@input="ifProfileNameExist = false"
										placeholder="Enter name of the resume"
										type="text"
										:class="
											$v.resumeName.$error ||
											ifProfileNameExist ||
											resumeName.length > 20
												? 'laptopinput-error'
												: 'laptopinput'
										"
										v-model="$v.resumeName.$model"
									>
									</b-form-input>
									<div v-if="ifProfileNameExist" class="candash-errortxt">
										{{ resumeErrorMessage }}
									</div>
									<div
										v-else-if="resumeName.length > 20"
										class="candash-errortxt"
									>
										Exceeded the max char length of 20
									</div>
									<div
										v-else-if="$v.resumeName.$dirty && !$v.resumeName.required"
										class="candash-errortxt w65"
									>
										Required
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="p-3 d-flex align-items-center justify-content-end gap-4 mt-3"
					>
						<div class="position-relative">
							<b-button
								class="candash-cancelBtn pointer"
								:class="
									saveResumeLoading && saveAs
										? 'loader-class-cancel'
										: saveResumeLoading && !saveAs
										? 'loader-class-save-resume defaultCursor '
										: 'pointer'
								"
								@click="
									saveResumeLoading
										? null
										: saveAs
										? ($bvModal.hide('saveresume1'), $v.resumeName.$reset())
										: saveResume(),
										setCandidateProgress()
								"
								>{{
									saveResumeLoading ? "" : saveAs ? "Cancel" : "Save"
								}}</b-button
							>
							<div v-if="saveResumeLoading" class="loader-pos-new">
								<BlueLoader />
							</div>
						</div>

						<div class="position-relative">
							<b-button
								class="candash-addBtn"
								:class="
									saveAndDownloadResumeLoading
										? ' loader-class defaultCursor '
										: ' pointer'
								"
								@click="
									saveAndDownloadResumeLoading
										? null
										: saveAs
										? saveResume()
										: checkAndDownload(true),
										setCandidateProgress()
								"
								>{{
									saveAndDownloadResumeLoading
										? ""
										: saveAs
										? "Save"
										: "Save & Download"
								}}</b-button
							>
							<div v-if="saveAndDownloadResumeLoading" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal
			id="saveresumeAtsPreview"
			size="md"
			centered
			hide-footer
			hide-header
		>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-body-3 p-3">
						<div class="d-flex align-items-start">
							<div>
								<img
									src="../../../assets/newdesign/dashboard/creaNewPro.svg"
									alt=""
								/>
							</div>
							<div class="w95 pl-3">
								<div class="d-flex align-items-center justify-content-between">
									<div class="candash-modal-head">
										{{ saveAsNewAts ? "Save As" : "Save Resume" }}
									</div>
									<div
										class="pointer"
										@click="
											$bvModal.hide('saveresumeAtsPreview'),
												$v.resumeName.$reset(),
												(resumeErrorMessage = ''),
												(resumeName = '')
										"
									>
										<img
											class="rotate-on-hover"
											src="../../../assets/newdesign/dashboard/blueCross.svg"
											alt=""
										/>
									</div>
								</div>
								<div class="candash-blackTxt mt-2">Profile Name</div>
								<div class="w95 mt-2">
									<b-form-input
										placeholder="Enter name of the resume"
										type="text"
										:class="
											$v.resumeName.$error || resumeName.length > 20
												? 'laptopinput-error'
												: 'laptopinput'
										"
										v-model="$v.resumeName.$model"
									>
									</b-form-input>
									<div v-if="ifProfileNameExist" class="candash-errortxt">
										{{ resumeErrorMessage }}
									</div>
									<div
										v-else-if="resumeName.length > 30"
										class="candash-errortxt"
									>
										Exceeded the max char length of 30
									</div>
									<div
										v-else-if="$v.resumeName.$dirty && !$v.resumeName.required"
										class="candash-errortxt w65"
									>
										Required
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="p-3 d-flex align-items-center justify-content-end gap-4 mt-3"
					>
						<div class="position-relative">
							<b-button
								class="candash-cancelBtn pointer"
								:class="
									saveAtsResumeLoading && saveAsNewAts
										? 'loader-class-cancel'
										: saveAtsResumeLoading && !saveAsNewAts
										? 'loader-class-save-resume defaultCursor '
										: 'pointer'
								"
								@click="
									saveAtsResumeLoading
										? null
										: saveAsNewAts
										? $bvModal.hide('saveresumeAtsPreview')
										: saveResumeAtsPreviewfunc(true)
								"
								>{{
									saveAtsResumeLoading ? "" : saveAsNewAts ? "Cancel" : "Save"
								}}</b-button
							>
							<div v-if="saveAtsResumeLoading" class="loader-pos-new">
								<BlueLoader />
							</div>
						</div>
						<div class="position-relative">
							<b-button
								@click="
									saveAndDownloadResumeLoading
										? null
										: saveAsNewAts
										? saveAsNewAtsResume()
										: checkForAtsCredit(true)
								"
								class="candash-addBtn"
								:class="
									saveAndDownloadResumeLoading
										? 'loader-class defaultCursor '
										: 'pointer'
								"
							>
								{{
									saveAndDownloadResumeLoading
										? ""
										: saveAsNewAts
										? "Save"
										: "Save & Download"
								}}</b-button
							>
							<div v-if="saveAndDownloadResumeLoading" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="updateresumeAtsPreview"
			size="md"
			centered
			hide-footer
			hide-header
		>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-top no-border-bottom p-3">
						<div class="width-10">
							<img
								class="mr-3"
								src="../../../assets/videoresume/captureerror.svg"
								alt=""
							/>
						</div>
						<div class="pl-3 w87">
							<div class="d-flex justify-content-between">
								<div class="candash-modal-head">Update</div>
								<div
									class="d-flex justify-content-end pointer cross-icon-pos"
									@click="$bvModal.hide('updateresumeAtsPreview')"
								>
									<img
										class="rotate-on-hover"
										src="../../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-2 pr-3">
								Would you like to update the changes?
							</div>
						</div>
					</div>

					<div
						class="p-3 no-border-top d-flex align-items-center justify-content-end"
					>
						<div class="position-relative">
							<b-button
								class="candash-cancelBtn mr-4 pointer"
								@click="$bvModal.hide('updateresumeAtsPreview')"
								>Cancel</b-button
							>
						</div>
						<div class="position-relative">
							<b-button
								class="candash-addBtn"
								:class="
									isUpdatingAtsResume
										? 'loader-class-update defaultCursor '
										: 'pointer'
								"
								@click="
									localCandidateInfo.atsResume.templateID ===
									'template' + (selectedindex + 1)
										? updateAtsPreview()
										: (updateAtsPreview(),
										  Object.keys(localCandidateInfo.atsResume).length !== 0
												? saveResumeAtsPreviewfunc(false)
												: '')
								"
							>
								{{ isUpdatingAtsResume ? "" : "Update" }}</b-button
							>
							<div v-if="isUpdatingAtsResume" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="setupjobpref" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="w-100">
					<div
						class="d-flex align-items-start"
						:class="isLaptop ? '' : 'flex-column align-items-center'"
					>
						<img src="@/assets/job-search-icons/setup-jp-modal.svg" alt="" />
						<div class="ml-3 mobile-txt-center">
							<div
								class="d-flex align-items-center"
								:class="
									isLaptop
										? 'justify-content-between'
										: 'justify-content-center'
								"
							>
								<div class="setup-job-pref-head mob-mt-1">
									Set your Job Preferences
								</div>
								<img
									@click="$bvModal.hide('setupjobpref')"
									class="rotate-on-hover pointer hideinmob"
									src="@/assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
							<div class="setup-jp-subhead mt-1">
								Increase your chances of being noticed by recruiters, update
								your job preferences.
							</div>
						</div>
					</div>
					<div
						class="d-flex align-items-center mt-4"
						:class="
							isLaptop
								? 'justify-content-end'
								: 'justify-content-center mob-w110px'
						"
					>
						<b-button
							class="candash-cancelBtn mr-3"
							@click="$bvModal.hide('setupjobpref')"
							>Skip</b-button
						>

						<div class="position-relative">
							<b-button class="candash-addBtn" @click="showJobPreferance = true"
								>Set-up</b-button
							>
							<!-- <div v-if="deleteOne" class="loader-pos">
								<Loader />
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<LaptopJobPref
			v-if="showJobPreferance"
			:showModal="showJobPreferance"
			:initialData="formData"
			@close-modal="showJobPreferance = false"
		/>

		<UploadResume
			v-if="showUploadResumeModal"
			:showModal="showUploadResumeModal"
			:isLaptop="isLaptop"
			@getCommonFuncForProfile="getCommonFuncForProfile()"
			@getCandidateDetail="getCandidateDetailTabs"
			@open-fill-form="openFillFormModal"
		/>

		<!-- Delete modal -->
		<DeleteModal
			v-if="showDeleteModal"
			:showModal="showDeleteModal"
			:deleteContent="deleteContent"
			:selectedForm="selectedForm"
			@close-modal="clearDeleteData"
			@profile-complition="profileCompletion"
			@get-profile-details="getCommonFuncForProfile()"
		/>

		<PersonalDetailsModal
			v-if="showBasicModalFullNew && !isOnboardingActive"
			:showModal="showBasicModalFullNew"
			:form="selectedForm"
			:formType="modalType"
			@close-modal="showBasicModalFullNew = false"
			@discard-modal="discardModal = true"
			@update-data="updateData"
			@open-rename-modal="showresumerename = true"
		/>
		<SkillModal
			v-if="showSkillModal"
			:showModal="showSkillModal"
			:form="selectedForm"
			:singleData="selectedData"
			:formType="formType"
			@close-modal="closeFormModal(), (showSkillModal = false)"
			@show-success="showSuccess"
			@data-added="getCommonFuncForProfile()"
		/>

		<DiscardModal
			v-if="discardModal"
			:showModal="discardModal"
			@close-modal="discardModal = false"
			@discard-changes="discardAllChangesModal"
		/>

		<PaymentModal
			v-if="showPayment"
			:showPayment="showPayment"
			:userEmail="userEmail"
			:creditData="creditData"
			:customerID="customerID"
			@downloadDone="handleAfterPayment"
			@close-modal="hidePayment()"
		/>

		<CreateNewProfile
			v-if="showCreateNewMProfileModal"
			:showModal="showCreateNewMProfileModal"
			:isLaptop="isLaptop"
			@open-mob-create="mobileCreateNewProfile"
			@close-modal="showCreateNewMProfileModal = false"
			@change-profile="finishProfileCreation"
		/>
		<FormModal
			v-if="showForm"
			:showModal="showForm"
			:singleData="selectedData"
			:formType="formType"
			:form="selectedForm"
			:selectedAchieveTab="selectedAchieveTab"
			@data-added="dataAddedFunc"
			@close-modal="closeFormModal"
			@select-parser-tab="assignSelectedTab"
		/>
		<RenameProfile
			v-if="renameProfile"
			:showModal="renameProfile"
			:localCandidateInfo="localCandidateInfo"
			@update-profile="getCandidateDetailTabs"
			@close-modal="hideRenameModal"
		/>
		<SetPrimary
			v-if="setPrimary"
			:showModal="setPrimary"
			:localCandidateInfo="localCandidateInfo"
			@update-isPrimary="updateIsPrimary"
			@close-modal="hideSetPrimaryModal"
		/>
		<DeleteProfile
			v-if="deleteProfile"
			:localCandidateInfo="localCandidateInfo"
			@update-profile="setProfileId"
			@close-modal="hideDeleteModal"
		/>
		<!-- <KickstartModal
			v-if="showKickstart"
			:showModal="showKickstart"
			:isKickstartSufficient="isKickstartSufficient"
			@close-modal="closeKickstartModal"
		/> -->
		<b-modal
			v-if="featureNotAvailable"
			visible
			id="featureNotAvailable"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<section
				class="d-flex flex-column align-items-center justify-content-center"
			>
				<img src="@/assets/newbuilder/featureLocked.svg" alt="" />
				<div class="cr-modalhead my-3 mx-3 text-center">Feature Locked</div>
				<div v-if="shouldShowDiv">Save resume to Unlock this feature</div>
				<div v-else class="cr-modal-subhead my-2 mx-3 text-center">
					Please fill the required information in the sections shown below to
					unlock “{{ featureNotAvailable }}”.
				</div>
				<div class="mob-addBtn w-100 mt-4 text-center">
					<b-button class="w40" @click="featureNotAvailable = null"
						>Okay</b-button
					>
				</div>
			</section>
		</b-modal>
		<b-modal centered hide-footer hide-header id="completeSeventy">
			<div class="d-flex flex-column align-items-center gap-3">
				<img src="@/assets/newbuilder/warn-modal-icon.svg" alt="" />
				<div class="fam-lato fw-LM fs-18 text-black text-center">
					Complete at least 70% of your resume to <br />
					become a panelist
				</div>
				<div class="fam-mont fw-LM fs-13 text-344054 text-center">
					Fill your resume and then come back to complete your <br />
					application! This helps us to assess you better.
				</div>
				<b-button class="candash-addBtn my-2">Okay</b-button>
			</div>
		</b-modal>

		<b-modal
			id="saveparserprofile"
			v-model="saveparserprofile"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			class="p-0"
			@hidden="saveparserprofile = false"
		>
			<div class="candash-modal-body-3" :class="isLaptop ? 'p-3' : 'p-0'">
				<div class="d-flex align-items-start mobflexcol">
					<div class="mobw-100 mobile-txt-center position-relative">
						<img
							src="../../../assets/newdesign/dashboard/creaNewPro.svg"
							alt=""
						/>
						<img
							id="hideinlaptop"
							@click="$bvModal.hide('saveparserprofile')"
							class="rotate-on-hover pointer parsermodalcross"
							src="@/assets/newdesign/dashboard/blueCross.svg"
							alt=""
						/>
					</div>
					<div :class="isLaptop ? 'pl-3 w-95' : 'w-100'">
						<div class="d-flex align-items-center justify-content-between mb-2">
							<div class="setup-job-pref-head mobmt20">Set your Profile</div>
							<img
								@click="$bvModal.hide('saveparserprofile')"
								class="rotate-on-hover pointer"
								src="@/assets/newdesign/dashboard/blueCross.svg"
								alt=""
								id="hideinmobile"
							/>
						</div>
						<div class="w95 mt-2" :class="{ 'w-100': !isLaptop }">
							<label id="hideinmobile" class="teams-label-font w-40"
								>Profile Name<span class="asterik">*</span></label
							>
							<b-form-input
								placeholder="Enter name of the resume"
								type="text"
								:class="
									$v.parserProfileinput.$error ||
									resumeClinicerror ||
									parserProfileinput.length > 20
										? 'laptopinput-error'
										: 'laptopinput'
								"
								v-model="$v.parserProfileinput.$model"
							>
							</b-form-input>
							<div v-if="resumeClinicerror" class="candash-errortxt">
								Profile name already exists
							</div>
							<div
								v-else-if="parserProfileinput.length > 20"
								class="candash-errortxt"
							>
								Exceeded the max char length of 20
							</div>
							<div
								v-else-if="
									$v.parserProfileinput.$dirty &&
									!$v.parserProfileinput.required
								"
								class="candash-errortxt w65"
							>
								Required
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr
				style="border-top: 1px solid rgb(153 157 163)"
				class="mt-1 mb-0"
				id="hideinmobile"
			/>
			<div
				class="w-100 d-flex justify-content-end"
				:class="isLaptop ? 'p-3' : 'p-0'"
			>
				<div class="position-relative" :class="{ 'mt-3': !isLaptop }">
					<b-button
						:style="buttonLoader ? 'width: 96px;height: 32px;opacity:0.5' : ''"
						class="candash-addBtn"
						@click="saveresumeParserprofile()"
						>{{ buttonLoader ? "" : "Save" }}</b-button
					>
					<div v-if="buttonLoader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</b-modal>
		<ResumeClinic
			v-if="showresumeclinic"
			:showModal="showresumeclinic"
			@modalClose="modalClose"
			:showfromhelpsection="true"
			:clinicDatafromhs="resumeClinicData"
		/>
		<ResumeRenameModal :showresumerename="showresumerename" />
	</div>
</template>

<script>
import store from "../../../store";
import ResumeClinic from "@/components/BuilderPage/ResumeclinicModal.vue";
import ResumeRenameModal from "@/components/BuilderPage/ResumeRenameModal.vue";
import ShareProfile from "@/components/Home/shareProfile.vue";
import commonFunc from "@/components/mixin/commonFunction.js";
import "@/assets/globalcss/builderpage.css";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import DonutProgress from "@/components/fixedcomponents/DonutProgress.vue";
import HelpSection from "./HelpSection.vue";
import Notification from "./Notification.vue";
import Template from "./Templates.vue";
import { mapGetters } from "vuex";
import EventBus from "../../../utils/EventBus.js";
import draggable from "vuedraggable";
import PaymentModal from "../modals/Payment.vue";
import successModal from "../../../components/mixin/toast";
import errorModal from "../../../components/mixin/toast";
import warningModal from "../../../components/mixin/toast";
import downloadingModal from "../../../components/mixin/toast";
import pdf from "vue-pdf";
import { getProcessedToken } from "../../../utils/request.js";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import BlueLoader from "../../../components/fixedcomponents/BlueLoader.vue";
import dashboadrdfooter from "./Footer.vue";
import LaptopJobPref from "@/views/JobSearch/LaptopJobPref.vue";
// import KickstartModal from "@/components/BuilderPage/KickstartModal.vue";
import { Capacitor } from "@capacitor/core";
import {
	getCandidateDetail,
	updatePortfolio,
	getUserCreditsData,
	addUserCreditValue,
	checkCustomer,
} from "../../../controllers/dashboard/asynchronous.js";
import {
	formatMonthName,
	candidateName,
} from "../../../controllers/dashboard/helpers.js";
import {
	getProfileCompletion,
	patchProjectsInfo,
	patchCandSkills,
	patchCandEvent,
	patchCandAward,
	patchPortfolio,
	postCandInfo,
	getDeviceActivity,
	getCandInfo,
	saveResume,
	logDownload,
	getResumeTemp,
	setPrimaryProfile,
	patchCandAchieve,
	converterAtsPreview,
	patchCandInterSkills,
	postAllProfiles,
	renameResume,
	getAllProfiles,
	downloadGraphicalResume,
	//For ats resume
	AtsResume,
	postNotifications,
	getNotifications,
	getPromotions,
	getJobPreference,
	getCandidatePrimaryProfile,
	syncParser,
	tempResume,
	markResumeVerified,
	candidateActions,
} from "../../../utils/apiFunctions.js";
import {
	saveResumeValidation,
	saveResumeclinicValidation,
} from "../../../controllers/dashboard/validations";
import previewResume from "./VideoResume/PreviewVideoResume.vue";
import CreateNewProfile from "@/components/BuilderPage/CreateNewProfile.vue";
import FormModal from "@/components/BuilderPage/FormModal.vue";
import Profiles from "@/components/BuilderPage/Profiles.vue";
import UploadResume from "@/components/BuilderPage/UploadResume.vue";
import EducationCard from "@/components/BuilderPage/Cards/EducationCard.vue";
import ExperienceCard from "@/components/BuilderPage/Cards/ExperienceCard.vue";
import SkillCard from "@/components/BuilderPage/Cards/skillCard.vue";
import HobbyCard from "@/components/BuilderPage/Cards/HobbyCard.vue";
import ProjectCard from "@/components/BuilderPage/Cards/ProjectCard.vue";
import AchievementCard from "@/components/BuilderPage/Cards/AchievementCard.vue";
import DeleteModal from "@/components/BuilderPage/DeleteModal.vue";
import PersonalDetailsModal from "@/components/BuilderPage/PersonalDetailsModal.vue";
import SkillModal from "@/components/BuilderPage/SkillModal.vue";
import DiscardModal from "@/components/BuilderPage/DiscardModal.vue";
import {
	checkTabEmpty,
	ifOriginalDataPresent,
	ifOriginalDataPresentCount,
} from "@/controllers/dashboard/mixin/resumebuilder";
import RenameProfile from "@/views/BuilderPage/RenameProfile.vue";
import SetPrimary from "@/views/BuilderPage/SetPrimary.vue";
import DeleteProfile from "@/views/BuilderPage/DeleteProfile.vue";
import ParserCheckModal from "./ParserCheckModal.vue";
import { trackAutoFilledFromResume, trackResumeDownloaded } from '@/utils/posthogHelpers';
export default {
	name: "Dashboard",
	components: {
		ParserCheckModal,
		DeleteProfile,
		SetPrimary,
		RenameProfile,
		LaptopJobPref,
		pdf,
		draggable,
		Template,
		Loader,
		BlueLoader,
		PaymentModal,
		previewResume,
		dashboadrdfooter,
		HelpSection,
		DonutProgress,
		Notification,
		NcdTopContainer,
		CreateNewProfile,
		FormModal,
		EducationCard,
		ExperienceCard,
		SkillCard,
		HobbyCard,
		ProjectCard,
		AchievementCard,
		UploadResume,
		Profiles,
		DeleteModal,
		ShareProfile,
		PersonalDetailsModal,
		DiscardModal,
		SkillModal,
		ResumeClinic,
		ResumeRenameModal,
		// KickstartModal,
	},
	props: {
		// candidateInfo: Object,
	},
	validations() {
		return {
			...saveResumeValidation(this),
			...saveResumeclinicValidation(this),
		};
	},
	data() {
		return {
			loadAtsNor: false,
			showMobVideoScreen: false,
			// showKickstart: false,
			resumeUpdated: false,
			atsResume: null,
			highlightSection: null,
			okayToParse: false,
			sectionRefs: {},
			saveGraphical: false,
			numberOfLines: null,
			deleteProfile: false,
			setPrimary: false,
			renameProfile: false,
			showAllPortfolios: false,
			mobilelastScrollTop: 0,
			showJobPreferance: false,
			profoptions: 7,
			numcard: 15,
			showptag: false,
			showFullContentCand: false,
			showloader: false,
			showDashboard: true,
			showAllProfileModal: false,
			showCreateNewMProfileModal: false,
			showUploadResumeModal: false,
			showForm: false,
			showSkillModal: false,
			discardModal: false,
			isCreatingNewProfile: false,
			formType: "",

			candidateInfo: {
				firstName: "",
				lastName: "",
				headline: "",
				designation: "",
				email: "",
				city: "",
				profileSummary: "",
				currentCTC: null,
				currentAddress: null,
				experienceLevel: null,
				industry: "IT/ITES",
				permanentAddress: null,
				dateOfBirth: "",
				expectedCTC: null,
				maritalStatus: null,
				phoneNumber: null,
				altPhoneNumber: null,
				placeOfBirth: null,
				totalYearsOfExp: null,
				weddingDate: null,
				portfolio: [],
				educationalInfo: [],
				experience: [],
				projects: [],
				skills: [],
				domain: [],
				achievement: [],
				resume: null,
				link: null,
			},
			selectedData: {},
			showNotSavedProfile: false,
			referalCode: null,
			selectedAchieveTab: null,
			firstTime: null,
			selectedForm: {},
			tmpExpLevel: null,
			tmpIndusLevel: null,
			isPrimary: false,
			avatarText: "",
			chkPinkFill: false,
			showText: false,
			showtstdiv: false,
			shareClick: false,
			linkCopied: false,
			showAboutMe: true,
			//Referral Count
			totalReferalCount: null,
			selectedTemplateID: null,
			customerID: null,
			openGraphBuy: false,
			openAtsBuy: false,
			showAtsBuy: false,
			downloadFreeAtsLoader: false,
			payementClicked: false,
			waterMarkedATS: null,

			saveAndDownloadResumeLoading: false,
			templateCovers: [],

			isUpdatingAtsResume: false,
			showDeleteTooltip: false,
			initialLocalCandidateInfo: {},
			initialAtsLocalCandidateInfo: {},
			upToDateKeys: [
				"achievement",
				"active",
				"altCountryCode",
				"altPhoneNumber",
				"awards",
				"city",
				"country",
				"countryCode",
				"currentAddress",
				"currentCTC",
				"dateOfBirth",
				"designation",
				"displayEmail",
				"educationalInfo",
				"email",
				"events",
				"expectedCTC",
				"experience",
				"experienceLevel",
				"firstName",
				"gender",
				"hobbies",
				"imagePath",
				"industry",
				"interpersonalSkills",
				"languages",
				"lastName",
				"link",
				"maritalStatus",
				"nationality",
				"noticePeriod",
				"permanentAddress",
				"phoneNumber",
				"portfolio",
				"profileSummary",
				"projects",
				"sameAsCurrentAddress",
				"skills",
				"state",
				"totalYearsOfExp",
				"willingToRelocate",
				"willingToRelocateTo",
				"workType",
			],
			resumeexpandGraph: false,
			resumeexpand: false,
			showAtsResume: false,
			showAtsResumeIndex: null,
			isSettingTab: false,
			noScroll: false,
			resumeNameNew: "",
			isRenaming: false,
			showDownloadTooltip: false,
			isDeletingResume: false,
			isDeletingPrimary: false,
			isSettingPrimary: false,

			selectedProfile: "",

			mainDashHeight: 0, // Initialize mainDashHeight
			windowHeight: window.innerHeight,
			demographicsLoop: 2,
			loopvar: 8,
			showTaskBarShimmer: false,
			personalCharacterLimit: null,
			isDownloading: false,
			isTemplateLoaded: false,
			isOnResumeDiv: false,
			isAnyEmptyMandetoryField: null,
			finalIndexToCheckPinkFill: null,
			createVideo: false,
			checkAllPinkBox: false,
			drag3: false,
			localCandidateInfo: {},
			sysCheck: true,
			previewVideo: false,
			previewAts: false,
			previewGraphical: false,
			preventScrollOnWatcher: false,
			hideDiscardModal: null,
			showProgressBar: false,
			progressPercentage: 0,
			time: 0,
			progressTime: 0,
			drag1: false,
			drag2: false,
			lastScrollTop: 0,
			showTaskBar: true,
			openCreateButton: false,
			pdfPreview: false,
			showMoreHighlight: [],
			showMoreResponsibility: [],
			showMoreResponsibilityParser: [],
			email: null,
			loading: false,
			oldProfile: true,
			openInsideAch: false,
			openachiev: false,
			openPortfolio: false,
			openInsidePro: false,
			openInsideProPortfolio: false,
			openInsideProProject: {},
			openInsideProCerti: {},
			openInsideProAward: {},
			openInsideProEvent: {},

			template1Loading: false,
			template2Loading: false,
			template3Loading: false,
			template4Loading: false,
			template1: {},
			template2: {},
			template3: {},
			template4: {},
			selectedTemplate: {},

			openproject: false,
			openskill: false,
			openexperience: false,
			openeducation: false,
			opendemographic: true,

			loopVar2: 2,
			demo2form: false,
			candidateProgress: null,
			currentPage: 1,
			currentPageAtsModal: 1,
			currentPageAts: 0,
			numPages: 0,
			perPage: 1,
			opentabs: false,
			openbasic: false,
			openedu: false,
			openexp: false,
			opendom: false,
			openachiv: false,
			openpro: true,
			openport: false,
			openResume: false,
			selectedTab: "education",
			selectedTabOnCrud: null,
			modalType: "add",
			loaderStatus: false,
			delCheck: true,
			showBasicModal: false,
			showBasicModalFullNew: false,
			showPortfolioModal: false,
			showPortfolioModalNew: false,
			showEducationModal: false,
			showExperienceModal: false,
			showProjectModal: false,
			showProjectModalNew: false,
			showSkillsModal: false,
			showSkillsModalNew: false,
			showDomainModal: false,
			showAchieveModal: false,
			showAchieveModalNew: false,
			camera: false,
			deleteContent: {
				name: null,
				funcName: null,
				id: null,
				callback: null,
			},
			myDeleteContent: {
				data: {},
				fullData: [],
				callback: null,
			},
			editData: {},
			allAddedData: {},
			editFullData: {},
			svgList: [],
			uploadPortfolio: [],
			hobyNameListData: [],
			hobyNameParserData: [],
			skillAdded: [],
			skillAddedParser: [],
			portfolioAddedParser: [],
			templateResume: [],
			InterskillAdded: [],
			resumeName: "",
			saveAs: false,
			firstDownload: false,
			saveResumeLoading: false,
			updateResumeLoading: false,
			resumeErrorMessage: null,
			ifProfileNameExist: false,
			templateResumelinks: [],
			templateResumecount: 0,
			currentFullPdfUrl: null,
			checkAtsLength: false,
			currentFullPdfUrlModal: null,
			currentFullPdfUrls: [],
			currentFullPdfUrlsModal: [],
			selectedindexResume: 0,
			selectedResumeToDownload: null,
			selectedindex: -1,
			saveAsNewAts: false,
			selectedAtsResume: "",
			selectedAtsResumeOnClick: "",
			atsPreviewView: false,
			saveAtsResumeLoading: false,
			showPayment: false,
			allProfiles: [],
			creditData: {},
			downloadType: null,
			startDownload: false,
			allProfileList: [],
			allProfileListNum: null,
			//For shimmer
			showShimmerBasicModal: false,
			showShimmerEduModal: false,
			showShimmerExpModal: false,
			showShimmerSkillModal: false,
			showShimmerProjectModal: false,
			showShimmerAchieveModal: false,
			showShimmerPortModal: false,
			showResumePreview: false,
			selectedCard: null,
			mobCreateNewProfile: false,
			showDeleteModal: false,
			selectedParserTab: "award",
			featureNotAvailable: null,
			parserProfileinput: "",
			saveparserprofile: false,
			buttonLoader: false,
			resumeClinicerror: false,
			overallScore: null,
			resumeClinicData: {},
			showresumeclinic: false,
			showresumerename: false,
			loadingData: true,
		};
	},
	mixins: [
		successModal,
		errorModal,
		warningModal,
		downloadingModal,
		commonFunc,
	],
	async created() {
		if (
			this.$route.query.openResumeClinic === "true" ||
			this.$route.query.openResumeClinic === true ||
			this.$route.query.downloadReport === "true" ||
			this.$route.query.downloadReport === true
		) {
			if (
				this.$route.query.downloadReport === "true" ||
				this.$route.query.downloadReport === true
			) {
				this.$store.commit("userVUEX/setDownloadReport", true);
			}
			if (
				this.$route.query.openResumeClinic === "true" ||
				this.$route.query.openResumeClinic === true
			) {
				this.$store.commit("userVUEX/setShowResumeClinic", true);
			}
		}
		this.showloader = true;
		this.showTaskBarShimmer = true;
		if (
			this.$route?.query?.uuid ||
			(this.$route?.query?.uuid && this.$route?.query?.resumeJobid)
		) {
			// this.$store.commit("userVUEX/SET_RESUME_UUID", this.$route.query.uuid);
			let payload = {
				createNew: false,
				clone: [],
			};
			// this.candidateInfoState._id != null
			// 	? {
			// 			profileName: '',
			// 			createNew: false,
			// 			clone: [],
			// 			_id: this.candidateInfoState._id,
			// 	  }
			// 	:

			const res = await postAllProfiles(payload);

			if (res.status === 201) {
				let payload2 = {
					id: res.data.data._id,
					uuid: this.$route.query.uuid,
				};
				let res2 = null;
				const maxRetries = 10;
				const retryDelay = 3000;
				for (let attempt = 0; attempt < maxRetries; attempt++) {
					try {
						res2 = await syncParser(payload2);
						if (res2.status === 200) break;
					} catch (e) {
						// ignore and retry
					}
					if (attempt < maxRetries - 1) {
						await new Promise((resolve) => setTimeout(resolve, retryDelay));
					}
				}
				this.buttonLoader = false;
				this.saveparserprofile = false;

				if (res2.status === 200) {
					store.state.userVUEX.resumeClinic_uuid = null;
					store.state.candidateVUEX.candidateInfo._id = res.data.data._id;
					const res3 = await getProfileCompletion(
						this.primaryCandidateInfo._id
					);
					console.log(res3.data.data, "the response");
					this.$store.commit(
						"candidateVUEX/updateCandidateProgressPrimary",
						res3.data.data
					);

					// this.getCommonFuncForProfile();
					// if (!this.isLaptop) {
					this.$router.replace({
						path: this.$route.path,
						query: {
							...this.$route.query,
							uuid: undefined,
							type: "resumeClinic",
						},
					});
					// }
				}
			}
		} else {
			this.$store.commit("userVUEX/SET_RESUME_UUID", null);
		}
		this.getclinicData();
		EventBus.$on("show-success", this.showSuccess);
		this.firstTime = true;

		await this.getCandidateDetailCand();
		this.getCommonFuncForProfile(false);
		this.setInitialLocalCandidateInfo();
		this.setInitialAtsLocalCandidateInfo();
		getUserCreditsData(this);
		// this.getJobPreference();
		this.primaryProfileUpd();
		if (this.$route.query.check === "true") {
			this.isAllMandTabsFilled();
		}
		if (this.$route.query.openfrom == "openSkills") {
			this.openSkillsFormOnly();
		}
		this.getAllProfiles();
		// this.$root.$on("route-changed", ({ to, from }) => {
		// 	this.showKickstart = false;
		// 	localStorage.removeItem("kickstart_force_show");
		// });
		setTimeout(() => {
			this.scrollToFirstSection();
			if (this.$route.params.type === "videoSnap") {
				this.$nextTick(() => {
					if (this.$refs.resumeDiv) {
						this.videoSnaps();
					}
				});
			}
		}, 500);
		this.loadingData = false;
		if (
			this.$route.query.openResumeClinic === "true" ||
			this.$route.query.openResumeClinic === true ||
			this.$route.query.downloadReport === "true" ||
			this.$route.query.downloadReport === true ||
			this.$store.getters["userVUEX/getShowResumeClinic"] ||
			this.$store.getters["userVUEX/getDownloadReport"]
		) {
			// Only open clinic if onboarding is complete. If the user registered
			// from Resume Clinic but hasn't finished onboarding yet, the onboarding
			// modal will handle opening the clinic via handleOnboardingClose.
			const onboardingDone =
				this.$store.getters["userVUEX/getOnboardingCompleted"];
			if (
				onboardingDone &&
				(!this.$route.query.fromWebsite || !this.isLaptop)
			) {
				this.showresumeclinic = true;
				setTimeout(() => {
					this.$store.commit("userVUEX/setShowResumeClinic", false);
					const query = { ...this.$route.query };
					delete query.openResumeClinic;
					delete query.downloadReport;
					this.$router
						.replace({ path: this.$route.path, query })
						.catch(() => {});
				}, 1000);
			}
		}
	},
	mounted() {
		this.candidateInfoWatcher = this.$watch(
			"candidateInfo",
			this.chkFilledDetails
		);
		EventBus.$on("checkDownloadCriteria", this.checkDownloadForm);
		EventBus.$on("create-new-profile", this.mobileCreateNewProfile);
		EventBus.$on("update-data", this.updateData);
		EventBus.$on("open-resume-clinic", ({ downloadReport } = {}) => {
			if (downloadReport) {
				this.$store.commit("userVUEX/setDownloadReport", true);
			}
			this.showresumeclinic = true;
		});
		EventBus.$on("onboarding-complete", this.reloadAfterOnboarding);

		this.setProfileIdCand();
		// EventBus.$on("toggleAboutMe", this.updateMainDashHeight);
		window.addEventListener("resize", this.handleResize);

		EventBus.$on("passReffCount", this.getReffCount);
		EventBus.$on("openSkForm", this.openSkillsFormOnly);
		EventBus.$on("updateUserInfo", this.updateUserInfo);
		this.getPromotions();
		this.updateMainDashHeight();
		if (sessionStorage.getItem("showUploadResumeModal") === "true") {
			this.showUploadResumeModal = true;
		}
		setTimeout(() => {
			if (this.previewState) {
				console.log("calling preview");
				this.PreviewResumevideo();
			}
			// this.openSkillsFormOnly();
		}, 2500);
	},
	watch: {
		showUploadResumeModal(val) {
			if (val) {
				sessionStorage.setItem("showUploadResumeModal", "true");
			} else {
				sessionStorage.removeItem("showUploadResumeModal");
			}
		},
		startDownload(val) {
			if (val == true) {
				getUserCreditsData(this);
				this.openGraphBuy = false;
				this.openAtsBuy = false;
			}
		},
		previewAts() {
			if (this.previewAts && !this.selectedResumeToDownload) {
				this.atsPreviewView = true;
				(this.selectedindex = -1),
					(this.selectedindexResume = 0),
					(this.templateResumecount = 0),
					(this.currentFullPdfUrl = null),
					(this.currentFullPdfUrls = []),
					this.templateResume.map((data) => {
						data.resumeDataUrls = [];
					});
				this.$nextTick(() => {
					if (this.$refs.resumeDiv) {
						if (!this.preventScrollOnWatcher) {
							this.$refs.resumeDiv.scrollIntoView({
								behavior: "smooth",
							});
						}
					} else {
						console.error("Ref 'resumeDiv' is not available.");
					}
					this.preventScrollOnWatcher = false;
				});
				this.getAllAtsTemplates();
			} else if (this.previewAts) {
				this.atsPreviewView = true;
				this.$nextTick(() => {
					this.renderAtsCovers();
				});
			} else {
				this.atsPreviewView = false;
			}
		},
		candidateInfo: {
			handler(oldValue, newValue) {
				this.localCandidateInfo = oldValue;
			},
			deep: true,
		},
		localCandidateInfo(val) {
			console.log(val, "**************");
		},
		// // your progress watcher: only show modal when profile hasn't already seen it
		// progressValue: {
		// 	async handler(newVal) {
		// 		if (typeof newVal === "number" && !isNaN(newVal)) {
		// 			if (this.isProgressSufficient) {
		// 				const profileId = this.getPrimaryProfileId();
		// 				const shownProfiles = JSON.parse(
		// 					localStorage.getItem("kickstart_shown_profiles") || "[]"
		// 				);
		// 				const hasClosedKickstartModal =
		// 					this.userInfo?.customFields?.completedActions?.includes(
		// 						"KickstartModalClosed"
		// 					);

		// 				// Check if all mandatory fields are filled
		// 				const areMandatoryFieldsFilled = await this.checkMandatoryFields(
		// 					false
		// 				);

		// 				if (
		// 					!shownProfiles.includes(profileId) &&
		// 					!hasClosedKickstartModal &&
		// 					areMandatoryFieldsFilled
		// 				) {
		// 					// open modal and persist for reload
		// 					this.showKickstart = true;
		// 					shownProfiles.push(profileId);
		// 					localStorage.setItem(
		// 						"kickstart_shown_profiles",
		// 						JSON.stringify(shownProfiles)
		// 					);
		// 					localStorage.setItem(
		// 						"kickstart_force_show",
		// 						JSON.stringify({ profileId, ts: Date.now() })
		// 					);
		// 				}
		// 			} else {
		// 				// not sufficient -> make sure modal is hidden and not persisted
		// 				this.showKickstart = false;
		// 				localStorage.removeItem("kickstart_force_show");
		// 			}
		// 		}
		// 	},
		// 	immediate: true,
		// }, // },
	},
	beforeDestroy() {
		// Remove event listener when the component is destroyed
		window.removeEventListener("resize", this.handleResize);
		EventBus.$off("show-success", this.showSuccess);
		EventBus.$off("update-data", this.updateData);
	},

	computed: {
		isResumeMissing() {
			const { atsResume } = this.candidateInfoState;
			return Object.keys(atsResume).length === 0;
		},
		progressValue() {
			return this.candidateProgress;
		},
		isProgressSufficient() {
			const level = this.localCandidateInfo.experienceLevel;
			const progress = this.candidateProgress;
			const primary = this.localCandidateInfo.primary;

			if (level === "student" && primary) return progress >= 45;
			if (level === "fresher" && primary) return progress >= 45;
			if ((level === "intermediate" || level === "senior") && primary)
				return progress >= 70;
			return false;
		},
		// isKickstartSufficient() {
		// 	const level = this.localCandidateInfo.experienceLevel;
		// 	const progress = this.candidateProgress;
		// 	if (level === "fresher") return !(progress >= 45);
		// 	if (level === "intermediate" || level === "senior") return progress >= 70;
		// 	return false;
		// },
		shouldShowDiv() {
			return this.isResumeMissing && this.isProgressSufficient;
		},
		overAllRating() {
			const overallScore =
				this.candidateInfoState?.resume_clinic_analysis?.overall?.rating;
			if (overallScore === 1) {
				return "Amazing";
			} else if (overallScore === 2) {
				return "Good";
			} else if (overallScore === 3) {
				return "Okay";
			} else {
				return "Fair";
			}
		},
		getMeterClass() {
			const score = parseInt(
				this.candidateInfoState?.resume_clinic_analysis?.overall?.rating
			);
			switch (score) {
				case 1:
					return "mobamazing-dial";
				case 2:
					return "mobgood-dial";
				case 3:
					return "mob-okaydial";
				case 4:
					return "mob-fairdial";
			}
		},
		displayPortfolio() {
			const limit = this.isLaptop ? 4 : 2;
			let portfolio =
				this.localCandidateInfo && this.localCandidateInfo.portfolio
					? this.localCandidateInfo.portfolio
					: [];
			return this.showAllPortfolios ? portfolio : portfolio.slice(0, limit);
		},
		hasMorePortfolio() {
			const limit = this.isLaptop ? 4 : 2;
			return (
				this.localCandidateInfo.portfolio.length > limit &&
				!this.showAllPortfolios
			);
		},
		remainingPortfolioCount() {
			const limit = this.isLaptop ? 4 : 2;
			return Math.max(0, this.localCandidateInfo.portfolio.length - limit);
		},
		totalEducation() {
			const nonParserEducation = (
				this.localCandidateInfo?.educationalInfo || []
			).filter((education) => !education.parser);
			return nonParserEducation.length;
		},
		totalParseEducation() {
			const parserEducation = this.localCandidateInfo.educationalInfo.filter(
				(education) => education.parser
			);
			return parserEducation.length;
		},
		nonParserEducations() {
			const nonParserEducation = this.localCandidateInfo.educationalInfo.filter(
				(education) => !education.parser
			);
			if (!this.isLaptop) {
				return this.totalParseEducation == 0
					? nonParserEducation.slice(0, 2)
					: this.totalParseEducation > 0
					? nonParserEducation.slice(0, 1)
					: nonParserEducation.slice(0, 2);
			}
			return nonParserEducation;
		},
		parserEducations() {
			const parserEducation = (
				this.localCandidateInfo?.educationalInfo || []
			).filter((education) => education.parser);
			if (!this.isLaptop) {
				return this.totalEducation == 0
					? parserEducation.slice(0, 2)
					: this.totalEducation > 0
					? parserEducation.slice(0, 1)
					: parserEducation.slice(0, 2);
			}

			return parserEducation;
		},
		totalExperience() {
			const nonParserExperience = (
				this.localCandidateInfo?.experience || []
			).filter((experience) => !experience.parser);
			return nonParserExperience.length;
		},
		totalParseExperience() {
			const parserExperience = this.localCandidateInfo.experience.filter(
				(experience) => experience.parser
			);
			return parserExperience.length;
		},
		nonParserExperiences() {
			const nonParserExperience = this.localCandidateInfo.experience.filter(
				(experience) => !experience.parser
			);
			if (!this.isLaptop) {
				return this.totalParseExperience == 0
					? nonParserExperience.slice(0, 2)
					: this.totalParseExperience > 0
					? nonParserExperience.slice(0, 1)
					: nonParserExperience.slice(0, 2);
			}

			return nonParserExperience;
		},
		parserExperiences() {
			const parserExperience = (
				this.localCandidateInfo?.experience || []
			).filter((experience) => experience.parser);
			if (!this.isLaptop) {
				return this.totalExperience == 0
					? parserExperience.slice(0, 2)
					: this.totalExperience > 0
					? parserExperience.slice(0, 1)
					: parserExperience.slice(0, 2);
			}

			return parserExperience;
		},
		totalTechSkills() {
			const nonParserTechSkills = (
				this.localCandidateInfo?.skills || []
			).filter((techSkill) => !techSkill.parser);
			return nonParserTechSkills.length;
		},
		totalParserTechSkills() {
			const parserTechSkills = this.localCandidateInfo.skills.filter(
				(techSkill) => techSkill.parser
			);
			return parserTechSkills.length;
		},
		nonParserTechSkills() {
			const nonParserTechSkills = this.localCandidateInfo.skills.filter(
				(techSkill) => !techSkill.parser
			);
			if (!this.isLaptop) {
				return this.totalParserTechSkills == 0
					? nonParserTechSkills.slice(0, 2)
					: this.totalParserTechSkills > 0
					? nonParserTechSkills.slice(0, 1)
					: nonParserTechSkills.slice(0, 2);
			}

			return nonParserTechSkills;
		},
		parserTechSkills() {
			const parserTechSkills = (this.localCandidateInfo?.skills || []).filter(
				(techSkill) => techSkill.parser
			);
			if (!this.isLaptop) {
				return this.totalTechSkills == 0
					? parserTechSkills.slice(0, 2)
					: this.totalTechSkills > 0
					? parserTechSkills.slice(0, 1)
					: parserTechSkills.slice(0, 2);
			}

			return parserTechSkills;
		},
		totalInterSkills() {
			const nonParserInterSkills = (
				this.localCandidateInfo?.interpersonalSkills || []
			).filter((interSkill) => !interSkill.parser);
			return nonParserInterSkills.length;
		},
		totalParserInterSkills() {
			const parserInterSkills =
				this.localCandidateInfo.interpersonalSkills.filter(
					(interSkill) => interSkill.parser
				);
			return parserInterSkills.length;
		},
		nonParserInterSkills() {
			const nonParserInterSkills =
				this.localCandidateInfo.interpersonalSkills.filter(
					(interSkill) => !interSkill.parser
				);
			if (!this.isLaptop) {
				return this.totalParserInterSkills == 0
					? nonParserInterSkills.slice(0, 2)
					: this.totalParserInterSkills > 0
					? nonParserInterSkills.slice(0, 1)
					: nonParserInterSkills.slice(0, 2);
			}

			return nonParserInterSkills;
		},
		parserInterSkills() {
			const parserInterSkills = (
				this.localCandidateInfo?.interpersonalSkills || []
			).filter((interSkill) => interSkill.parser);
			if (!this.isLaptop) {
				return this.totalInterSkills == 0
					? parserInterSkills.slice(0, 2)
					: this.totalInterSkills > 0
					? parserInterSkills.slice(0, 1)
					: parserInterSkills.slice(0, 2);
			}

			return parserInterSkills;
		},
		parserHobbies() {
			const hobbies = this.localCandidateInfo?.parserHobbies || [];
			if (!this.isLaptop) {
				return hobbies.slice(0, 2);
			}
			return hobbies;
		},
		totalProjects() {
			const nonParserProjects = (
				this.localCandidateInfo?.projects || []
			).filter((project) => !project.parser);
			return nonParserProjects.length;
		},
		totalParserProjects() {
			const parserProjects = this.localCandidateInfo.projects.filter(
				(project) => project.parser
			);
			return parserProjects.length;
		},
		nonParserProjects() {
			const nonParserProjects = this.localCandidateInfo.projects.filter(
				(project) => !project.parser
			);
			if (!this.isLaptop) {
				return this.totalParserProjects == 0
					? nonParserProjects.slice(0, 2)
					: this.totalParserProjects > 0
					? nonParserProjects.slice(0, 1)
					: nonParserProjects.slice(0, 2);
			}

			return nonParserProjects;
		},
		parserProjects() {
			const parserProjects = (this.localCandidateInfo?.projects || []).filter(
				(project) => project.parser
			);

			if (!this.isLaptop) {
				return this.totalProjects == 0
					? parserProjects.slice(0, 2)
					: this.totalProjects > 0
					? parserProjects.slice(0, 1)
					: parserProjects.slice(0, 2);
			}
			return parserProjects;
		},

		nonParserAwards() {
			const nonParserAward = this.localCandidateInfo.awards.filter(
				(award) => !award.parser
			);
			if (!this.isLaptop) {
				return nonParserAward.slice(0, 2);
			}

			return nonParserAward;
		},
		nonParserCertificates() {
			const nonParserCerti = this.localCandidateInfo.achievement.filter(
				(award) => !award.parser
			);
			if (!this.isLaptop) {
				return nonParserCerti.slice(0, 2);
			}

			return nonParserCerti;
		},
		nonParserEvents() {
			const nonParserEvent = this.localCandidateInfo.events.filter(
				(award) => !award.parser
			);
			if (!this.isLaptop) {
				return nonParserEvent.slice(0, 2);
			}

			return nonParserEvent;
		},
		parserAchievement() {
			const parserAchieve = (this.localCandidateInfo?.achievement || []).filter(
				(award) => award.parser
			);
			if (!this.isLaptop) {
				return parserAchieve.slice(0, 2);
			}

			return parserAchieve;
		},
		truncatedProfileSummary() {
			return this.showFullContentCand
				? this.candidateInfo.profileSummary
				: this.candidateInfo.profileSummary.slice(0, 256);
		},
		truncatedMobProfileSummary() {
			return this.showFullContentCand
				? this.candidateInfo.profileSummary
				: this.candidateInfo.profileSummary.slice(0, 100);
		},
		isNotProfileFilled() {
			return (
				!this.candidateInfo.firstName ||
				!this.candidateInfo.lastName ||
				!this.candidateInfo.city ||
				!this.candidateInfo.phoneNumber ||
				!this.candidateInfo.experienceLevel

				// !this.candidateInfo.profileSummary ||
				// !this.candidateInfo.headline ||
				// !this.candidateInfo.designation ||
			);
		},

		atsPreviewViewUpdate() {
			let currentLocalCandidateInfo = {};

			for (let key of Object.keys(this.initialAtsLocalCandidateInfo)) {
				currentLocalCandidateInfo[key] = this.localCandidateInfo[key];
			}

			return (
				JSON.stringify(currentLocalCandidateInfo) !==
				JSON.stringify(this.initialAtsLocalCandidateInfo)
			);
		},
		upToDateLocal() {
			let currentLocalCandidateInfo = {};

			for (let key of Object.keys(this.initialLocalCandidateInfo)) {
				currentLocalCandidateInfo[key] = this.localCandidateInfo[key];
			}

			return (
				JSON.stringify(currentLocalCandidateInfo) ===
				JSON.stringify(this.initialLocalCandidateInfo)
			);
		},

		belowDashHeight() {
			if (this.selectedTab == "resume") {
				this.hideAboutMe();
			}
			const divElement = document.getElementById("cand-name");
			if (divElement) {
				const computedStyle = window.getComputedStyle(divElement);
				const lineHeight = parseFloat(computedStyle.lineHeight); // Get the line height in pixels
				const divHeight = divElement.clientHeight; // Get the height of the div in pixels
				const numberOfLines = Math.round(divHeight / lineHeight); // Calculate the number of lines
				var basediv =
					numberOfLines == 1 ? "158px" : numberOfLines == 2 ? "162px" : "163px";
			}
			// Calculate the height of belowdash dynamically
			return (this.previewAts ||
				this.previewGraphical ||
				this.previewAts ||
				this.previewVideo ||
				this.sysCheck ||
				this.createVideo) &&
				this.isOnResumeDiv
				? `calc(100vh - 70px)`
				: `calc(100vh - ${this.mainDashHeight + 5}px - ${basediv})`;
		},

		...mapGetters("candidateVUEX", {
			progress: "getCandProgressResp",
			progressPrimary: "getCandProgressRespPrimary",
			// allValidation: "getAllValidation",
			toggleNotification: "getToggleNotification",
			candidateInfoState: "getcandidateInfo",
			previewState: "getPreviewResume",
			getcandidateInfo: "getcandidateInfo",
			primaryCandidateInfo: "getPrimaryCandidateInfo",
			isOnboardingActive: "getIsOnboardingActive",
		}),
		...mapGetters("userVUEX", {
			userEmail: "getUserEmail",
			userName: "getUserName",
			userInfo: "getUserInfo",
		}),
		checkIfGraphicalResumeExist() {
			return false;
		},
		checkDownloadCondition() {
			if (this.userInfo.PAYMENT_REQUIRED) {
				if (this.creditData.type == "free") {
					return true;
				} else {
					return this.creditData.credits < this.creditData.templateCost;
				}
			} else {
				return false;
			}
		},
	},
	updated() {
		this.updateMainDashHeight();
	},
	methods: {
		async updateUserInfo(){
			await getUserCreditsData(this)
		},
		isMobileApp(){
			return Capacitor.isNativePlatform();
		},
		async reloadAfterOnboarding({
			openResumeClinic = false,
			downloadReport = false,
		} = {}) {
			if (downloadReport) {
				this.$store.commit("userVUEX/setDownloadReport", true);
			}
			this.showloader = true;
			this.showTaskBarShimmer = true;

			// ── Step 1: postAllProfiles + syncParser (mirrors created() uuid block) ──
			if (
				this.$route?.query?.uuid ||
				(this.$route?.query?.uuid && this.$route?.query?.resumeJobid)
			) {
				const payload = { createNew: false, clone: [] };
				const res = await postAllProfiles(payload);

				if (res.status === 201) {
					const payload2 = {
						id: res.data.data._id,
						uuid: this.$route.query.uuid,
					};
					let res2 = null;
					const maxRetries = 10;
					const retryDelay = 3000;
					for (let attempt = 0; attempt < maxRetries; attempt++) {
						try {
							res2 = await syncParser(payload2);
							if (res2.status === 200) break;
						} catch (e) {
							// ignore and retry
						}
						if (attempt < maxRetries - 1) {
							await new Promise((resolve) => setTimeout(resolve, retryDelay));
						}
					}
					this.buttonLoader = false;
					this.saveparserprofile = false;

					if (res2 && res2.status === 200) {
						store.state.userVUEX.resumeClinic_uuid = null;
						store.state.candidateVUEX.candidateInfo._id = res.data.data._id;
						const res3 = await getProfileCompletion(
							this.primaryCandidateInfo._id
						);
						this.$store.commit(
							"candidateVUEX/updateCandidateProgressPrimary",
							res3.data.data
						);
						this.$router.replace({
							path: this.$route.path,
							query: {
								...this.$route.query,
								uuid: undefined,
								type: "resumeClinic",
							},
						});
					}
				}
			} else {
				this.$store.commit("userVUEX/SET_RESUME_UUID", null);
			}

			// ── Step 2: fetch candidate data, then read clinic data from store ──
			this.firstTime = true;
			await this.getCandidateDetailCand();
			// getclinicData reads candidateInfoState.resume_clinic_analysis —
			// must run after getCandidateDetailCand() so the store is populated.
			this.getclinicData();
			this.getCommonFuncForProfile(false);
			this.setInitialLocalCandidateInfo();
			this.setInitialAtsLocalCandidateInfo();
			getUserCreditsData(this);
			this.primaryProfileUpd();
			this.getAllProfiles();
			setTimeout(() => {
				this.scrollToFirstSection();
			}, 500);
			this.loadingData = false;
			if (openResumeClinic || downloadReport) {
				this.showresumeclinic = true;
			}
		},
		// closeKickstartModal() {
		// 	this.showKickstart = false;
		// 	localStorage.removeItem("kickstart_force_show");

		// 	// Call API
		// 	candidateActions({ actionKey: "KickstartModalClosed" })
		// 		.then(() => {
		// 			console.log("Modal close action logged successfully");
		// 		})
		// 		.catch((err) => {
		// 			console.error("Failed to log modal close action:", err);
		// 		});
		// },
		getPrimaryProfileId() {
			return (
				this.localCandidateInfo?._id ||
				// fallback to a deterministic string (not ideal but safe)
				(this.localCandidateInfo?.userID
					? `user_${this.localCandidateInfo.userID}`
					: "unknown_profile")
			);
		},
		// detect if current load is a browser reload (vs SPA navigation)
		isPageReload() {
			try {
				const nav = performance.getEntriesByType?.("navigation");
				if (nav && nav.length) {
					return nav[0].type === "reload" || nav[0].type === "navigate";
				}
				if (performance.navigation) {
					return (
						performance.navigation.type ===
							performance.navigation.TYPE_RELOAD ||
						performance.navigation.type === performance.navigation.TYPE_NAVIGATE
					);
				}
			} catch (e) {}
			return false;
		},
		// async initKickstartState() {
		// 	const profileId = this.getPrimaryProfileId();
		// 	const persisted = JSON.parse(
		// 		localStorage.getItem("kickstart_force_show") || "null"
		// 	);
		// 	const shownProfiles = JSON.parse(
		// 		localStorage.getItem("kickstart_shown_profiles") || "[]"
		// 	);
		// 	const wasReload = this.isPageReload();
		// 	const hasClosedKickstartModal =
		// 		this.userInfo?.customFields?.completedActions?.includes(
		// 			"KickstartModalClosed"
		// 		);

		// 	// Check if all mandatory fields are filled
		// 	const areMandatoryFieldsFilled = await this.checkMandatoryFields(false);

		// 	// If this is a normal SPA navigation (not reload), we should NOT restore persisted modal:
		// 	if (!wasReload) {
		// 		localStorage.removeItem("kickstart_force_show");
		// 	}
		// 	if (
		// 		wasReload &&
		// 		persisted &&
		// 		persisted.profileId === profileId &&
		// 		!hasClosedKickstartModal &&
		// 		areMandatoryFieldsFilled
		// 	) {
		// 		this.showKickstart = true;
		// 	}
		// 	if (
		// 		!shownProfiles.includes(profileId) &&
		// 		this.isProgressSufficient &&
		// 		!hasClosedKickstartModal &&
		// 		areMandatoryFieldsFilled
		// 	) {
		// 		this.showKickstart = true;

		// 		// mark profile as shown so it won't show again for that profile
		// 		shownProfiles.push(profileId);
		// 		localStorage.setItem(
		// 			"kickstart_shown_profiles",
		// 			JSON.stringify(shownProfiles)
		// 		);

		// 		// persist "force show" so it survives page reload
		// 		localStorage.setItem(
		// 			"kickstart_force_show",
		// 			JSON.stringify({ profileId, ts: Date.now() })
		// 		);
		// 	}
		// },

		submitResumeVerification() {
			const payload = {
				id: this.getcandidateInfo._id,
				resumeVerificationClicked: true,
			};
			markResumeVerified(payload)
				.then((res) => {
					console.log("Marked as verified", res);
				})
				.catch((err) => {
					console.error("Error marking verified", err);
				});
			this.okayToParse = true;
		},
		scrollToFirstSection() {
			// Uncomment this line only if you want to block re-scrolling once a section is already highlighted
			// if (this.highlightSection != null && !this.okayToParse) return;

			const sectionMap = [
				{ key: "education", data: this.parserEducations },
				{ key: "experience", data: this.parserExperiences },
				{ key: "techskill", data: this.parserTechSkills },
				{ key: "interskill", data: this.parserInterSkills },
				{ key: "hobby", data: this.parserHobbies },
				{ key: "project", data: this.parserProjects },
				{ key: "achievement", data: this.parserAchievement },
			];

			let found = false;

			for (let { key, data } of sectionMap) {
				if (data && data.length > 0) {
					this.highlightSection = key;
					if (this.localCandidateInfo.customFields.resumeVerificationClicked) {
						this.okayToParse =
							this.localCandidateInfo.customFields.resumeVerificationClicked;
					}

					this.$nextTick(() => {
						setTimeout(() => this.waitForSectionRef(key), 300); // wait for DOM/rendering
					});

					found = true;
					break;
				}
			}

			if (!found) {
				this.highlightSection = null;
			}
		},
		waitForSectionRef(key, attempt = 0) {
			const elArray = this.$refs[key];
			const el = Array.isArray(elArray) ? elArray[0] : elArray;
			const scrollParent = this.isLaptop
				? this.$refs.belowdash
				: this.$refs.mobscrollContainer;

			if (el && scrollParent) {
				const scrollTop = getOffsetRelativeToParent(el, scrollParent);

				scrollParent.scrollTo({
					top: scrollTop,
					behavior: "smooth",
				});
			} else if (attempt < 10) {
				setTimeout(() => this.waitForSectionRef(key, attempt + 1), 100);
			} else {
				console.warn("Could not find element or scroll parent for:", key);
			}

			function getOffsetRelativeToParent(child, parent) {
				const childRect = child.getBoundingClientRect();
				const parentRect = parent.getBoundingClientRect();
				return childRect.top - parentRect.top + parent.scrollTop;
			}
		},
		getclinicData() {
			if (this.candidateInfoState?.resume_clinic_analysis) {
				this.resumeClinicData = this.candidateInfoState.resume_clinic_analysis;
			}
		},
		async openATS() {
			this.noScroll = false;
			await this.checkOverallMandetoryTabsFilledAts(false);
			if (!this.localCandidateInfo.database_demographics) {
				this.showAtserror();
			} else if (
				!this.isAnyEmptyMandetoryField ||
				(Object.keys(this.getcandidateInfo).length > 0 &&
					Object.keys(this.getcandidateInfo.atsResume).length !== 0)
			) {
				this.previewAts = true;
				this.getCandidateDetailCand();
				this.setInitialAtsLocalCandidateInfo();
				this.previewGraphical = false;
				this.templateResumecount = 0;
				this.getAllProfiles();
			} else {
				this.checkDownloadForm();
			}
		},
		selectAtsTab() {
			const hasAtsResume =
				Object.keys(this.getcandidateInfo).length > 0 &&
				Object.keys(this.getcandidateInfo.atsResume).length !== 0;
			if (hasAtsResume) {
				this.previewAts = true;
				this.previewGraphical = false;
				this.previewVideo = false;
				if (!this.selectedResumeToDownload) {
					this.setInitialAtsLocalCandidateInfo();
				}
			} else {
				this.openATS();
			}
		},
		showAtserror() {
			this.errorModal(
				"Error",
				"Please complete the required personal details to ensure a smooth and accurate process!"
			);
		},
		modalClose() {
			this.showresumeclinic = false;
			// this.$router.replace({
			// 	path: this.$route.path,
			// 	query: {
			// 		...this.$route.query,
			// 		type: undefined,
			// 		downloadReport: undefined,
			// 		openResumeClinic: undefined,
			// 	},
			// }).catch(() => {});
		},
		assignSelectedTab(e) {
			this.selectedParserTab = e;
			this.selectedAchieveTab = e;
		},
		handleClickAts() {
			if (this.downloadFreeAtsLoader || this.showAtsBuy) return;
			this.downloadFreeATS();
		},
		async handleClick() {
			this.noScroll = false;
			await this.isAllMandTabsFilled();
			if (!this.isAnyEmptyMandetoryField) {
				this.previewAts = false;
				this.previewGraphical = true;
				this.previewVideo = false;
				if (Object.keys(this.selectedTemplate).length === 0) {
					this.setInitialLocalCandidateInfo();
					this.getAllTemplates();
				} else {
					this.callAllTemplateScripts();
				}
			} else {
				this.showToast();
			}
		},
		showModal() {
			this.mobileCreateNewProfile(!this.mobCreateNewProfile);
		},
		getheaderheight() {
			const divElement = document.getElementById("cand-name");
			console.log("divElement", divElement);
			if (divElement) {
				const computedStyle = window.getComputedStyle(divElement);
				const lineHeight = parseFloat(computedStyle.lineHeight);
				const divHeight = divElement.clientHeight;
				const numberOfLines = Math.round(divHeight / lineHeight);
				return numberOfLines;
			}
			console.warn("Element not found!");
			return 0; // Fallback value
		},
		hideRenameModal() {
			this.mobCreateNewProfile = false;
			this.renameProfile = false;
		},
		hideSetPrimaryModal() {
			this.mobCreateNewProfile = false;
			this.setPrimary = false;
		},
		hideDeleteModal() {
			this.mobCreateNewProfile = false;
			this.deleteProfile = false;
		},
		async primaryProfileUpd() {
			const res = await getCandidatePrimaryProfile();
			if (res.status === 200) {
				this.$store.commit("candidateVUEX/setPrimaryProfile", res.data.data);
			}
		},
		changeProfiles(pId) {
			this.mobCreateNewProfile = false;
			this.showCreateNewMProfileModal = false;
			this.setProfileId(pId);
		},
		showSuccess(event) {
			this.successModal("Successfully added", event);
		},
		mobilehandleScroll() {
			const container = this.$refs.mobscrollContainer;
			const currentScrollTop = container.scrollTop;

			// Compare current and previous scroll positions to determine direction
			if (currentScrollTop > this.mobilelastScrollTop) {
				this.showptag = true;
			} else if (currentScrollTop < this.mobilelastScrollTop) {
				this.showptag = false;
			}

			// Update the last scroll position
			this.mobilelastScrollTop = currentScrollTop;
			console.log(this.showptag);
		},
		async getJobPreference() {
			try {
				const emailID = this.userInfo.email;
				const res = await getJobPreference(emailID);
				if (res.status == 200) {
					if (!res.data.data.submitted) {
						this.$bvModal.show("setupjobpref");
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		togglePortfolioView() {
			this.showAllPortfolios = !this.showAllPortfolios;
		},
		redirectToTheLink(linkCopy) {
			const textarea = document.createElement("textarea");
			textarea.value = linkCopy;
			document.body.appendChild(textarea);
			textarea.select();
			document.body.removeChild(textarea);
			window.open(linkCopy, "_blank");
		},
		formatPortfolioLink(link) {
			let cleanedLink = link.replace(/^(https?:\/\/)?(www\.)?/, "");
			cleanedLink = cleanedLink.replace(/(\.[a-z]{2,3})\S*$/, "$1");

			return cleanedLink;
		},
		handleScroll(event) {
			this.isSettingTab = false;

			// Throttle scroll handling for better performance
			//Don't UNCOMMENT IT UNLESS REQUIRED
			// if (this.isThrottling) return;
			// this.isThrottling = true;
			// setTimeout(() => {
			// 	this.isThrottling = false;
			// }, 200);

			const element = document.getElementById("resumeDiv");
			if (!element) return false;

			const rect = element.getBoundingClientRect();
			const isBottomVisible = rect.bottom <= window.innerHeight;

			if (isBottomVisible) {
				this.isSettingTab = true;
				this.selectedTab = "resume";
				return;
			}

			// Adjust for sticky div height
			const stickyDivHeight = 250;
			const scrollTop = event.target.scrollTop + stickyDivHeight;

			let currentTab = null;
			const sectionRefs = {
				personalDetails: "demographicSection",
				education: "educationSection",
				experience: "experinceSection",
				project: "projectSection",
				skills: "skillSection",
				achievement: "achievementSection",
				portfolio: "portfolioSection",
				demographics: "demographicSection",
				resume: "resumeDiv",
			};

			// Dynamically update the selected tab based on scroll position
			for (const tab in sectionRefs) {
				const sectionRef = sectionRefs[tab];
				const sectionElement = Array.isArray(this.$refs[sectionRef])
					? this.$refs[sectionRef][0]
					: this.$refs[sectionRef];
				if (
					sectionElement &&
					sectionElement.offsetTop <= scrollTop &&
					sectionElement.offsetTop + sectionElement.clientHeight > scrollTop
				) {
					currentTab = tab;
				}
			}

			if (currentTab) {
				this.selectedTab = currentTab;
				const isScrollingDown = scrollTop > this.lastScrollTop;

				// Check if we are on the resume div
				const isOnResumeDiv =
					element &&
					(this.createVideo ||
						this.previewVideo ||
						this.sysCheck ||
						this.previewAts ||
						this.previewGraphical) &&
					scrollTop >= element.offsetTop;
				this.isOnResumeDiv = isOnResumeDiv;

				// Handle UI changes based on scroll position
				if (isOnResumeDiv) {
					this.drag1 = false;
					this.drag2 = true;
					this.showTaskBar = false;
					this.showDashboard = false;
				} else if (isScrollingDown) {
					this.hideAboutMe();
					this.drag1 = true;
					this.drag2 = false;
				} else if (
					this.selectedTab === "education" ||
					this.selectedTab === "personalDetails"
				) {
					this.showAboutMe = true;
					this.showDashboard = true;
					this.drag3 = false;
					this.drag1 = false;
					this.drag2 = false;
					this.showTaskBar = true;
				} else {
					this.hideAboutMe();
					this.showDashboard = true;
					this.drag3 = false;
					this.showTaskBar = true;
				}

				this.lastScrollTop = scrollTop;
			}
		},
		discardAllChangesModal() {
			this.discardModal = false;
			this.showBasicModalFullNew = false;
			this.showForm = false;
			this.selectedData = {};
			this.formType = "";
		},
		ProfileAboutToggle() {
			this.showFullContentCand = !this.showFullContentCand;
		},
		bindPortfolioSrc(portfolio) {
			if (portfolio.portfolioName == "dribbble") {
				return require("@/assets/newbuilder/dribble.svg");
			} else if (portfolio.portfolioName == "behance") {
				return require("@/assets/newbuilder/behance.svg");
			} else if (portfolio.portfolioName == "linkedIn") {
				return require("@/assets/newbuilder/linkedin.svg");
			} else if (
				portfolio.portfolioName == "gitlab" ||
				portfolio.portfolioName == "github"
			) {
				return require("@/assets/newbuilder/gitlab.svg");
			} else {
				return require("@/assets/newbuilder/otherPortfolio.svg");
			}
		},
		openProfileModal() {
			this.showAllProfileModal = true;
		},
		capitalizeFirstLetter(value) {
			if (!value) return "";
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
		async getTopTabsScale() {
			await this.getTopTabsData(this.candidateInfo);
			if (this.scaleTopSuccess) {
				const personalDetails = {
					formID: "personalDetails",
					formName: "Personal Details",
				};
				if (
					!this.passDynamicScale.find(
						(item) => item.formID === "personalDetails"
					)
				) {
					this.passDynamicScale.unshift(personalDetails);
				}
				this.showloader = false;
				await this.showTheDynamicTabs();
			}
		},
		candidateName() {
			return candidateName(this.candidateInfo);
		},
		hideAboutMe() {
			this.showAboutMe = false;
			this.updateMainDashHeight();
		},
		closeShare() {
			this.shareClick = false;
			this.linkCopied = false;
		},
		openShare() {
			if (this.loadingData) return;
			this.shareClick = !this.shareClick;
			if (!this.isPrimary) {
				this.showtstdiv = true;
				setTimeout(() => {
					this.showtstdiv = false;
					this.shareClick = false;
				}, 1000);
			}
			if (!this.shareClick) {
				this.linkCopied = false;
			}
		},
		async setProfileIdCand() {
			this.showBasicModalFullNew = false;
			this.showBasicModalFullNewok = false;
		},
		async getCandidateDetailCand() {
			this.showloader = true;
			this.candidateInfo = await getCandidateDetail();
			if(this.progress.profileCount == 1 && this.candidateInfo.hasOwnProperty("parser") && this.progress.progress == 0){
				let postHogPayload = {
					educationalInfo: this.candidateInfo.educationalInfo.length > 0,
					experience: this.candidateInfo.experience.length > 0,
					skills: this.candidateInfo.skills.length > 0,
					hobbies: this.candidateInfo.parserHobbies.length > 0,
					projects: this.candidateInfo.projects.length > 0,
					achievement: this.candidateInfo.achievement.length > 0
				};

				postHogPayload.totalFilled = Object.values(postHogPayload)
					.filter(value => value === true)
					.length;
				trackAutoFilledFromResume(postHogPayload)
			}
			this.localCandidateInfo = this.candidateInfo;
			this.initialAtsLocalCandidateInfo = this.candidateInfo;
			this.referalCode = this.candidateInfo.referalCode;
			this.$store.commit("candidateVUEX/setCandidateInfo", this.candidateInfo);

			// if (!this.tmpExpLevel) {
			// 	this.tmpExpLevel = this.candidateInfo.experienceLevel;
			// }
			// if (!this.tmpIndusLevel) {
			// 	this.tmpIndusLevel = this.candidateInfo.industry;
			// }
			const candidateName = this.candidateInfo.firstName;
			if (
				this.tmpExpLevel != this.candidateInfo.experienceLevel ||
				this.tmpIndusLevel != this.candidateInfo.industry ||
				this.firstTime
			) {
				this.tmpExpLevel = this.candidateInfo.experienceLevel;
				this.tmpIndusLevel = this.candidateInfo.industry;
				// if (this.candidateInfo.experienceLevel != null) {
				await this.getDynamicMandetoryFields(this.candidateInfo);
				// } else {
				// 	await this.getDynamicMandetoryFields(this.candidateInfo);
				// }
				if (this.candidateInfo.industry != null) {
					await this.getTopTabsScale();
				}
				this.firstTime = false;
			} else {
				this.setCandidateInfoBack(this.candidateInfo);
			}
			this.isPrimary = this.candidateInfo.primary;
			const firstLetter = candidateName.charAt(0).toUpperCase();
			this.avatarText = firstLetter;
			this.$store.commit("userVUEX/SET_USER_NAME", this.candidateName());
			this.$store.commit("userVUEX/setUserDetails", this.candidateInfo.email);
			this.showloader = false;
			this.$forceUpdate();
			// if (Object.keys(this.candidateInfoState.atsResume).length != 0) {
			// 	this.getTemplates();
			// }

			if (this.chkPinkFill) {
				this.chkIfExpChanged();
				this.chkPinkFill = false;
			}
			this.firstTime = false;
			this.numberOfLines = this.getheaderheight();
		},

		// Changed Done until this
		openSkillsFormOnly() {
			const skillForm = this.passDynamicScale.find(
				(obj) => obj.formID === "skills"
			);

			if (skillForm) {
				this.openSkillModal(skillForm);
			} else {
				this.warningModal("Skills", "Something went wrong");
			}
		},
		async checkForAtsCredit(noSave = false) {
			if (
				!this.localCandidateInfo.profileName &&
				(this.$v.resumeName.$invalid || this.resumeName.length > 20)
			) {
				this.$v.resumeName.$touch();
				return;
			}
			await getUserCreditsData(this);
			this.downloadType = "ats";
			this.checkDownloadCondition
				? (this.showModalValues(true), (this.isDownloading = false))
				: this.saveDownloadResumeAtsPreview(noSave);
		},
		async downloadFreeATS() {
			try {
				this.downloadFreeAtsLoader = true;
				await this.saveDownloadResumeAtsPreview(false, true);
				this.downloadFreeAtsLoader = false;
				this.openAtsBuy = false;
			} catch (error) {
				console.log(error);
			}
		},
		async getAtsTemplate() {
			try {
				this.openAtsBuy = true;
				this.showAtsBuy = true;

				const templateName = `template${this.selectedindex + 1}`;

				const [watermarkedRes, normalRes] = await Promise.all([
					getResumeTemp(templateName, true),
					!this.previewAts ? getResumeTemp(templateName, false) : null,
				]);

				this.waterMarkedATS = {
					resumeData: watermarkedRes.data,
					resumeDataUrls: [],
					resumeLink: null,
				};

				await this.renderAtsFromHtml({
					html: watermarkedRes.data,
					templateIndex: this.selectedindex,
					isForModal: true,
					fromHeader: false,
				});

				this.showAtsBuy = false;

				if (normalRes) {
					this.loadAtsNor = true;
					this.templateResume[this.selectedindex] = {
						resumeData: normalRes.data,
						resumeDataUrls: [],
						resumeLink: null,
					};
					this.currentFullPdfUrlsModal = [];
					this.currentFullPdfUrlModal = null;
					this.currentPageAtsModal = 1;

					await this.renderAtsFromHtml({
						html: normalRes.data,
						templateIndex: this.selectedindex,
						isForModal: false,
						fromHeader: true,
					});

					this.currentFullPdfUrlModal =
						this.currentFullPdfUrlsModal[this.currentPageAtsModal - 1];
					this.loadAtsNor = false;
				}
			} catch (error) {
				console.error(error);
				this.showAtsBuy = false;
				this.loadAtsNor = false;
			}
		},
		async renderAtsFromHtml({ html, templateIndex, isForModal, fromHeader }) {
			const blob = new Blob([html], { type: "text/html" });

			const formData = new FormData();
			formData.append("htmlFile", blob);
			formData.append("returnType", "pdf");
			formData.append(
				"outputPath",
				`${this.candidateInfoState._id}_${this.localCandidateInfo.atsResume.templateID}`
			);
			formData.append("ats", true);

			const pdf = await converterAtsPreview(formData);
			const url = URL.createObjectURL(pdf.data);

			const loadingTask = window.pdfjsLib.getDocument({ url });
			const pdfDocument = await loadingTask.promise;

			const numPages = 1;

			await this.renderAtsPdf(
				templateIndex,
				pdfDocument,
				numPages,
				url,
				isForModal,
				fromHeader
			);
		},

		showModalValues(isAts = false) {
			if (this.creditData.credits < this.creditData.templateCost) {
				this.showPaymentModal();
			} else {
				if (isAts) {
					this.getAtsTemplate();
				} else {
					this.openGraphBuy = true;
				}
			}
		},
		async getPromotions() {
			let payload = {
				promoCode:
					this.userInfo && Object.keys(this.userInfo.offers).length != 0
						? this.userInfo.offers.code
						: null,
			};
			const res = await getPromotions(payload);
			if (res.status == 200) {
				this.$store.commit("userVUEX/setPromoData", res.data.data.plans);
			}
		},
		async downloadFree() {
			try {
				await this.download(true, this.saveGraphical);
				this.openGraphBuy = false;
			} catch (error) {
				console.log(error);
			}
		},
		addWaterMark(element, isFreeDownload) {
			const img = document.createElement("img");
			img.setAttribute(
				"src",
				this.selectedTemplate["resumeData"]["centerImage"]
			);
			img.setAttribute("alt", "");
			img.style.position = "absolute";
			if (!isFreeDownload) {
				img.style.height = "200px";
				img.style.width = "200px";
			} else {
				img.style.top = "35%";
				img.style.left = "20%";
			}
			element.appendChild(img);
		},
		getReffCount(refCount) {
			this.totalReferalCount = refCount;
		},
		setCandidateInfoBack(myData) {
			this.localCandidateInfo = myData;
		},
		chkIfExpChanged() {
			if (this.pinkFilled.includes(true)) {
				this.noScroll = false;
				this.isAllMandTabsFilled();
			}
		},
		handlePageChange(newPage) {
			this.currentFullPdfUrlModal = this.currentFullPdfUrlsModal[newPage - 1];
			const ATSPreview = document.getElementById("ATSPreview"); // Note: 'ATSPreview' should be a string
			if (ATSPreview) {
				ATSPreview.scrollTo({
					top: 0,
					behavior: "auto",
				});
			}
		},
		async setCandidateProgress() {
			try {
				let payload = {
					audience: [
						{
							userID: getProcessedToken(),
							message: "Saved profile",
							event: {
								eventID: "savedFirstProfile",
								eventName: "Saved First profile",
							},
						},
					],
					project: "candidate",
					by_userID: getProcessedToken(),
				};
				const res = await postNotifications(payload);
				if (res.status == 200) {
					let notify = await getNotifications();
					if (notify.status == 200) {
						if (notify.data.data.data.length !== 0) {
							this.$store.commit(
								"candidateVUEX/updatetogglecreateNewProfile",
								!notify.data.data.data[0].read
							);
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		},
		setInitialAtsLocalCandidateInfo() {
			this.initialAtsLocalCandidateInfo = {};
			for (let key of Object.keys(this.localCandidateInfo)) {
				if (this.upToDateKeys.includes(key)) {
					this.initialAtsLocalCandidateInfo[key] = this.localCandidateInfo[key];
				}
			}
		},
		setInitialLocalCandidateInfo() {
			this.initialLocalCandidateInfo = {};
			for (let key of Object.keys(this.localCandidateInfo)) {
				if (this.upToDateKeys.includes(key)) {
					this.initialLocalCandidateInfo[key] = this.localCandidateInfo[key];
				}
			}
		},
		async updateBeforeDownload() {
			this.updateResumeLoading = true;
			await this.getAllTemplates(false);
			this.updateResumeLoading = false;
			this.$bvModal.hide("updateresume");
			this.setInitialLocalCandidateInfo();
		},
		async checkAndDownloadAts() {
			await getUserCreditsData(this);
			this.downloadType = "ats";
			this.checkDownloadCondition
				? (this.showModalValues(), (this.isDownloading = false))
				: this.saveDownloadResumeAtsPreview(false);
		},
		async checkAndDownload(save = false) {
			this.$v.resumeName.$touch();
			if (
				!this.localCandidateInfo.profileName &&
				(this.$v.resumeName.$invalid || this.resumeName.length > 20)
			) {
				return;
			}
			this.saveGraphical = save;
			await getUserCreditsData(this);
			this.downloadType = "graphical";
			if (save) {
				this.saveResume(false, false, true);
			}
			this.checkDownloadCondition
				? (this.showModalValues(), (this.isDownloading = false))
				: this.download(false, save);
		},
		handleAfterPayment(data) {
			if (data.type == "Success") {
				this.hidePayment();
				this.successModal("Success", "Payment successful.");
				addUserCreditValue(this, data.data.data.paymentInfo.orderID);
			}
			// else{
			//   // this.hidePayment();
			//   this.errorModal(
			//           "Error",
			//           "Payment failed! Please try again."
			//         );
			// }
		},
		hidePayment() {
			this.showPayment = false;
		},
		showPaymentModal() {
			this.payementClicked = true;
			checkCustomer(this, this.userEmail);
		},
		async getAllProfiles() {
			this.allProfiles = (await getAllProfiles()).data.data.map((profile) => {
				return {
					profileName: profile.profileName,
					_id: profile._id,
					primary: profile.primary,
				};
			});
			// this.initKickstartState();
		},

		async renameResume() {
			if (this.resumeNameNew.trim() === "") {
				return;
			}

			this.isRenaming = true;

			try {
				const res = await renameResume({
					_id: this.localCandidateInfo._id,
					profileName: this.resumeNameNew,
				});

				if (res.status === 200) {
					this.successModal(
						"Successfully renamed.",
						"Resume has been renamed."
					);
					this.getCandidateDetailTabs();
				} else if (res.status === 409) {
					this.isRenaming = false;
					return this.errorModal("Error", "Resume with same name exists!");
				} else {
					this.errorModal("Error", "Something went wrong!");
				}
			} catch (error) {
				this.errorModal("Error", "Something went wrong!");
			}
			this.$bvModal.hide("renameresume");
			this.isRenaming = false;
		},

		async handleRadioChange() {
			this.isSettingPrimary = true;
			if (!this.localCandidateInfo.primary) {
				let payload = { id: this.localCandidateInfo._id };
				const response = await setPrimaryProfile(payload);
				if (response.status === 200) {
					await this.getCandidateDetailTabs();
					this.getAllProfiles();

					const res = await getCandidatePrimaryProfile();
					if (res.status === 200) {
						this.$store.commit(
							"candidateVUEX/setPrimaryProfile",
							res.data.data
						);
					}
					const respData = await getProfileCompletion(
						this.localCandidateInfo._id
					);
					const candProgressPrimaryResp = respData.data.data;
					this.$store.commit(
						"candidateVUEX/updateCandidateProgressPrimary",
						candProgressPrimaryResp
					);

					this.$bvModal.hide("setprimary");
					this.$emit("update-isPrimary");
				}
			}
			this.isSettingPrimary = false;
		},

		selectTemplate(templateData) {
			const templateCopy = { ...this.selectedTemplate };
			this.selectedTemplate = { ...templateData };
			this.callScripts(templateCopy);
			this.callScripts(this.selectedTemplate);
		},

		updateMainDashHeight() {
			this.mainDashHeight =
				document.getElementById("maindash") &&
				document.getElementById("maindash").offsetHeight;
			// Update ainDashHeight when the component is mounted or when window is resized
		},
		handleResize() {
			// Update windowHeight when window is resized
			this.updateMainDashHeight();
			this.windowHeight = window.innerHeight;
		},
		getHTMLFile(
			rawHTML = false,
			isWaterMarkNeeded = 0,
			isFreeDownload = false
		) {
			let scriptContent = document.createElement("script");
			let converterContent = document.createElement("script");
			for (let i = 0; i < this.selectedTemplate?.rows?.length; i++) {
				const curRow = this.selectedTemplate.rows[i];
				for (let j = 0; j < this.selectedTemplate.rowData[curRow].length; j++) {
					if (this.selectedTemplate.rowData[curRow][j].script) {
						scriptContent.innerHTML +=
							this.selectedTemplate.rowData[curRow][j].script;
						if (
							this.selectedTemplate.rowData[curRow][j].converterCalls &&
							this.selectedTemplate.rowData[curRow][j].content != "basicInfo"
						)
							converterContent.innerHTML +=
								this.selectedTemplate.rowData[curRow][j].converterCalls;
					}
				}
			}
			for (let col of this.selectedTemplate.columnData) {
				if (col.script && col.content !== "basicInfo") {
					scriptContent.innerHTML += col.script;
					converterContent.innerHTML += col.converterCalls;
				}
			}
			console.log("the selcted ");
			const graphDiv = document.getElementById("graph-resume");
			const element = graphDiv.cloneNode(true);
			if (isWaterMarkNeeded === 1) {
				this.addWaterMark(element, isFreeDownload);
			}
			var img = document.createElement("img");
			img.setAttribute(
				"src",
				this.selectedTemplate["resumeData"]["bottomImage"]
			);
			img.setAttribute("alt", "");
			img.style.position = "absolute";
			if (isFreeDownload) {
				img.style.right = "7px";
				img.style.bottom = "10px";
			} else {
				img.style.right = "0px";
				img.style.bottom = "0px";
				img.style.height = "4px";
				img.style.width = "30px";
			}
			element.appendChild(img);
			let html = document.createElement("html");
			html.innerHTML = `<head>
                    <style>
                    @media print {
                        #graph-resume {
                            margin: 0;
                            padding: 0;
                            box-shadow: 0;
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                        }
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format('woff2');
                    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
                    }
                    /* cyrillic */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format('woff2');
                    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
                    }
                    /* greek-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format('woff2');
                    unicode-range: U+1F00-1FFF;
                    }
                    /* greek */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format('woff2');
                    unicode-range: U+0370-03FF;
                    }
                    /* vietnamese */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format('woff2');
                    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
                    }
                    /* latin-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format('woff2');
                    unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
                    }
                    /* latin */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format('woff2');
                    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                    }
                    /* cyrillic-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format('woff2');
                    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
                    }
                    /* cyrillic */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format('woff2');
                    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
                    }
                    /* greek-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format('woff2');
                    unicode-range: U+1F00-1FFF;
                    }
                    /* greek */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format('woff2');
                    unicode-range: U+0370-03FF;
                    }
                    /* vietnamese */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format('woff2');
                    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
                    }
                    /* latin-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format('woff2');
                    unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
                    }


                    /* latin */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format('woff2');
                    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                    }
                        .d-flex{
                            display: flex;
                        }
                        .w-100{
                            width: 100%;
                        }
                        .a4{
                            width: 21cm;
                            height: 29.7cm;
                            overflow: hidden;
                            background: white;
                            display: block;
                            margin: 0 auto;
                            margin-bottom: 0.5cm;
                            box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
                            position: relative;
                        }
                    </style>
                </head>
                <body>
                    ${element.innerHTML}
                    <script>
                    ${scriptContent.innerHTML}
                    ${converterContent.innerHTML}
                    <\/script>
                </body>`;

			if (isFreeDownload) {
				let body = html.getElementsByTagName("body");
				body = body[0];
				body.style.position = "relative";
			}
			let update = html.querySelector("#update-btn");

			if (update) {
				update.remove();
			}

			let pageContent = `<html>${html.innerHTML}</html>`;
			if (rawHTML) {
				let update = element.querySelector("#update-btn");

				if (update) {
					update.remove();
				}
				let expand = element.querySelector("#expand-resume");
				if (expand) {
					expand.remove();
				}
				let expand2 = element.querySelector("#expand-resume-column");
				if (expand2) {
					expand2.remove();
				}
				return ` ${element.innerHTML}`;
			} else {
				console.log(pageContent);
				return new Blob([pageContent], {
					type: "text/html",
				});
			}
		},
		async download(isFreeDownload = false, save = false) {
			this.downloadType = null;
			this.startDownload = false;
			this.isDownloading = true;
			try {
				// if (
				//   this.localCandidateInfo.graphicalResume.templateID !==
				//   this.selectedTemplate["template_id"]
				// ) {
				const blob = isFreeDownload
					? this.getHTMLFile(false, 1, true)
					: this.getHTMLFile();

				const formData = new FormData();
				formData.append("html_file", blob, "resume.html");

				formData.append(
					"uploadPath",
					this.localCandidateInfo.uploadPath + "/downloads/"
				);
				formData.append("type", "recruitment");
				formData.append("outputPath", this.localCandidateInfo.profileName);

				const res = await downloadGraphicalResume(formData);
				if (res.status == 200) {
					let payload = {
						id: this.localCandidateInfo._id,
						templateID: this.selectedTemplate.template_id,
						code: null,
						key: res.data.data.path,
						type: this.creditData.type,
					};
					await this.logDownload(payload);
					if (res.data && res.data.data && res.data.data.link) {
						const link = document.createElement("a");
						link.href = res.data.data.link;
						link.setAttribute(
							"download",
							`${this.localCandidateInfo.profileName || "Resume"}.pdf`
						);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}
					this.isDownloading = false;
					this.openGraphBuy = false;
				} else {
					this.errorModal("Error", "Something went wrong !");
					this.isDownloading = false;
				}
			} catch (error) {
				this.errorModal("Error", "Something went wrong !");
				this.isDownloading = false;
			}
		},
		async saveResume(downloadBool = false, update = false, first = false) {
			this.$v.resumeName.$touch();
			if (
				!this.localCandidateInfo.profileName &&
				(this.$v.resumeName.$invalid || this.resumeName.length > 20)
			) {
				return;
			}

			if (update) {
				this.updateResumeLoading = true;
			} else if (!downloadBool && !first) {
				this.saveResumeLoading = true;
			} else {
				this.saveAndDownloadResumeLoading = true;
			}

			if (!this.localCandidateInfo.upToDate) {
				await this.getAllTemplates(false);
			}

			const id = this.candidateInfoState._id;
			let payload = {};

			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1;
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = "0" + dd;
			}
			if (mm < 10) {
				mm = "0" + mm;
			}
			today = dd + "-" + mm + "-" + yyyy;

			this.selectedTemplate["resumeData"]["date"] = today;
			if (this.saveAs) {
				this.$v.resumeName.$touch();
				if (this.$v.resumeName.$invalid) {
					this.resumeErrorMessage = "Required";
					this.saveResumeLoading = false;
					this.saveAndDownloadResumeLoading = false;
					return;
				}
				let data = {
					profileName: this.resumeName,
					clone: true,
					cloneID: this.localCandidateInfo._id,
					graphical: JSON.stringify(this.selectedTemplate["resumeData"]),
					html_file: this.getHTMLFile(),
				};

				payload = new FormData();
				for (let key in data) {
					payload.append(key, data[key]);
				}
			} else {
				let data = {
					_id: id,
					profileName: this.localCandidateInfo.profileName || this.resumeName,
					graphical: JSON.stringify(this.selectedTemplate["resumeData"]),
					html_file: this.getHTMLFile(),
					saveHTML: true,
				};

				payload = new FormData();
				for (let key in data) {
					payload.append(key, data[key]);
				}
			}

			try {
				const response = await saveResume(payload);
				if (response.status === 200 || response.status === 201) {
					this.loading = false;
					if (update) {
						this.successModal(
							"Successfully updated.",
							"Resume has been updated."
						);
						this.$bvModal.hide("updateresume");
					} else {
						this.successModal("Successfully saved", "Resume has been saved");
						this.$bvModal.hide("saveresume1");
						if (response.data.data._id)
							this.setProfileId(response.data.data._id);
					}
				} else if (response.status === 409) {
					this.ifProfileNameExist = true;
					this.resumeErrorMessage = response.data.data.Detail;
					this.saveResumeLoading = false;
					this.saveAndDownloadResumeLoading = false;
					return;
				} else {
					this.loading = false;
					this.errorModal("Error", "Something went wrong");
					this.$bvModal.hide("saveresume1");
					this.$bvModal.hide("updateresume");
				}
			} catch (error) {
				this.loading = false;
				this.errorModal("Error", "Something went wrong");
			}

			await this.getCommonFuncForProfile();

			if (downloadBool) {
				await getUserCreditsData(this);
				if (this.checkDownloadCondition) {
					this.downloadType = "graphical";
					this.showModalValues();
					this.isDownloading = false;
				}
				// else {
				//   this.download();
				// }
			}
			this.resumeName = "";
			this.$v.resumeName.$reset();
			this.saveAs = false;
			this.firstDownload = false;
			this.saveResumeLoading = false;
			this.saveAndDownloadResumeLoading = false;
			this.updateResumeLoading = false;
		},
		async logDownload(payload) {
			try {
				const response = await logDownload(payload);
				if (response.status === 200) {
					this.loading = false;
					trackResumeDownloaded("graphical")
					this.successModal(
						"Successfully downloaded",
						"Resume has been downloaded"
					);
					await getUserCreditsData(this);
				} else {
					this.loading = false;
					this.errorModal("Error", "Something went wrong");
				}
			} catch (error) {
				this.loading = false;
				console.log(error);
				this.errorModal("Error", "Something went wrong");
			}
		},

		async checkDownloadForm() {
			if (
				(((this.localCandidateInfo.experienceLevel == "student" ||
					this.localCandidateInfo.experienceLevel == "fresher") &&
					this.candidateProgress < 45) ||
					(this.localCandidateInfo.experienceLevel == "intermediate" &&
						this.candidateProgress < 70) ||
					(this.localCandidateInfo.experienceLevel == "senior" &&
						this.candidateProgress < 70)) &&
				Object.keys(this.candidateInfoState.atsResume).length == 0 &&
				!this.previewAts
			) {
				this.$bvModal.show("createATS");
			} else if (Object.keys(this.candidateInfoState.atsResume).length == 0) {
				this.$refs.resumeDiv.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
				this.previewAts = true;
				this.previewGraphical = false;
				this.templateResumecount = 0;
			} else if (Object.keys(this.candidateInfoState.atsResume).length != 0) {
				if (!this.atsPreviewViewUpdate) {
					await getUserCreditsData(this);
					if (this.checkDownloadCondition) {
						this.downloadType = "atsheader";
						if (this.selectedindex == -1) {
							this.selectedindex = 0;
						}
						this.showModalValues(true, true);
					} else {
						this.downloadingModal(
							"Downloading resume...",
							"Downloading resume.."
						);
						this.downloadAtsFromHeader();
					}
				} else {
					this.$refs.resumeDiv.scrollIntoView({
						behavior: "smooth",
						block: "start",
					});
					this.previewAts = true;
					this.previewGraphical = false;
					this.templateResumecount = 0;
				}
			}
		},
		async downloadAtsFromHeader() {
			this.downloadType = null;
			this.startDownload = false;
			try {
				let payload = {
					template: this.localCandidateInfo.atsResume.templateID,
					id: this.localCandidateInfo._id,
				};
				const res = await AtsResume(payload);

				if (res.status === 200) {
					let blob = new Blob([res.data], {
						type: "text/html",
					});
					const formData = new FormData();
					formData.append("html_file", blob);
					formData.append("type", "recruitment");
					formData.append("outputPath", this.localCandidateInfo.profileName);
					formData.append(
						"uploadPath",
						this.localCandidateInfo.uploadPath + "/downloads/ATS/"
					);
					formData.append("ats", true);

					const res2 = await downloadGraphicalResume(formData);
					if (res2.status === 200) {
						let payload2 = {
							code: `${res.data}`,
							id: this.localCandidateInfo._id,
							key: res2.data.data.path,
							templateID: this.candidateInfoState.atsResume.templateID,
							type: this.creditData.type,
						};
						const res3 = await logDownload(payload2);
						getUserCreditsData(this);
						if (res3.status === 200) {
							if (res2.data && res2.data.data && res2.data.data.link) {
								const link = document.createElement("a");
								link.href = res2.data.data.link;
								link.setAttribute(
									"download",
									`${this.localCandidateInfo.profileName || "Resume"}.pdf`
								);
								document.body.appendChild(link);
								link.click();
								document.body.removeChild(link);
								trackResumeDownloaded("ats")
							}
							this.successModal(
								"Successfully Downloaded",
								"The Resume has been downloaded"
							);
						}
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		checkTabPresent(formIDToCheck) {
			return this.passDynamicScale.find(
				(item) => item.formID === formIDToCheck
			);
		},
		checkTabsIndexPresent(formIDToCheck) {
			return this.passDynamicScale.findIndex(
				(item) => item.formID === formIDToCheck
			);
		},
		isTabEmpty(formID) {
			if (Object.keys(this.checkDynamicField).length > 0) {
				return checkTabEmpty(
					formID,
					this.localCandidateInfo,
					this.checkDynamicField
				);
			}
		},

		checkMandetoryTabsFilledInterSkill(formID, minLength) {
			if (formID == "skills") {
				return (
					this.localCandidateInfo.interpersonalSkills &&
					this.ifOriginalDataPresentCount(
						this.localCandidateInfo.interpersonalSkills
					).count >= minLength
				);
			}
		},

		async checkMandatoryFields(primary = false) {
			const personalDetailsFilled = this.checkPersonalDetailsMandatoryFilled(
				this.localCandidateInfo
			);
			if (!personalDetailsFilled) {
				if (primary) this.$bvModal.show("fillmandatory");
				return false;
			} else {
				if (primary) this.setPrimary = true;
				return true;
			}
		},
		async isAllMandTabsFilled() {
			this.checkAllPinkBox = true;
			await this.checkOverallMandetoryTabsFilled(
				false,
				this.passDynamicScale,
				this.checkDynamicField,
				this.localCandidateInfo
			);
			if (this.allFilledTabs) {
				console.log("allFilledTabs", this.allFilledTabs);
				this.isAnyEmptyMandetoryField = false;
				// this.previewGraphical = false;
				this.graphicalScroll();
			} else {
				this.isAnyEmptyMandetoryField = true;
			}
		},

		//For Progress Bar Popup
		checkOverallProgressGraphical() {
			if (
				this.checkDynamicField &&
				Object.keys(this.checkDynamicField).length > 0
			) {
				const { passDynamicScale, checkDynamicField } = this;
				let pinkFilledTemp = [];
				pinkFilledTemp = new Array(passDynamicScale.length).fill(false);
				let resultsArray = null;
				for (let i = 0; i < passDynamicScale.length - 1; i++) {
					const { formID } = passDynamicScale[i];

					if (formID != "demographics") {
						let minimum;
						switch (formID) {
							case "education":
							case "experience":

							case "project":
							case "achievement":
								minimum =
									checkDynamicField[formID]?.minimum != null
										? checkDynamicField[formID]?.minimum
										: 0;
								break;
							case "portfolio":
								minimum =
									checkDynamicField?.hobbies?.minimum != null
										? checkDynamicField?.hobbies?.minimum
										: 0;
								break;
							case "skills":
								minimum =
									checkDynamicField?.skills?.minimum != null
										? checkDynamicField?.skills?.minimum
										: 0;

								break;
							default:
								break;
						}
						if (formID == "skills") {
							const interpersonalSkillsMinimum =
								checkDynamicField?.interpersonalSkills?.minimum != null
									? checkDynamicField?.interpersonalSkills?.minimum
									: 0;
							const hobbyMin =
								checkDynamicField?.hobbies?.minimum != null
									? checkDynamicField?.hobbies?.minimum
									: 0;
							const onlySkill = this.checkMandetoryTabsFilled(
								formID,
								minimum,
								false,
								this.localCandidateInfo
							);
							const onlyInterSkill = this.checkMandetoryTabsFilledInterSkill(
								formID,
								interpersonalSkillsMinimum,
								false,
								this.localCandidateInfo
							);
							const onlyHobby = this.checkMandetoryTabsFilled(
								"hobbies",
								hobbyMin,
								false,
								this.localCandidateInfo
							);
							if (
								onlySkill == true &&
								onlyInterSkill == true &&
								onlyHobby === true
							) {
								resultsArray = true;
							} else {
								resultsArray = false;
							}
						} else {
							resultsArray = this.checkMandetoryTabsFilled(
								formID,
								minimum,
								false,
								this.localCandidateInfo
							);
						}
						pinkFilledTemp[i] = !resultsArray;
					}
				}
				let myArr = this.passDynamicScale.map((d, i) => {
					const { clone, progress, visibility, ...newData } = d;
					newData.filled = !pinkFilledTemp[i];
					newData.isMandetory =
						checkDynamicField[newData.formID] != null
							? checkDynamicField[newData.formID].isMandatory
							: null;
					return newData;
				});
				let targetObject = myArr.find((obj) => obj.formID === "portfolio");
				if (
					checkDynamicField["hobbies"] &&
					checkDynamicField["hobbies"].isMandatory &&
					targetObject
				) {
					targetObject.isMandetory = true;
					targetObject.formName = "Portfolio";
				}
				EventBus.$emit("passFilledInfo", myArr);
				// return myArr;
			}
		},

		async checkOverallMandetoryTabsFilledAts(val) {
			this.$bvModal.hide("fillmandatory");
			this.checkAllPinkBox = val;
			await this.checkOverallMandetoryTabsFilled(
				false,
				this.passDynamicScale,
				this.checkDynamicField,
				this.localCandidateInfo,
				val
			);
			if (this.allFilledTabs) {
				this.isAnyEmptyMandetoryField = false;
			} else {
				this.isAnyEmptyMandetoryField = true;
			}
		},
		displayDateOfBirth(dateString) {
			if (dateString) {
				const months = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				];

				const date = new Date(dateString);

				if (isNaN(date.getTime())) {
					// Invalid date
					return null;
				}

				const day = date.getDate(); // Get the day of the month (1-31)
				const monthName = months[date.getMonth()]; // Get the month name (0-11)
				const year = date.getFullYear(); // Get the year

				return `${monthName} ${day}, ${year}`;
			}
			return null;
		},
		ifParserDataPresent(datas) {
			return datas.some((obj) => obj.hasOwnProperty("parser"));
		},
		ifOriginalDataPresent(datas) {
			return ifOriginalDataPresent(datas);
		},

		ifOriginalDataPresentCount(datas) {
			return ifOriginalDataPresentCount(datas);
		},
		isArrayNotEmpty(arr) {
			return Array.isArray(arr) && arr.length > 0;
		},
		ifParserCertiPresent(datas) {
			return datas.some(
				(obj) =>
					obj.hasOwnProperty("parser") && obj.achievetype == "certificate"
			);
		},
		stopWatchingCandidateInfo() {
			// Unwatch the candidateInfoWatcher
			if (this.candidateInfoWatcher) {
				this.candidateInfoWatcher();
				this.candidateInfoWatcher = null; // Reset the watcher variable
			}
		},
		areKeysFilled(obj, keys) {
			return keys.every((key) => obj[key] !== null && obj[key] !== "");
		},
		finishProfileCreation(id) {
			this.isCreatingNewProfile = true;
			this.setProfileId(id);
		},
		handleCreateNewProfile() {
			this.showCreateNewMProfileModal = true;
			this.isCreatingNewProfile = false;
			this.showAllProfileModal = false;
		},
		async openFillFormModal() {
			if (!this.isLaptop) {
				const query = {
					formID: "personalDetails",
				};

				if (this.$route.query.type === "resumeClinic") {
					query.type = "resumeClinic";
				}
				this.showUploadResumeModal = false;

				this.$router.push({
					name: "MobileForm",
					query,
				});
			} else {
				this.openPersonalDetailsModal("add");
				this.$forceUpdate();
				this.$bvModal.hide("draganddrop");
			}
		},
		openPersonalDetailsModal(type) {
			if (
				this.localCandidateInfo.profileName == null &&
				this.$route.query.fromWebsite
			) {
				this.saveparserprofile = true;
			} else {
				this.modalType = type;
				this.selectedForm = this.passDynamicScale[0];
				this.selectedForm = {
					formID: "personalDetails",
				};
				this.showBasicModalFullNew = true;
			}
		},
		chkFilledDetails(myCandInfo) {
			// Do not trigger dashboard-level modals if the global onboarding flow is already active.
			// This prevents the "double modal" stacking issue on refresh.
			if (this.isOnboardingActive) {
				return;
			}

			const propertiesToCheck = [
				"firstName",
				"lastName",
				"email",
				"dateOfBirth",
				"phoneNumber",
				"city",
				// "totalYearsOfExp",
				// "nationality",
				// "languages",
				"profileSummary",
				"experienceLevel",
				"industry",
				"database_demographics",
			];

			if (
				propertiesToCheck.some((property) => {
					return !myCandInfo[property];
				})
			) {
				if (
					(this.$route.query?.uuid ||
						this.$route.query?.type == "resumeClinic" ||
						this.$route.query?.openResumeClinic === "true" ||
						this.$route.query?.openResumeClinic === true ||
						this.$route.query?.downloadReport === "true" ||
						this.$route.query?.downloadReport === true) &&
					myCandInfo.hasOwnProperty("parser")
				) {
					return;
				}
				if (
					myCandInfo.hasOwnProperty("parser") &&
					myCandInfo._id != null &&
					this.$route.query.fromWebsite
				) {
					this.oldProfile = true;
					this.showUploadResumeModal = false;
				} else if (
					myCandInfo.hasOwnProperty("parser") &&
					myCandInfo._id != null &&
					this.$router?.query?.type !== "resumeClinic"
				) {
					console.log(
						myCandInfo,
						"meeeeeeeeeeeeeeeeeeeeeeeeee",
						this.$router.query?.type
					);
					this.oldProfile = true;
					this.openFillFormModal();
				} else if (
					myCandInfo._id != null &&
					!myCandInfo.database_demographics &&
					myCandInfo.hasOwnProperty("parser")
				) {
					this.oldProfile = true;
					this.openFillFormModal();
				} else if (myCandInfo._id === null) {
					this.oldProfile = true;
					this.showUploadResumeModal = false;
				} else {
					this.oldProfile = false;
					if (this.isCreatingNewProfile) {
						this.showUploadResumeModal = true;
						this.isCreatingNewProfile = false;
					}
				}
			}
			this.stopWatchingCandidateInfo();
			//  else if (myCandInfo.hasOwnProperty("parser")) {
			//   this.cometoProfile();
			// }
		},
		// async getScrollResume() {
		// 	this.noScroll = false;
		// 	await this.isAllMandTabsFilled();
		// 	this.isAnyEmptyMandetoryField
		// 		? (this.setInitialLocalCandidateInfo(),
		// 		  (this.selectedTemplate = {}),
		// 		  this.getAllTemplates(),
		// 		  this.getAllProfiles())
		// 		: this.showToast();
		// },

		async showTheDynamicTabs() {
			try {
				this.showTaskBarShimmer = true;
				this.isTemplateLoaded = false;
				// this.selectedTemplate = {};
				if (Object.keys(this.localCandidateInfo.atsResume).length) {
					this.preventScrollOnWatcher = true;
					this.previewAts = true;
				}
				this.selectedResumeToDownload = null;
				// this.templateResume = [];
				this.showTaskBarShimmer = false;
			} catch (e) {
				console.log(e);
			} finally {
				this.isTemplateLoaded = true;
			}
		},
		async setProfileId(pId) {
			this.drag3 = false;
			this.drag1 = false;
			this.drag2 = false;
			this.showTaskBar = true;
			this.$bvModal.hide("draganddrop");
			this.showBasicModalFullNew = false;
			this.showPortfolioModalNew = false;
			this.showEducationModal = false;
			this.showExperienceModal = false;
			this.showProjectModalNew = false;
			this.showSkillsModalNew = false;
			this.showAchieveModalNew = false;
			this.showBasicModalFullNewok = false;
			this.selectedResumeToDownload = null;

			this.selectedTab = "education";
			this.showAboutMe = true;

			this.showDashboard = true;

			this.noScroll = false;
			this.isSettingTab = false;

			this.createVideo = false;
			this.previewVideo = false;
			this.sysCheck = false;
			this.previewAts = false;
			this.previewGraphical = false;
			this.localCandidateInfo._id = pId;
			this.progressPercentage = 0;
			this.$store.commit(
				"candidateVUEX/setCandidateInfo",
				this.localCandidateInfo
			);

			await this.getCandidateDetailTabs();
			if (Object.keys(this.localCandidateInfo.atsResume).length) {
				this.preventScrollOnWatcher = true;
				this.previewAts = true;
			} else {
				this.previewAts = false;
			}

			//For removing the pink filled data
			this.pinkFilled = [];
			this.selectedTabOnCrud = null;
			this.finalIndexToCheckPinkFill = null;
			this.candidateInfoWatcher = this.$watch(
				"localCandidateInfo",
				this.chkFilledDetails
			);
			const element = document.getElementById("belowdash");
			element.scrollTo({
				top: 0,
				behavior: "smooth",
			});

			this.getCandidateDetailCand();
			this.$refs["belowdash"].scrollTo(0, 0);
			await this.getCommonFuncForProfile(false);
			//videoresume
			this.previewVideo = false;
			this.createVideo = false;
			this.stopVideoStream();
			this.setInitialAtsLocalCandidateInfo();
		},

		async getDynamicMandetoryFieldsFilled(index) {
			if (Object.keys(this.checkDynamicField).length > 0) {
				let isMandetoryFilled = null;
				if (index > 0) {
					this.pinkFilled = new Array(this.passDynamicScale.length).fill(false);
					for (let i = 0; i < index; i++) {
						if (this.passDynamicScale[i].formID == "portfolio") {
							if (
								this.checkDynamicField.hobbies &&
								this.checkDynamicField.hobbies.isMandatory
							) {
								this.pinkFilled[i] = !this.checkMandetoryTabsFilled(
									this.checkDynamicField.portfolio.formID,
									this.checkDynamicField.hobbies.minimum,
									false,
									this.localCandidateInfo
								);
							}
						} else if (this.passDynamicScale[i].formID == "skills") {
							if (
								this.checkDynamicField.skills &&
								this.checkDynamicField.hobbies &&
								this.checkDynamicField.interpersonalSkills &&
								(this.checkDynamicField.skills.isMandatory ||
									this.checkDynamicField.interpersonalSkills.isMandatory)
							) {
								const interpersonalSkillsMinimum =
									this.checkDynamicField.interpersonalSkills.minimum;
								const onlySkill = this.checkMandetoryTabsFilled(
									this.checkDynamicField.skills.formID,
									this.checkDynamicField.skills.minimum,
									false,
									this.localCandidateInfo
								);
								const onlyInterSkill = this.checkMandetoryTabsFilledInterSkill(
									this.checkDynamicField.skills.formID,
									interpersonalSkillsMinimum
								);

								const onlyHobbies = this.checkMandetoryTabsFilled(
									this.checkDynamicField.hobbies.formID,
									this.checkDynamicField.hobbies.minimum,
									false,
									this.localCandidateInfo
								);

								if (
									onlySkill == true &&
									onlyInterSkill == true &&
									onlyHobbies == true
								) {
									this.pinkFilled[i] = false;
								} else {
									this.pinkFilled[i] = true;
								}
								// this.pinkFilled[i] = !this.checkMandetoryTabsFilled(
								//   this.checkDynamicField.skills.formID,
								//   this.checkDynamicField.skills.minimum +
								//     this.checkDynamicField.interpersonalSkills.minimum
								// );
							}
						} else if (this.passDynamicScale[i].formID == "personalDetails") {
							this.pinkFilled[i] = !this.localCandidateInfo.dateOfBirth;
						} else if (
							this.passDynamicScale[i].formID != "demographics" &&
							this.passDynamicScale[i].formID != "portfolio" &&
							this.passDynamicScale[i].formID != "skills"
						) {
							const checkFilledTab = this.passDynamicScale[i].formID;
							const eachTab = this.checkDynamicField[checkFilledTab];
							if (eachTab && eachTab.isMandatory && eachTab.minimum != null) {
								isMandetoryFilled = this.checkMandetoryTabsFilled(
									eachTab.formID,
									eachTab.minimum,
									false,
									this.localCandidateInfo
								);

								this.pinkFilled[i] = !isMandetoryFilled;
							}
						}
					}
				}
			}
		},

		graphicalScroll() {
			const sectionRefs = {
				education: "educationSection",
				experience: "experinceSection",
				project: "projectSection",
				skills: "skillSection",
				achievement: "achievementSection",
				portfolio: "portfolioSection",
				demographics: "portfolioSection",
				resume: "resumeDiv",
			};
			const indexOfTrue = this.pinkFilled.findIndex((value) => value === true);
			if (indexOfTrue >= 0 && indexOfTrue < Object.keys(sectionRefs).length) {
				const sectionRef = Object.values(sectionRefs)[indexOfTrue];
				const sectionElement = this.$refs[sectionRef];
				// this.pinkFilled[indexOfTrue] = false;
				if (sectionElement) {
					sectionElement[0].scrollIntoView({
						behavior: "smooth",
						block: "center",
					});
					setTimeout(() => {
						sectionElement[0].style.scrollBehavior = "auto";
					}, 100);
				}
			}
		},
		async onDragEndProj(event) {
			let ids = this.localCandidateInfo.projects;
			const itemToMove = ids.splice(event.newIndex, 1)[0];
			ids.splice(event.newIndex, 0, itemToMove);
			let finalIds = {};
			ids.forEach((item, index) => {
				finalIds[item.priorityID] = String(index + 1);
			});

			const filteredKeys = Object.keys(finalIds).filter(
				(key) => finalIds[key] !== undefined
			);
			if (filteredKeys.includes("undefined")) {
				const indexToRemove = filteredKeys.indexOf("undefined");
				filteredKeys.splice(indexToRemove, 1);
			}
			// Create a new object without the keys with undefined values
			const filteredIds = filteredKeys.reduce((obj, key) => {
				obj[key] = finalIds[key];
				return obj;
			}, {});

			try {
				let payload = {
					email: this.localCandidateInfo.email,
					ids: filteredIds,
					id: this.getcandidateInfo._id,
				};
				const resp = await patchProjectsInfo(payload);
				if (resp.status == 200) {
					this.getCommonFuncForProfile();
				} else {
					this.errorModal("Error", "Something went wrong !");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async onDragEndSkill(event) {
			this.commonDragFunc(event, this.localCandidateInfo.skills);
		},
		async onDragEndInterSkill(event) {
			let ids = this.localCandidateInfo.interpersonalSkills;
			const itemToMove = ids.splice(event.newIndex, 1)[0];
			ids.splice(event.newIndex, 0, itemToMove);
			let finalIds = {};
			ids.forEach((item, index) => {
				finalIds[item.priorityID] = String(index + 1);
			});

			const filteredKeys = Object.keys(finalIds).filter(
				(key) => finalIds[key] !== undefined
			);
			if (filteredKeys.includes("undefined")) {
				const indexToRemove = filteredKeys.indexOf("undefined");
				filteredKeys.splice(indexToRemove, 1);
			}
			// Create a new object without the keys with undefined values
			const filteredIds = filteredKeys.reduce((obj, key) => {
				obj[key] = finalIds[key];
				return obj;
			}, {});

			try {
				let payload = {
					email: this.localCandidateInfo.email,
					ids: filteredIds,
					id: this.getcandidateInfo._id,
				};
				const resp = await patchCandInterSkills(payload);
				if (resp.status == 200) {
					this.getCommonFuncForProfile();
				} else {
					this.errorModal("Error", "Something went wrong !");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async commonDragFunc(event, tagInfo) {
			let ids = tagInfo;
			const itemToMove = ids.splice(event.newIndex, 1)[0];
			ids.splice(event.newIndex, 0, itemToMove);
			let finalIds = {};
			ids.forEach((item, index) => {
				finalIds[item.priorityID] = String(index + 1);
			});

			const filteredKeys = Object.keys(finalIds).filter(
				(key) => finalIds[key] !== undefined
			);
			if (filteredKeys.includes("undefined")) {
				const indexToRemove = filteredKeys.indexOf("undefined");
				filteredKeys.splice(indexToRemove, 1);
			}
			// Create a new object without the keys with undefined values
			const filteredIds = filteredKeys.reduce((obj, key) => {
				obj[key] = finalIds[key];
				return obj;
			}, {});

			try {
				let payload = {
					email: this.localCandidateInfo.email,
					ids: filteredIds,
					id: this.getcandidateInfo._id,
				};
				const resp = await patchCandSkills(payload);
				if (resp.status == 200) {
					// this.successModal(
					//   "Successfully swapped",
					//   "Skills details has been swapped successfully"
					// );
					this.getCommonFuncForProfile();
				} else {
					this.errorModal("Error", "Something went wrong !");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async onDragEndAchieveEvent(event) {
			let ids = this.localCandidateInfo.events;
			const itemToMove = ids.splice(event.newIndex, 1)[0];
			ids.splice(event.newIndex, 0, itemToMove);
			let finalIds = {};
			ids.forEach((item, index) => {
				finalIds[item.priorityID] = String(index + 1);
			});

			const filteredKeys = Object.keys(finalIds).filter(
				(key) => finalIds[key] !== undefined
			);
			if (filteredKeys.includes("undefined")) {
				const indexToRemove = filteredKeys.indexOf("undefined");
				filteredKeys.splice(indexToRemove, 1);
			}
			// Create a new object without the keys with undefined values
			const filteredIds = filteredKeys.reduce((obj, key) => {
				obj[key] = finalIds[key];
				return obj;
			}, {});

			try {
				let payload = {
					email: this.localCandidateInfo.email,
					ids: filteredIds,
					id: this.getcandidateInfo._id,
				};
				const resp = await patchCandEvent(payload);
				if (resp.status == 200) {
					this.getCommonFuncForProfile();
				} else {
					this.errorModal("Error", "Something went wrong !");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async onDragEndAchieveAward(event) {
			let ids = this.localCandidateInfo.awards;
			const itemToMove = ids.splice(event.newIndex, 1)[0];
			ids.splice(event.newIndex, 0, itemToMove);
			let finalIds = {};
			ids.forEach((item, index) => {
				finalIds[item.priorityID] = String(index + 1);
			});

			const filteredKeys = Object.keys(finalIds).filter(
				(key) => finalIds[key] !== undefined
			);
			if (filteredKeys.includes("undefined")) {
				const indexToRemove = filteredKeys.indexOf("undefined");
				filteredKeys.splice(indexToRemove, 1);
			}
			// Create a new object without the keys with undefined values
			const filteredIds = filteredKeys.reduce((obj, key) => {
				obj[key] = finalIds[key];
				return obj;
			}, {});

			try {
				let payload = {
					email: this.localCandidateInfo.email,
					ids: filteredIds,
					id: this.getcandidateInfo._id,
				};
				const resp = await patchCandAward(payload);
				if (resp.status == 200) {
					this.getCommonFuncForProfile();
				} else {
					this.errorModal("Error", "Something went wrong !");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async onDragEndAchieveCerti(event) {
			let ids = this.localCandidateInfo.achievement;
			const itemToMove = ids.splice(event.newIndex, 1)[0];
			ids.splice(event.newIndex, 0, itemToMove);
			let finalIds = {};
			ids.forEach((item, index) => {
				finalIds[item.priorityID] = String(index + 1);
			});

			const filteredKeys = Object.keys(finalIds).filter(
				(key) => finalIds[key] !== undefined
			);
			if (filteredKeys.includes("undefined")) {
				const indexToRemove = filteredKeys.indexOf("undefined");
				filteredKeys.splice(indexToRemove, 1);
			}
			// Create a new object without the keys with undefined values
			const filteredIds = filteredKeys.reduce((obj, key) => {
				obj[key] = finalIds[key];
				return obj;
			}, {});

			try {
				let payload = {
					email: this.localCandidateInfo.email,
					ids: filteredIds,
					id: this.getcandidateInfo._id,
				};
				const resp = await patchCandAchieve(payload);
				if (resp.status == 200) {
					this.getCommonFuncForProfile();
				} else {
					this.errorModal("Error", "Something went wrong !");
				}
			} catch (error) {
				console.log(error);
			}
		},
		onDragEndPortfolio(event) {
			this.commonDragFuncPortfolio(event, this.localCandidateInfo.portfolio);
		},
		async commonDragFuncPortfolio(event, tagInfo) {
			let ids = tagInfo;
			const itemToMove = ids.splice(event.newIndex, 1)[0];
			ids.splice(event.newIndex, 0, itemToMove);
			let finalIds = {};
			ids.forEach((item, index) => {
				finalIds[item.priorityID] = String(index + 1);
			});

			const filteredKeys = Object.keys(finalIds).filter(
				(key) => finalIds[key] !== undefined
			);
			if (filteredKeys.includes("undefined")) {
				const indexToRemove = filteredKeys.indexOf("undefined");
				filteredKeys.splice(indexToRemove, 1);
			}
			// Create a new object without the keys with undefined values
			const filteredIds = filteredKeys.reduce((obj, key) => {
				obj[key] = finalIds[key];
				return obj;
			}, {});

			try {
				let payload = {
					email: this.localCandidateInfo.email,
					ids: filteredIds,
					id: this.getcandidateInfo._id,
				};
				const resp = await patchPortfolio(payload);
				if (resp.status == 200) {
					this.getCommonFuncForProfile();
				} else {
					this.errorModal("Error", "Something went wrong !");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async onDragEndHoby(event) {
			let ids = this.localCandidateInfo.hobbies;
			const itemToMove = ids.splice(event.newIndex, 1)[0];
			ids.splice(event.newIndex, 0, itemToMove);
			try {
				let payLoadHobbie = {
					email: this.localCandidateInfo.email,
					hobbies: ids,
					id: this.getcandidateInfo._id,
				};

				const resp = await postCandInfo(payLoadHobbie);
				if (resp.status == 200) {
					this.getCommonFuncForProfile();
				} else {
					this.errorModal("Error", "Something went wrong !");
				}
			} catch (error) {
				console.log(error);
			}
		},
		dataAddedFunc(addNew) {
			if (addNew) {
				this.selectedData = {};
				this.formType = "add";
			}
			this.selectedParserTab = "award";
			this.getCommonFuncForProfile();

			this.scrollToFirstSection();
		},
		async getCommonFuncForProfile(callFunc = true) {
			this.selectedData = {};
			if (callFunc) {
				await this.getCandidateDetailTabs();
			} else {
				for (
					let i = 0;
					i < this.localCandidateInfo.educationalInfo.length;
					i++
				) {
					if (!this.localCandidateInfo.educationalInfo[i].degree) {
						this.localCandidateInfo.educationalInfo[i].degree = "";
					}
				}
			}
			if (
				this.pinkFilled.some((value) => {
					return value === true;
				})
			) {
				this.previewGraphical = false;
				// this.previewAts = false;
			}
			this.selectedCard = null;

			this.checkEducationalValue();
			this.experienceValue();
			this.checkSkillValue();
			this.checkProjectValue();
			this.checkAchievmentValue();
			this.checkPortFolioValue();
			this.profileCompletion();
			this.checkOverallProgressGraphical();
			EventBus.$emit("helpSectionUpdate");
			const maxInd = this.checkTabsIndexPresent(this.selectedTabOnCrud);
			if (this.finalIndexToCheckPinkFill < maxInd) {
				this.finalIndexToCheckPinkFill = maxInd;
			}
			if (this.finalIndexToCheckPinkFill > 0) {
				this.getDynamicMandetoryFieldsFilled(this.finalIndexToCheckPinkFill);
			}
			this.primaryProfileUpd();
			this.closeAllShimmers();
		},
		async closeAllShimmers() {
			this.showShimmerBasicModal = false;
			this.showShimmerEduModal = false;
			this.showShimmerExpModal = false;
			this.showShimmerSkillModal = false;
			this.showShimmerProjectModal = false;
			this.showShimmerAchieveModal = false;
			this.showShimmerPortModal = false;
		},
		async profileCompletion() {
			try {
				const response = await getProfileCompletion();
				this.candidateProgress = response.data.data.progress;
				const candProgressResp = response.data.data;
				const togglecreateNewProfile = response.data.data.createNewProfile;
				if (
					this.localCandidateInfo.primary &&
					!this.localCandidateInfo.atsResume.templateID &&
					this.candidateProgress >= 40 &&
					!this.resumeUpdated
				) {
					this.resumeUpdated = true;
					await this.renderTempResume();
				}
				this.$store.commit(
					"candidateVUEX/updateCandidateProgress",
					candProgressResp
				);

				if (this.localCandidateInfo.primary) {
					console.log(this.localCandidateInfo.primary, "checkkkk prrimary");

					this.$store.commit(
						"candidateVUEX/updateCandidateProgressPrimary",
						candProgressResp
					);
				}

				this.localCandidateInfo.achievement.sort((a, b) => {
					const typeA = (a.achieveType || "").toUpperCase(); // Guard against null or undefined
					const typeB = (b.achieveType || "").toUpperCase();

					if (typeA < typeB) {
						return -1;
					}
					if (typeA > typeB) {
						return 1;
					}
					return 0;
				});
				// await getCandidateDetail(this);
			} catch (error) {
				console.log(error);
			}
		},

		async updateIsPrimary() {
			this.resumeUpdated = false;
			await this.getCandidateDetailCand();
			await this.profileCompletion();
		},
		async renderTempResume() {
			window.pdfjsLib.GlobalWorkerOptions.workerSrc =
				"https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";

			const templateID =
				this.localCandidateInfo.atsResume.templateID || "template1";
			const fileName = `${this.localCandidateInfo._id}_${templateID}`;

			const resume = await getResumeTemp(
				templateID,
				this.localCandidateInfo._id
			);

			this.atsResume = {
				resumeData: resume.data,
				resumeDataUrls: [],
				resumeLink: null,
			};
			const blob = new Blob([this.atsResume.resumeData], {
				type: "text/html",
			});
			const formData = new FormData();
			formData.append("htmlFile", blob);
			formData.append("returnType", "pdf");
			formData.append(
				"outputPath",
				`${this.localCandidateInfo._id}_${templateID}`
			);
			formData.append("outputPath", fileName);
			const pdf = await converterAtsPreview(formData);
			await this.tempResumePath(
				this.localCandidateInfo.email,
				fileName,
				pdf.data
			);
		},
		async tempResumePath(email, fileName, blobFile) {
			const fileWithName = new File([blobFile], fileName, {
				type: "application/pdf",
			});

			const formData = new FormData();
			formData.append("email", email);
			formData.append("fileName", fileName);
			formData.append("pdfFile", fileWithName);

			try {
				const response = await tempResume(formData);
				if (response.status === 200) {
					console.log("Resume uploaded");
				} else {
					console.error("Unexpected response:", response);
				}
			} catch (error) {
				console.error("Error uploading resume:", error);
			}
		},
		async getCandidateDetailTabs() {
			this.localCandidateInfo = await getCandidateDetail(this);
			this.$store.commit(
				"candidateVUEX/setCandidateInfo",
				this.localCandidateInfo
			);
			for (let i = 0; i < this.localCandidateInfo.educationalInfo.length; i++) {
				if (!this.localCandidateInfo.educationalInfo[i].degree) {
					this.localCandidateInfo.educationalInfo[i].degree = "";
				}
			}
			if (this.checkMandatoryFields() == false) {
				this.previewGraphical = false;
			}
			this.scrollToFirstSection();
		},
		experienceValue() {
			if (
				this.localCandidateInfo.experience &&
				this.localCandidateInfo.experience.length < 1
			) {
				this.openexperience = false;
			} else {
				this.openexperience = true;
			}
		},
		checkEducationalValue() {
			if (
				this.localCandidateInfo.educationalInfo &&
				this.localCandidateInfo.educationalInfo.length < 1
			) {
				this.openeducation = false;
			} else {
				this.openeducation = true;
			}
		},
		checkSkillValue() {
			if (
				(this.localCandidateInfo.skills &&
					this.localCandidateInfo.skills.length > 0) ||
				(this.localCandidateInfo.interpersonalSkills &&
					this.localCandidateInfo.interpersonalSkills.length > 0) ||
				(this.localCandidateInfo.hobbies &&
					this.localCandidateInfo.hobbies.length > 0)
			) {
				this.openskill = true;
			} else {
				this.openskill = false;
			}
		},
		checkProjectValue() {
			if (
				this.localCandidateInfo.projects &&
				this.localCandidateInfo.projects.length < 1
			) {
				this.openproject = false;
			} else {
				this.openproject = true;
			}
		},
		checkAchievmentValue() {
			if (
				(this.localCandidateInfo.awards &&
					this.localCandidateInfo.awards.length > 0) ||
				(this.localCandidateInfo.achievement &&
					this.localCandidateInfo.achievement.length > 0) ||
				(this.localCandidateInfo.events &&
					this.localCandidateInfo.events.length > 0)
			) {
				this.openachiev = true;
			} else {
				this.openachiev = false;
			}
		},
		checkPortFolioValue() {
			if (
				(this.localCandidateInfo.portfolio &&
					this.localCandidateInfo.portfolio.length > 0) ||
				(this.localCandidateInfo.hobbies &&
					this.localCandidateInfo.hobbies.length > 0) ||
				(this.localCandidateInfo.parserHobbies &&
					this.localCandidateInfo.parserHobbies.length > 0)
			) {
				this.openPortfolio = true;
			} else {
				this.openPortfolio = false;
			}
		},
		clearDeleteData() {
			this.deleteContent = {
				name: null,
				funcName: null,
				id: null,
				callback: null,
			};
			this.myDeleteContent = {
				data: {},
				fullData: [],
				callback: null,
			};
			this.showDeleteModal = false;
			// this.$bvModal.hide("deleteModal");
		},

		async updateData(data) {
			this.showUploadResumeModal = false;
			if (data.formID == "personalDetails") {
				// this.showloader = true;
				this.tmpExpLevel = null;
				await this.getCandidateDetailCand();
				this.showloader = false;
				this.getCommonFuncForProfile();

				const newQuery = { ...this.$route.query };

				if (
					newQuery.openResumeClinic === "true" ||
					newQuery.openResumeClinic === true ||
					newQuery.downloadReport === "true" ||
					newQuery.downloadReport === true
				) {
					// Add type=resumeClinic to the URL so watchers don't override the UI
					this.$router.replace({
						path: this.$route.path,
						query: newQuery,
					});

					// Trigger the Resume Clinic Component to mount
					this.showresumeclinic = true;
					setTimeout(() => {
						const query = { ...this.$route.query };
						delete query.openResumeClinic;
						delete query.downloadReport;
						this.$router
							.replace({ path: this.$route.path, query })
							.catch(() => {});
					}, 1000);
				} else if (this.$route.query.fromWebsite) {
					this.showresumeclinic = true;
					this.$router.replace({
						path: this.$route.path,
						query: newQuery,
					});
				}
			}
		},
		// async updateDataCand() {
		// 	this.chkPinkFill = true;

		// 	try {
		// 		const response = await getProfileCompletion();
		// 		EventBus.$emit("helpSectionUpdate");
		// 	} catch (error) {
		// 		console.log(error);
		// 	}
		// },
		setTab(tab, index) {
			this.selectedTab = tab;
			this.checkAllPinkBox = true;
			const sectionRef = document.getElementById(tab);

			if (sectionRef) {
				// Smoothly scroll to the section
				setTimeout(() => {
					sectionRef.scrollIntoView({
						behavior: "smooth",
						block: "start",
					});
				}, 100);
			}

			// Ensure tabs are opened
			if (!this.opentabs) {
				this.opentabs = true;
			}

			// Update the final index to check for the pink fill
			if (index > this.finalIndexToCheckPinkFill) {
				this.finalIndexToCheckPinkFill = index;
			}

			// Perform different actions based on the selected tab
			if (this.selectedTab !== "resume") {
				this.getDynamicMandetoryFieldsFilled(this.finalIndexToCheckPinkFill);
			} else {
				this.noScroll = true;
				this.isAllMandTabsFilled();
			}
		},
		async getScrollResume() {
			this.noScroll = false;
			await this.isAllMandTabsFilled();
			if (!this.localCandidateInfo.database_demographics) {
				this.showAtserror();
			} else {
				!this.isAnyEmptyMandetoryField
					? (this.setInitialLocalCandidateInfo(),
					  (this.selectedTemplate = {}),
					  this.getAllTemplates(),
					  this.getAllProfiles())
					: this.showToast();
			}
		},
		closeModal(data, isImageChanged) {
			this[data] = false;
			if (isImageChanged) {
				// this.$emit("update-data");
				this.getCandidateDetailCand();
				this.getCommonFuncForProfile();
			}
			this.chkPinkFill = false;
		},

		closeFormModal() {
			this.showForm = false;
			this.selectedData = {};
			this.formType = "";
			this.selectedAchieveTab = null;
			this.selectedParserTab = "award";
		},

		openModal(showModal, modalType, data, dataFull) {
			if (this.isLaptop) {
				if (data) {
					if (
						(showModal == "showExperienceModal" ||
							showModal == "showProjectModalNew") &&
						(modalType == "edit" || modalType == "addParser")
					) {
						if (data.startDate && !data.startDate.endsWith("T00:00:00.000Z")) {
							data.startDate += "T00:00:00.000Z";
						}
						if (data.endDate && !data.endDate.endsWith("T00:00:00.000Z")) {
							data.endDate += "T00:00:00.000Z";
						}
					} else if (
						showModal == "showAchieveModalNew" &&
						(modalType == "edit" ||
							modalType == "addParser" ||
							modalType == "editEvent")
					) {
						if (data.issueDate && !data.issueDate.endsWith("T00:00:00.000Z")) {
							data.issueDate += "T00:00:00.000Z";
						}
						if (
							data.expirationDate &&
							!data.expirationDate.endsWith("T00:00:00.000Z")
						) {
							data.expirationDate += "T00:00:00.000Z";
						}
					}
					this.editData = { ...data };
					this.editFullData = { ...dataFull };
					if (showModal === "showSkillsModalNew") {
						this.allAddedData = data;
					}
				}
				this[showModal] = true;
				this.modalType = modalType;
			} else {
				const query = {
					formID: this.selectedForm.formID,
				};

				if (this.$route.query.type == "resumeClinic") {
					query.type = "resumeClinic";
				}
				this.$router.push({
					name: "MobileForm",
					query,
				});
			}
		},
		assignDeleteData(data) {
			if (this.candidateInfo._id == null) {
				this.saveparserprofile = true;
			} else if (
				this.localCandidateInfo.profileName == null &&
				this.$route.query.fromWebsite
			) {
				this.saveparserprofile = true;
			} else {
				this.deleteContent = data.content;
				this.selectedForm = data.form;
				this.showDeleteModal = true;
				// this.$bvModal.show("deleteModal");
			}
		},

		async updatePortfolio() {
			this.checkValue = "save";
			const isSaved = await updatePortfolio(this);
			if (isSaved == true) {
				this.clearDeleteData();
				this.delCheck = true;
				this.getCommonFuncForProfile();
				this.$bvModal.hide("deleteModal");
			}
		},
		updateSkill() {
			this.addedSkillButton = false;
			this.addedSkillButton2 = false;
			updateSkill(this);
			this.clearDeleteData();
			this.delCheck = true;
			this.getCommonFuncForProfile();
		},

		async renderAtsCovers() {
			for (let i in this.templateCovers) {
				const scale = 1.0;
				const viewport = this.templateCovers[i].getViewport({ scale });
				const canvas = document.getElementById(i + "pdfCanvas");
				const context = canvas.getContext("2d");
				canvas.style.width = "100%";
				canvas.style.height = "100%";
				const canvasWidth = viewport.width;
				canvas.width = canvasWidth;
				const scaleFactor = canvasWidth / viewport.width;
				const canvasHeight = viewport.height * scaleFactor;
				canvas.height = canvasHeight;
				await this.templateCovers[i].render({
					canvasContext: context,
					viewport: viewport,
				}).promise;
			}
		},

		async getAllAtsTemplates(isFromHeader = false) {
			if (Object.keys(this.getcandidateInfo.atsResume).length !== 0) {
				this.selectedAtsResume = this.getcandidateInfo.atsResume.templateID;
				console.log("the selected ats resume", this.selectedAtsResume);
			}
			const templates = ["template1", "template2", "template3", "template4"];

			this.selectedResumeToDownload = null;
			this.templateResume = [];
			this.templateCovers = [];
			this.currentFullPdfUrls = [];

			window.pdfjsLib.GlobalWorkerOptions.workerSrc =
				"https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";

			const getTemplates = templates.map(async (template, i) => {
				const resume = await getResumeTemp(template);

				this.templateResume[i] = {
					resumeData: resume.data,
					resumeDataUrls: [],
					resumeLink: null,
				};
			});

			await Promise.all(getTemplates);

			this.$forceUpdate();

			const promises = this.templateResume.map(async (template, i) => {
				const blob = new Blob([template.resumeData], {
					type: "text/html",
				});
				const formData = new FormData();
				formData.append("htmlFile", blob);
				formData.append("returnType", "pdf");
				formData.append(
					"outputPath",
					`${this.candidateInfoState._id}_template${i + 1}`
				);
				formData.append("ats", true);
				const pdf = await converterAtsPreview(formData);

				const url = URL.createObjectURL(pdf.data);
				const loadingTask = window.pdfjsLib.getDocument({
					url,
				});
				const pdfDocument = await loadingTask.promise;
				const numPages = pdfDocument._pdfInfo.numPages;

				return this.renderAtsPdf(
					i,
					pdfDocument,
					numPages,
					url,
					false,
					isFromHeader
				);
			});

			await Promise.all(promises);

			let index = 0;
			if (Object.keys(this.getcandidateInfo.atsResume).length > 0) {
				index = templates.indexOf(this.getcandidateInfo.atsResume.templateID);
				if (index == -1) index = 0;
			} else {
				index = 0;
			}
			this.selectResumeprev(this.templateResume[index], index);
			return Promise.resolve();
		},

		async renderAtsPdf(
			templateIndex,
			pdfDocument,
			numPages,
			link,
			isForModal = false,
			isFromHeader = false
		) {
			console.log(
				"the templateResume is ",
				this.templateResume,
				link,
				templateIndex
			);
			if (this.templateResume[templateIndex]?.resumeLink === link) {
				console.log(
					`PDF for templateIndex ${templateIndex} has already been processed. Skipping.`
				);
				return Promise.resolve();
			}
			console.log(
				`Processing PDF for templateIndex: ${templateIndex}, numPages: ${numPages}, link: ${link}`
			);

			for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
				console.log(
					`Processing page ${pageNumber} of templateIndex ${templateIndex}`
				);
			}

			for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
				if (this.templateResume[templateIndex]?.resumeDataUrls.length > 1) {
					this.checkAtsLength = true;
				} else {
					this.checkAtsLength = false;
				}

				const page = await pdfDocument.getPage(pageNumber);

				if (pageNumber === 1) {
					const scale = 1.0;
					const viewport = page.getViewport({ scale });
					let id = null;
					if (isForModal) {
						id = "free-pdfCanvas";
					} else {
						id = templateIndex + "pdfCanvas";
					}
					if (!isFromHeader) {
						const canvas = document.getElementById(id);
						const context = canvas.getContext("2d");
						canvas.style.width = "100%";
						canvas.style.height = "100%";
						const canvasWidth = viewport.width;
						canvas.width = canvasWidth;
						const scaleFactor = canvasWidth / viewport.width;
						const canvasHeight = viewport.height * scaleFactor;
						canvas.height = canvasHeight;
						await page.render({
							canvasContext: context,
							viewport: viewport,
						}).promise;
					}
					// const imageDataUrl = canvas.toDataURL("image/png");
					// this.templateResume[templateIndex].resume;
					if (!isForModal) {
						this.templateCovers.push(page);
						this.templateResume[templateIndex].resumeLink = link;
					} else if (isForModal) {
						this.waterMarkedATS.resumeLink = link;
					}
				}

				const scale = 3.0;
				const viewport = page.getViewport({ scale });
				const canvas = document.createElement("canvas");
				const context = canvas.getContext("2d");
				canvas.style.width = "450px";
				canvas.style.height = "580px";
				const canvasWidth = viewport.width;
				canvas.width = canvasWidth;
				const scaleFactor = canvasWidth / viewport.width;
				const canvasHeight = viewport.height * scaleFactor;
				canvas.height = canvasHeight;
				await page.render({
					canvasContext: context,
					viewport: viewport,
				}).promise;
				const imageDataUrl = canvas.toDataURL("image/png");
				if (isForModal) {
					this.waterMarkedATS.resumeDataUrls.push(imageDataUrl);
				} else {
					this.templateResume[templateIndex].resumeDataUrls.push(imageDataUrl);
					this.currentFullPdfUrlsModal.push(imageDataUrl);
				}
			}

			return Promise.resolve();
		},

		selectPreviousPage() {
			this.selectedindexResume =
				this.selectedindexResume - 2 === 1
					? this.selectedindexResume - 1
					: this.selectedindexResume - 2;
			this.currentPageAts = this.selectedindexResume;
			if (this.currentFullPdfUrls.length - this.selectedindexResume < 2) {
				this.checkAtsLength = false;
			} else {
				this.checkAtsLength = true;
			}
			this.currentFullPdfUrl =
				this.currentFullPdfUrls[this.selectedindexResume];
		},
		selectNextPage() {
			this.selectedindexResume = this.selectedindexResume + 2;
			this.currentPageAts = this.selectedindexResume;
			if (this.currentFullPdfUrls.length - this.selectedindexResume < 2) {
				this.checkAtsLength = false;
			} else {
				this.checkAtsLength = true;
			}

			this.currentFullPdfUrl =
				this.currentFullPdfUrls[this.selectedindexResume];
		},
		selectResumeprev(data, index) {
			this.selectedAtsResumeOnClick = `template${index + 1}`;
			this.selectedResumeToDownload = data.resumeLink;
			this.currentFullPdfUrls = data.resumeDataUrls;
			this.currentFullPdfUrlsModal = data.resumeDataUrls;
			this.currentPageAts = 0;
			if (data.resumeDataUrls.length > 1) {
				this.checkAtsLength = true;
			} else {
				this.checkAtsLength = false;
			}
			this.currentFullPdfUrl = data.resumeDataUrls[0];
			this.currentFullPdfUrlModal = data.resumeDataUrls[0];

			this.selectedindex = index;
			this.selectedindexResume = 0;
			if (this.currentFullPdfUrls.length < 2) {
				this.checkAtsLength = false;
			} else {
				this.checkAtsLength = true;
			}
		},
		async downloadAtsPreview() {
			if (!this.getcandidateInfo.profileName) {
				this.$bvModal.show("saveresumeAtsPreview");
				this.saveAtsResumeLoading = false;
			} else {
				await getUserCreditsData(this);
				if (this.checkDownloadCondition) {
					this.downloadType = "ats";
					this.showModalValues(true);
					this.saveAtsResumeLoading = false;
				} else {
					this.saveDownloadResumeAtsPreview(false);
					this.saveAtsResumeLoading = true;
				}
			}
		},
		getDate() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1;
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = "0" + dd;
			}
			if (mm < 10) {
				mm = "0" + mm;
			}
			today = dd + "-" + mm + "-" + yyyy;
			return today;
		},
		async updateAtsPreview() {
			this.currentFullPdfUrls = [];
			this.isUpdatingAtsResume = true;
			(this.templateResumecount = 0),
				(this.templateResume = []),
				(this.selectedResumeToDownload = null);
			let candidateResponse = await getCandInfo();
			this.selectedAtsResume = candidateResponse.data.data.atsResume.templateID;
			this.$store.commit(
				"candidateVUEX/setCandidateInfo",
				candidateResponse.data.data
			);
			this.setInitialAtsLocalCandidateInfo();
			await this.getAllAtsTemplates();
			this.$bvModal.hide("updateresumeAtsPreview");
			this.isUpdatingAtsResume = false;
			if (
				this.localCandidateInfo.primary &&
				!this.localCandidateInfo.atsResume.templateID &&
				this.candidateProgress >= 40
			) {
				await this.renderTempResume();
			}
		},
		async saveResumeAtsPreviewfunc(noSave) {
			this.saveAtsResumeLoading = true;
			if (noSave) {
				this.$v.resumeName.$touch();
				if (this.$v.resumeName.$invalid) {
					this.saveAtsResumeLoading = false;
					return;
				}
			}
			let payload = {
				_id: this.getcandidateInfo._id,
				profileName: noSave
					? this.resumeName
					: this.getcandidateInfo.profileName,
				atsResume: {
					templateID: `template${this.selectedindex + 1}`,
					date: this.getDate(),
				},
			};
			await postAllProfiles(payload);
			let candidateResponse = await getCandInfo();
			this.selectedAtsResume = candidateResponse.data.data.atsResume.templateID;
			//this.localCandidateInfo = candidateResponse.data.data;
			this.$store.commit(
				"candidateVUEX/setCandidateInfo",
				candidateResponse.data.data
			);
			this.profileCompletion();
			this.successModal("Successfully saved", "Resume has been saved");
			this.$bvModal.hide("saveresumeAtsPreview");
			this.saveAtsResumeLoading = false;
		},
		async saveDownloadResumeAtsPreview(noSave, isForModal = false) {
			if (!isForModal) {
				this.isDownloading = true;
			}
			if (noSave === true) {
				this.$v.resumeName.$touch();
				if (this.$v.resumeName.$invalid) {
					return;
				}
				this.saveAndDownloadResumeLoading = true;
			}
			let payload = {
				_id: this.getcandidateInfo._id,
				profileName: noSave
					? this.resumeName
					: this.getcandidateInfo.profileName || this.resumeName,
				atsResume: {
					templateID: `template${this.selectedindex + 1}`,
					date: this.getDate(),
				},
			};
			await postAllProfiles(payload);

			let blob = new Blob(
				[
					isForModal
						? this.waterMarkedATS.resumeData
						: this.templateResume[this.selectedindex].resumeData,
				],
				{ type: "text/html" }
			);
			const formData = new FormData();
			formData.append("html_file", blob);
			formData.append("type", "recruitment");
			formData.append(
				"outputPath",
				noSave
					? this.resumeName
					: this.getcandidateInfo.profileName || this.resumeName
			);
			formData.append(
				"uploadPath",
				this.getcandidateInfo.uploadPath + "/ATS/downloads/"
			);
			formData.append("ats", true);
			const res2 = await downloadGraphicalResume(formData);
			if (res2.status === 200) {
				let payload2 = {
					code: isForModal
						? this.waterMarkedATS.resumeData
						: this.templateResume[this.selectedindex].resumeData,
					id: this.getcandidateInfo._id,
					key: res2.data.data.path,
					templateID: `template${this.selectedindex + 1}`,
					type: this.creditData.type,
				};
				const res3 = await logDownload(payload2);
				if (res3.status === 200) {
					if (res2.data && res2.data.data && res2.data.data.link) {
						const link = document.createElement("a");
						link.href = res2.data.data.link;
						link.setAttribute(
							"download",
							`${
								this.resumeName || this.getcandidateInfo.profileName || "Resume"
							}.pdf`
						);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						trackResumeDownloaded("ats")
					}
					this.successModal(
						"Successfully Downloaded",
						"The Resume has been downloaded"
					);
				}
				getUserCreditsData(this);
			}
			let candidateResponse = await getCandInfo();
			this.selectedAtsResume = candidateResponse.data.data.atsResume.templateID;
			this.localCandidateInfo = candidateResponse.data.data;
			this.$store.commit(
				"candidateVUEX/setCandidateInfo",
				candidateResponse.data.data
			);
			this.setInitialAtsLocalCandidateInfo();
			this.profileCompletion();
			this.saveAtsResumeLoading = false;
			this.isDownloading = false;
			this.downloadType = null;
			this.startDownload = false;
			this.$bvModal.hide("saveresumeAtsPreview");
			this.saveAndDownloadResumeLoading = false;
		},
		async saveAsNewAtsResume() {
			this.saveAtsResumeLoading = true;
			this.atsPreviewView = false;
			this.$v.resumeName.$touch();
			if (this.$v.resumeName.$invalid) {
				this.saveAtsResumeLoading = false;
				return;
			}
			let payload = {
				profileName: this.resumeName,
				clone: true,
				cloneID: this.getcandidateInfo._id,
				atsResume: this.getcandidateInfo.atsResume,
			};
			let response = await postAllProfiles(payload);
			if (response.status == 201) {
				this.$v.resumeName.$reset();
				this.setProfileId(response.data.data._id);
				let candidateResponse = await getCandInfo();
				this.selectedAtsResume =
					candidateResponse.data.data.atsResume.templateID;
				this.$store.commit(
					"candidateVUEX/setCandidateInfo",
					candidateResponse.data.data
				);
				this.saveAtsResumeLoading = false;
				this.$bvModal.hide("saveresumeAtsPreview");
			} else {
				this.saveAtsResumeLoading = false;
				this.errorModal("Error", `${response.data.data.Detail}`);
			}
		},
		saveasanewresumne() {
			this.saveAsNewAts = true;
			this.$bvModal.show("saveresumeAtsPreview");
		},
		async previewAtsResume() {
			this.templateResume = [];
			this.previewAts = !this.previewAts;
			this.previewGraphical = false;
			// if (this.previewAts) {
			//   await this.resumeTemplate();
			// }
		},
		checkVideoCreateCondition() {
			if (this.totalReferalCount > 4) {
				this.localCandidateInfo.videoResume
					? (this.previewVideo = true)
					: this.goSystemCheck();
			} else {
				this.videoSnapOnClick();
			}
		},
		goSystemCheck() {
			this.$router.push({
				name: "systemcheck",
			});
		},
		videoSnapOnClick() {
			this.previewVideo = true;
			this.previewGraphical = false;
			this.previewAts = false;
			this.$nextTick(() => {
				if (this.$refs.resumeDiv) {
					this.$refs.resumeDiv.scrollIntoView({
						behavior: "smooth",
					});
				} else {
					console.error("Ref 'resumeDiv' is not available.");
				}
			});
		},
		videoSnap(mobile = false) {
			this.$forceUpdate();
			this.$nextTick(() => {
				if (this.$refs.resumeDiv) {
					this.$refs.resumeDiv.scrollIntoView({
						behavior: "smooth",
					});
				} else {
					console.error("Ref 'resumeDiv' is not available.");
				}
			});
			this.stopVideoStream();
			if (this.totalReferalCount > 4) {
				if (this.localCandidateInfo.videoResume) {
					this.previewVideo = true;
				} else {
					this.previewVideo = false;
					this.goSystemCheck();
				}
			} else {
				this.videoSnapOnClick();
			}
			this.previewGraphical = false;
			this.previewAts = false;
			if (mobile) {
				if (this.localCandidateInfo.videoResume) {
					this.$router.push({
						name: "MobilePreviewResume",
						query: { snapshot: true },
					});
				} else {
					this.showMobVideoScreen = true;
				}
			}
		},
		videoSnaps() {
			this.$refs.resumeDiv.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});

			if (this.totalReferalCount > 4) {
				setTimeout(() => {
					this.hideDashboard();
					this.hideAboutMe();
					this.showTaskBar = false;
				}, 400);
			}

			this.videoSnap();
		},
		PreviewResumevideo() {
			this.previewVideo = true;
			this.previewGraphical = false;
			this.previewAts = false;
			document.getElementById("resumeDiv").scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
			this.$store.commit("candidateVUEX/updatePreviewResume", false);
		},
		stopVideoStream() {
			// Check if there's a stream running
			if (window.localVideoStream) {
				const tracks = window.localVideoStream.getTracks();
				tracks.forEach((track) => {
					// Check if track is active
					if (track.readyState === "live") {
						try {
							track.stop(); // Stop the track
						} catch (error) {
							console.error("Error stopping track:", error);
						}
					}
				});
				window.localVideoStream = null; // Clear the stream object
			} else {
				console.warn("No video stream to stop.");
			}
		},
		async mobileCreateNewProfile(val) {
			if (val) await this.getAllProfiles();
			this.mobCreateNewProfile = val;
		},
		formatMonthName(inputDate) {
			return formatMonthName(inputDate);
		},
		openFormModal(form, viewAll) {
			console.log(this.candidateInfo);

			if (this.candidateInfo._id == null) {
				this.saveparserprofile = true;
			} else if (
				this.localCandidateInfo.profileName == null &&
				this.$route.query.fromWebsite
			) {
				this.saveparserprofile = true;
			} else {
				this.selectedForm = form;
				if (this.isLaptop) {
					this.showForm = true;
				} else {
					let queryParams = {
						formID: this.selectedForm.formID,
						check: this.$route.query.check,
					};

					// Only add 'openaddnew' if viewAll is false
					if (!viewAll) {
						queryParams.openaddnew = "opnenew";
					}
					if (this.$route.query.type === "resumeClinic") {
						queryParams.type = "resumeClinic";
					}
					this.$router.push({
						name: "MobileForm",
						query: queryParams,
					});
				}
			}
		},
		openSkillModal(form) {
			// this.selectedForm = form;
			// if (this.isLaptop) {
			// 	this.showSkillModal = true;
			// } else {
			// 	this.$router.push({
			// 		name: "MobileForm",
			// 		query: {
			// 			formID: this.selectedForm.formID,
			// 			check: this.$route.query.check,
			// 		},
			// 	});
			// }
			if (this.isLaptop) {
				if (
					this.candidateInfo._id == null &&
					this.$route.query.type != "resumeClinic"
				) {
					this.saveparserprofile = true;
				} else if (
					this.localCandidateInfo.profileName == null &&
					this.$route.query.fromWebsite
				) {
					this.saveparserprofile = true;
				} else {
					this.selectedForm = form;
					this.showSkillModal = true;
				}
			} else {
				if (
					this.candidateInfo._id == null &&
					this.$route.query.type != "resumeClinic"
				) {
					this.saveparserprofile = true;
				} else if (
					this.localCandidateInfo.profileName == null &&
					this.$route.query.fromWebsite
				) {
					this.saveparserprofile = true;
				} else {
					this.selectedForm = form;
					const query = {
						formID: this.selectedForm.formID,
						check: this.$route.query.check,
					};
					if (this.$route.query.type === "resumeClinic") {
						query.type = "resumeClinic";
					}

					this.$router.push({
						name: "MobileForm",
						query,
					});
				}
			}
		},
		goToPersonalDetails() {
			if (this.candidateInfo._id == null) {
				this.saveparserprofile = true;
			} else if (
				this.localCandidateInfo.profileName == null &&
				this.$route.query.fromWebsite
			) {
				this.saveparserprofile = true;
			} else {
				const query = {
					formID: "personalDetails",
					check: this.$route.query.check,
				};

				if (this.$route.query.type === "resumeClinic") {
					query.type = "resumeClinic";
				}

				this.$router.push({
					name: "MobileForm",
					query,
				});
			}
		},
		openForm(data) {
			this.selectedTabOnCrud = data.selectedTabOnCrud;
			this.selectedForm = data.form;

			this.openModal(data.modal, data.modalType, data.data);
		},
		openEditForm(data) {
			console.log(
				data.form.formID,
				"data.form.formIDdata.form.formIDdata.form.formIDdata.form.formIDdata.form.formIDdata.form.formIDdata.form.formID"
			);
			if (this.candidateInfo._id == null) {
				this.saveparserprofile = true;
			} else if (
				this.localCandidateInfo.profileName == null &&
				this.$route.query.fromWebsite
			) {
				this.saveparserprofile = true;
			} else {
				let id = data.id;
				this.selectedForm = data.form;
				if (this.isLaptop) {
					if (data.form.formID == "skills" || data.form.formID == "hobbies") {
						this.showSkillModal = true;
					} else {
						this.showForm = true;
					}
					if (data.form.formID == "hobbies") {
						this.selectedData = data.content;
					} else {
						this.selectedData = { ...data.content };
					}
					data.tab ? (this.selectedAchieveTab = data.tab) : "";
					if (data.content.parser) {
						this.formType = "editParser";
						this.selectedAchieveTab = this.selectedParserTab;
					} else {
						this.formType = "edit";
					}
				} else if (data.tab) {
					const query = {
						id: id,
						formID: data.form.formID,
						type: "edit",
						tab: data.tab,
					};

					if (this.$route.query.type === "resumeClinic") {
						query.type = "resumeClinic";
					}

					this.$router.push({
						name: "MobileForm",
						query,
					});
				} else {
					const query = {
						id: id,
						formID: data.form.formID,
						type: "edit",
					};

					if (this.$route.query.type === "resumeClinic") {
						query.type = "resumeClinic";
					}

					this.$router.push({
						name: "MobileForm",
						query,
					});
				}
			}
		},
		goToPreviewResume() {
			// Check if ATS resume is not created
			const noAtsResume =
				Object.keys(this.getcandidateInfo.atsResume || {}).length == 0;

			if (noAtsResume) {
				// Show the candash-saved-cont container
				this.showNotSavedProfile = true;
			} else {
				// Existing logic for when resume exists
				if (this.localCandidateInfo.database_demographics) {
					this.$router.push({
						name: "MobilePreviewResume",
						query: {
							id: this.localCandidateInfo._id,
						},
					});
				} else {
					this.showAtserror();
				}
			}
		},
		async routeToMobileResume(tabType) {
			// Route to MobilePreviewResume with the appropriate tab selected
			const query = {
				id: this.localCandidateInfo._id,
			};
			if (tabType === "graphical") {
				await this.isAllMandTabsFilled();
				if (!this.localCandidateInfo.database_demographics) {
					this.showAtserror();
					return;
				}
				if (this.isAnyEmptyMandetoryField) {
					this.showToast();
					this.showNotSavedProfile = false;
					this.setInitialLocalCandidateInfo();
					return;
				}
				query.tab = "1";
				this.$router.push({
					name: "MobilePreviewResume",
					query: query,
				});
			} else if (tabType === "ats") {
				await this.checkOverallMandetoryTabsFilledAts(false);
				if (!this.localCandidateInfo.database_demographics) {
					this.showAtserror();
					return;
				}
				// Allow routing if mandatory fields are filled OR ATS resume already exists
				// if (
				// 	this.isAnyEmptyMandetoryField &&
				// 	!(
				// 		Object.keys(this.getcandidateInfo).length > 0 &&
				// 		Object.keys(this.getcandidateInfo.atsResume).length !== 0
				// 	)
				// ) {
				// 	this.checkDownloadForm();
				// 	return;
				// }
				this.showNotSavedProfile = false;
				query.tab = "0";
				this.$router.push({
					name: "MobilePreviewResume",
					query: query,
				});
			} else if (tabType === "video") {
				if (this.localCandidateInfo.videoResume) {
					this.$router.push({
						name: "MobilePreviewResume",
						query: {
							snapshot: true,
							id: this.localCandidateInfo._id,
						},
					});
				} else {
					this.showNotSavedProfile = false;
					this.showMobVideoScreen = true;
				}
			}
		},
		async saveresumeParserprofile() {
			try {
				this.$v.parserProfileinput.$touch();
				if (
					this.$v.parserProfileinput.$invalid ||
					this.parserProfileinput.length > 20
				) {
					return;
				}

				this.buttonLoader = true;
				let payload =
					this.candidateInfoState._id != null
						? {
								profileName: this.parserProfileinput,
								createNew: false,
								clone: [],
								_id: this.candidateInfoState._id,
						  }
						: {
								profileName: this.parserProfileinput,
								createNew: false,
								clone: [],
						  };
				const res = await postAllProfiles(payload);

				// if (res.status === 201) {
				// 	let payload2 = {
				// 		id: res.data.data._id,
				// 		uuid: this.$route.query.uuid,
				// 	};
				// 	const res2 = await syncParser(payload2);
				// 	this.buttonLoader = false;
				// 	this.saveparserprofile = false;

				// 	if (res2.status === 200) {
				// 		store.state.userVUEX.resumeClinic_uuid = null;
				// 		store.state.candidateVUEX.candidateInfo._id = res.data.data._id;
				// 		// let candidateResponse = await getCandInfo();
				// 		// this.$store.commit(
				// 		// 	"candidateVUEX/setCandidateInfo",
				// 		// 	candidateResponse.data.data
				// 		// );
				// 		this.getCommonFuncForProfile();
				// 		const res3 = await getProfileCompletion(
				// 			this.primaryCandidateInfo._id
				// 		);
				// 		console.log(res3.data.data, "the response");

				// 		this.$store.commit(
				// 			"candidateVUEX/updateCandidateProgressPrimary",
				// 			res3.data.data
				// 		);

				// 		this.getCommonFuncForProfile();
				// 		this.$router.replace({
				// 			path: this.$route.path,
				// 			query: {
				// 				...this.$route.query,
				// 				uuid: undefined,
				// 				type: "resumeClinic",
				// 			},
				// 		});
				// 	}
				// } else
				if (res.status === 200) {
					this.buttonLoader = false;
					this.saveparserprofile = false;
					this.getCommonFuncForProfile();
					const res3 = await getProfileCompletion(
						this.primaryCandidateInfo._id
					);
					console.log(res3.data.data, "the profile 200");

					this.$store.commit(
						"candidateVUEX/updateCandidateProgressPrimary",
						res3.data.data
					);

					this.getCommonFuncForProfile();
					this.$router.replace({
						path: this.$route.path,
						query: {
							...this.$route.query,
							fromWebsite: undefined,
							type: "resumeClinic",
						},
					});
				} else if (res.status === 409) {
					this.resumeClinicerror = true;
					this.buttonLoader = false;
				}
			} catch (error) {
				this.buttonLoader = false;
			}
		},
	},
};
</script>

<style scoped>
.preview-none {
	display: none !important;
}
@media (max-width: 1028px) {
	.tabs-dash-sharebox {
		top: -165px;
		width: 100%;
	}
	.mob-z-ind {
		z-index: 4;
		position: relative;
	}
	.mobresume-card {
		height: 80px;
		background: #2e425d;
		border-radius: 0px;
		padding: 15px;
	}
	.mobreviewbtn {
		padding: 3px 7px;
		background: #ffffff;
		border-radius: 4px;
	}
	.mobgood-dial {
		bottom: -2px;
		left: 28px;
		transform: rotate(-6deg);
	}
	.mobamazing-dial {
		left: 32px;
		bottom: -6px;
		transform: rotate(52deg);
	}
	.mob-okaydial {
		bottom: 0px;
		left: 23px;
		transform: rotate(-59deg);
	}
	.mob-fairdial {
		bottom: -4px;
		left: 15px;
		transform: rotate(-97deg);
	}
	.parsermodalcross {
		position: absolute;
		top: 0;
		right: 0;
	}
	.mobflexcol {
		flex-direction: column !important;
	}
	.mobmt20 {
		margin-top: 20px !important;
	}
}
.apply-blur .alw-bluring {
	filter: blur(5px);
	user-select: none;
	pointer-events: none;
}
</style>
